(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp', [
            'ngStorage',
            'tmh.dynamicLocale',
            'pascalprecht.translate',
            'ngResource',
            'ngCookies',
            'ngAria',
            'ngCacheBuster',
            'ngFileUpload',
            'ngFileSaver',
            'ui.bootstrap',
            'ui.bootstrap.datetimepicker',
            'ui.router',
            'infinite-scroll',
            // jhipster-needle-angularjs-add-module JHipster will add new module here
            'angular-loading-bar',
            'ejangular',
            'multipleDatePicker',
            'ui.bootstrap-slider',
            'katex'
        ])
        .run(run);

    run.$inject = ['stateHandler', 'translationHandler'];

    function run(stateHandler, translationHandler) {
        stateHandler.initialize();
        translationHandler.initialize();
    }
})();

(function () {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .factory('User', User);

    User.$inject = ['$resource'];

    function User ($resource) {
        var service = $resource('api/users/:login', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'save': { method:'POST' },
            'update': { method:'PUT' },
            'delete':{ method:'DELETE'}
        });

        return service;
    }
})();

(function() {
    'use strict';
    angular
        .module('moldovaYieldCurvesApp')
        .factory('YieldCurveResultsOpen', YieldCurveResultsOpen);

    YieldCurveResultsOpen.$inject = ['$resource', 'DateUtils'];

    function YieldCurveResultsOpen ($resource, DateUtils) {
        var resourceUrl =  'api/open/yield-curve-results/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.date = DateUtils.convertLocalDateFromServer(data.date);
                    }
                    return data;
                }
            }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('moldovaYieldCurvesApp')
        .factory('YieldCurvePointOpen', YieldCurvePointOpen);

    YieldCurvePointOpen.$inject = ['$resource', 'DateUtils'];

    function YieldCurvePointOpen ($resource, DateUtils) {
        var resourceUrl =  'api/open/yield-curve-points/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.date = DateUtils.convertLocalDateFromServer(data.date);
                    }
                    return data;
                }
            }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('moldovaYieldCurvesApp')
        .factory('ParCurvePointOpen', ParCurvePointOpen);

    ParCurvePointOpen.$inject = ['$resource', 'DateUtils'];

    function ParCurvePointOpen ($resource, DateUtils) {
        var resourceUrl =  'api/open/par-curve-points/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.date = DateUtils.convertLocalDateFromServer(data.date);
                    }
                    return data;
                }
            }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('moldovaYieldCurvesApp')
        .factory('ParCorporateCurvePointOpen', ParCorporateCurvePointOpen);

    ParCorporateCurvePointOpen.$inject = ['$resource', 'DateUtils'];

    function ParCorporateCurvePointOpen ($resource, DateUtils) {
        var resourceUrl =  'api/open/par-corporate-curve-points/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.date = DateUtils.convertLocalDateFromServer(data.date);
                    }
                    return data;
                }
            }
        });
    }
})();

(function () {
    'use strict';
    angular
        .module('moldovaYieldCurvesApp')
        .factory('PaperErrorsCsv', PaperErrorsCsv);

    PaperErrorsCsv.$inject = ['$resource'];

    function PaperErrorsCsv($resource) {
        var resourceUrl = 'api/paper-errors/csv';

        return function (exportType) {
                return $resource(resourceUrl, {}, {
                    'get': {
                        method: 'GET',
                        responseType: "text",
                        transformResponse: function (data, headers) {
                            var response = {};
                            response.data = data;
                            response.headers = headers();
                            return response;
                        }
                    }
                });
        }
    }
})();

(function () {
    'use strict';
    angular
        .module('moldovaYieldCurvesApp')
        .factory('ObservedDataCsv', ObservedDataCsv);

    ObservedDataCsv.$inject = ['$resource'];

    function ObservedDataCsv($resource) {
        var resourceUrl = 'api/observed-data/csv';

        return function (exportType) {
                return $resource(resourceUrl, {}, {
                    'get': {
                        method: 'GET',
                        responseType: "text",
                        transformResponse: function (data, headers) {
                            var response = {};
                            response.data = data;
                            response.headers = headers();
                            return response;
                        }
                    }
                });
        }
    }
})();

(function () {
    'use strict';
    angular
        .module('moldovaYieldCurvesApp')
        .factory('DataExportOpen', DataExportOpen);

    DataExportOpen.$inject = ['$resource'];

    function DataExportOpen($resource) {
        var resourceUrl = 'api/open/download/';

        return function (exportType) {
            if (exportType === 'excel') {
                return $resource(resourceUrl + "excel/", {}, {
                    'query': {
                        method: 'GET',
                        responseType: "arraybuffer",
                        transformResponse: function (data, headers) {
                            var response = {};
                            response.data = data;
                            response.headers = headers();
                            return response;
                        }
                    }
                });
            }
            else if (exportType === 'excel-betas') {
                return $resource(resourceUrl + "excel/betas/", {}, {
                    'query': {
                        method: 'GET',
                        responseType: "arraybuffer",
                        transformResponse: function (data, headers) {
                            var response = {};
                            response.data = data;
                            response.headers = headers();
                            return response;
                        }
                    }
                });
            }
            else if (exportType === 'excel-all') {
                return $resource(resourceUrl + "excel/all/", {}, {
                    'query': {
                        method: 'GET',
                        responseType: "arraybuffer",
                        transformResponse: function (data, headers) {
                            var response = {};
                            response.data = data;
                            response.headers = headers();
                            return response;
                        }
                    }
                });
            }
        }
    }
})();

(function () {
    'use strict';
    angular
        .module('moldovaYieldCurvesApp')
        .factory('CurveLimitsOpen', CurveLimitsOpen);

    CurveLimitsOpen.$inject = ['$resource', 'DateUtils'];

    function CurveLimitsOpen($resource, DateUtils) {
        var resourceUrl = 'api/open/curve-limits/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.validFrom = DateUtils.convertLocalDateFromServer(data.validFrom);
                        data.validTo = DateUtils.convertLocalDateFromServer(data.validTo);
                    }
                    return data;
                }
            }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('moldovaYieldCurvesApp')
        .factory('CorporateCurveResultsOpen', CorporateCurveResultsOpen);

    CorporateCurveResultsOpen.$inject = ['$resource', 'DateUtils'];

    function CorporateCurveResultsOpen ($resource, DateUtils) {
        var resourceUrl =  'api/open/corporate-curve-results/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.date = DateUtils.convertLocalDateFromServer(data.date);
                    }
                    return data;
                }
            }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('moldovaYieldCurvesApp')
        .factory('CorporateCurvePointOpen', CorporateCurvePointOpen);

    CorporateCurvePointOpen.$inject = ['$resource', 'DateUtils'];

    function CorporateCurvePointOpen ($resource, DateUtils) {
        var resourceUrl =  'api/open/corporate-curve-points/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.date = DateUtils.convertLocalDateFromServer(data.date);
                    }
                    return data;
                }
            }
        });
    }
})();

(function () {
    'use strict';
    angular
        .module('moldovaYieldCurvesApp')
        .factory('AppDatesOpen', AppDatesOpen);

    AppDatesOpen.$inject = ['$resource', 'DateUtils'];

    function AppDatesOpen($resource, DateUtils) {
        var resourceUrl = 'api/open/app-dates/';

        return function (dateType) {
            return $resource(resourceUrl + dateType, {}, {
                'query': {method: 'GET', isArray: true}
            });
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .factory('ProfileService', ProfileService);

    ProfileService.$inject = ['$http'];

    function ProfileService($http) {

        var dataPromise;

        var service = {
            getProfileInfo : getProfileInfo
        };

        return service;

        function getProfileInfo() {
            if (angular.isUndefined(dataPromise)) {
                dataPromise = $http.get('api/profile-info').then(function(result) {
                    if (result.data.activeProfiles) {
                        var response = {};
                        response.activeProfiles = result.data.activeProfiles;
                        response.ribbonEnv = result.data.ribbonEnv;
                        response.inProduction = result.data.activeProfiles.indexOf("prod") !== -1;
                        response.swaggerEnabled = result.data.activeProfiles.indexOf("swagger") !== -1;
                        return response;
                    }
                });
            }
            return dataPromise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .directive('pageRibbon', pageRibbon);

    pageRibbon.$inject = ['ProfileService', '$rootScope', '$translate'];

    function pageRibbon(ProfileService, $rootScope, $translate) {
        var directive = {
            replace : true,
            restrict : 'AE',
            template : '<div class="ribbon hidden"><a href="" data-translate="global.ribbon.{{ribbonEnv}}">{{ribbonEnv}}</a></div>',
            link : linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            ProfileService.getProfileInfo().then(function(response) {
                if (response.ribbonEnv) {
                    scope.ribbonEnv = response.ribbonEnv;
                    element.addClass(response.ribbonEnv);
                    element.removeClass('hidden');
                }
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .factory('Register', Register);

    Register.$inject = ['$resource'];

    function Register ($resource) {
        return $resource('api/register', {}, {});
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .factory('Principal', Principal);

    Principal.$inject = ['$q', 'Account'];

    function Principal ($q, Account) {
        var _identity,
            _authenticated = false;

        var service = {
            authenticate: authenticate,
            hasAnyAuthority: hasAnyAuthority,
            hasAuthority: hasAuthority,
            identity: identity,
            isAuthenticated: isAuthenticated,
            isIdentityResolved: isIdentityResolved
        };

        return service;

        function authenticate (identity) {
            _identity = identity;
            _authenticated = identity !== null;
        }

        function hasAnyAuthority (authorities) {
            if (!_authenticated || !_identity || !_identity.authorities) {
                return false;
            }

            for (var i = 0; i < authorities.length; i++) {
                if (_identity.authorities.indexOf(authorities[i]) !== -1) {
                    return true;
                }
            }

            return false;
        }

        function hasAuthority (authority) {
            if (!_authenticated) {
                return $q.when(false);
            }

            return this.identity().then(function(_id) {
                return _id.authorities && _id.authorities.indexOf(authority) !== -1;
            }, function(){
                return false;
            });
        }

        function identity (force) {
            var deferred = $q.defer();

            if (force === true) {
                _identity = undefined;
            }

            // check and see if we have retrieved the identity data from the server.
            // if we have, reuse it by immediately resolving
            if (angular.isDefined(_identity)) {
                deferred.resolve(_identity);

                return deferred.promise;
            }

            // retrieve the identity data from the server, update the identity object, and then resolve.
            Account.get().$promise
                .then(getAccountThen)
                .catch(getAccountCatch);

            return deferred.promise;

            function getAccountThen (account) {
                _identity = account.data;
                _authenticated = true;
                deferred.resolve(_identity);
            }

            function getAccountCatch () {
                _identity = null;
                _authenticated = false;
                deferred.resolve(_identity);
            }
        }

        function isAuthenticated () {
            return _authenticated;
        }

        function isIdentityResolved () {
            return angular.isDefined(_identity);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .factory('PasswordResetInit', PasswordResetInit);

    PasswordResetInit.$inject = ['$resource'];

    function PasswordResetInit($resource) {
        var service = $resource('api/account/reset_password/init', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .factory('PasswordResetFinish', PasswordResetFinish);

    PasswordResetFinish.$inject = ['$resource'];

    function PasswordResetFinish($resource) {
        var service = $resource('api/account/reset_password/finish', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .factory('Password', Password);

    Password.$inject = ['$resource'];

    function Password($resource) {
        var service = $resource('api/account/change_password', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .directive('hasAuthority', hasAuthority);

    hasAuthority.$inject = ['Principal'];

    function hasAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authority = attrs.hasAuthority.replace(/\s+/g, '');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {

                    if (reset) {
                        setVisible();
                    }

                    Principal.hasAuthority(authority)
                        .then(function (result) {
                            if (result) {
                                setVisible();
                            } else {
                                setHidden();
                            }
                        });
                };

            if (authority.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .directive('hasAnyAuthority', hasAnyAuthority);

    hasAnyAuthority.$inject = ['Principal'];

    function hasAnyAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authorities = attrs.hasAnyAuthority.replace(/\s+/g, '').split(',');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {
                    var result;
                    if (reset) {
                        setVisible();
                    }

                    result = Principal.hasAnyAuthority(authorities);
                    if (result) {
                        setVisible();
                    } else {
                        setHidden();
                    }
                };

            if (authorities.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .factory('Auth', Auth);

    Auth.$inject = ['$rootScope', '$state', '$sessionStorage', '$q', '$translate', 'Principal', 'AuthServerProvider', 'Account', 'LoginService', 'Register', 'Activate', 'Password', 'PasswordResetInit', 'PasswordResetFinish'];

    function Auth ($rootScope, $state, $sessionStorage, $q, $translate, Principal, AuthServerProvider, Account, LoginService, Register, Activate, Password, PasswordResetInit, PasswordResetFinish) {
        var service = {
            activateAccount: activateAccount,
            authorize: authorize,
            changePassword: changePassword,
            createAccount: createAccount,
            getPreviousState: getPreviousState,
            login: login,
            logout: logout,
            resetPasswordFinish: resetPasswordFinish,
            resetPasswordInit: resetPasswordInit,
            resetPreviousState: resetPreviousState,
            storePreviousState: storePreviousState,
            updateAccount: updateAccount
        };

        return service;

        function activateAccount (key, callback) {
            var cb = callback || angular.noop;

            return Activate.get(key,
                function (response) {
                    return cb(response);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function authorize (force) {
            var authReturn = Principal.identity(force).then(authThen);

            return authReturn;

            function authThen () {
                var isAuthenticated = Principal.isAuthenticated();

                // an authenticated user can't access to login and register pages
                if (isAuthenticated && $rootScope.toState.parent === 'account' && ($rootScope.toState.name === 'login' || $rootScope.toState.name === 'register')) {
                    $state.go('home');
                }

                // recover and clear previousState after external login redirect (e.g. oauth2)
                if (isAuthenticated && !$rootScope.fromState.name && getPreviousState()) {
                    var previousState = getPreviousState();
                    resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }

                if ($rootScope.toState.data.authorities && $rootScope.toState.data.authorities.length > 0 && !Principal.hasAnyAuthority($rootScope.toState.data.authorities)) {
                    if (isAuthenticated) {
                        // user is signed in but not authorized for desired state
                        $state.go('accessdenied');
                    }
                    else {
                        // user is not authenticated. stow the state they wanted before you
                        // send them to the login service, so you can return them when you're done
                        storePreviousState($rootScope.toState.name, $rootScope.toStateParams);

                        // now, send them to the signin state so they can log in
                        $state.go('accessdenied').then(function() {
                            LoginService.open();
                        });
                    }
                }
            }
        }

        function changePassword (newPassword, callback) {
            var cb = callback || angular.noop;

            return Password.save(newPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function createAccount (account, callback) {
            var cb = callback || angular.noop;

            return Register.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    this.logout();
                    return cb(err);
                }.bind(this)).$promise;
        }

        function login (credentials, callback) {
            var cb = callback || angular.noop;
            var deferred = $q.defer();

            AuthServerProvider.login(credentials)
                .then(loginThen)
                .catch(function (err) {
                    this.logout();
                    deferred.reject(err);
                    return cb(err);
                }.bind(this));

            function loginThen (data) {
                Principal.identity(true).then(function(account) {
                    // After the login the language will be changed to
                    // the language selected by the user during his registration
                    if (account!== null) {
                        $translate.use(account.langKey).then(function () {
                            $translate.refresh();
                        });
                    }
                    deferred.resolve(data);
                });
                return cb();
            }

            return deferred.promise;
        }


        function logout () {
            AuthServerProvider.logout();
            Principal.authenticate(null);
        }

        function resetPasswordFinish (keyAndPassword, callback) {
            var cb = callback || angular.noop;

            return PasswordResetFinish.save(keyAndPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function resetPasswordInit (mail, callback) {
            var cb = callback || angular.noop;

            return PasswordResetInit.save(mail, function() {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function updateAccount (account, callback) {
            var cb = callback || angular.noop;

            return Account.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function getPreviousState() {
            var previousState = $sessionStorage.previousState;
            return previousState;
        }

        function resetPreviousState() {
            delete $sessionStorage.previousState;
        }

        function storePreviousState(previousStateName, previousStateParams) {
            var previousState = { "name": previousStateName, "params": previousStateParams };
            $sessionStorage.previousState = previousState;
        }
    }
})();

(function() {
    /*jshint camelcase: false */
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .factory('AuthServerProvider', AuthServerProvider);

    AuthServerProvider.$inject = ['$http', '$localStorage', 'Base64'];

    function AuthServerProvider ($http, $localStorage, Base64) {
        var service = {
            getToken: getToken,
            login: login,
            logout: logout
        };

        return service;

        function getToken () {
            return $localStorage.authenticationToken;
        }

        function login (credentials) {
            var data = 'username=' +  encodeURIComponent(credentials.username) + '&password=' +
                encodeURIComponent(credentials.password) + '&grant_type=password&scope=read%20write&' +
                'client_secret=my-secret-token-to-change-in-production&client_id=moldova_yield_curvesapp';

            return $http.post('oauth/token', data, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Accept': 'application/json',
                    'Authorization': 'Basic ' + Base64.encode('moldova_yield_curvesapp' + ':' + 'my-secret-token-to-change-in-production')
                }
            }).success(authSucess);

            function authSucess (response) {
                var expiredAt = new Date();
                expiredAt.setSeconds(expiredAt.getSeconds() + response.expires_in);
                response.expires_at = expiredAt.getTime();
                $localStorage.authenticationToken = response;
                return response;
            }
        }

        function logout () {
            $http.post('api/logout').then(function() {
                delete $localStorage.authenticationToken;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .factory('Activate', Activate);

    Activate.$inject = ['$resource'];

    function Activate ($resource) {
        var service = $resource('api/activate', {}, {
            'get': { method: 'GET', params: {}, isArray: false}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .factory('Account', Account);

    Account.$inject = ['$resource'];

    function Account ($resource) {
        var service = $resource('api/account', {}, {
            'get': { method: 'GET', params: {}, isArray: false,
                interceptor: {
                    response: function(response) {
                        // expose response
                        return response;
                    }
                }
            }
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .controller('NavbarController', NavbarController);

    NavbarController.$inject = ['$state', 'Auth', 'Principal', 'ProfileService', 'LoginService'];

    function NavbarController ($state, Auth, Principal, ProfileService, LoginService) {
        var vm = this;

        vm.isNavbarCollapsed = true;
        vm.isAuthenticated = Principal.isAuthenticated;

        ProfileService.getProfileInfo().then(function(response) {
            vm.inProduction = response.inProduction;
            vm.swaggerEnabled = response.swaggerEnabled;
        });

        vm.login = login;
        vm.logout = logout;
        vm.toggleNavbar = toggleNavbar;
        vm.collapseNavbar = collapseNavbar;
        vm.$state = $state;

        function login() {
            collapseNavbar();
            LoginService.open();
        }

        function logout() {
            collapseNavbar();
            Auth.logout();
            $state.go('home');
        }

        function toggleNavbar() {
            vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
        }

        function collapseNavbar() {
            vm.isNavbarCollapsed = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .directive('activeMenu', activeMenu);

    activeMenu.$inject = ['$translate', '$locale', 'tmhDynamicLocale'];

    function activeMenu($translate, $locale, tmhDynamicLocale) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var language = attrs.activeMenu;

            scope.$watch(function() {
                return $translate.use();
            }, function(selectedLanguage) {
                if (language === selectedLanguage) {
                    tmhDynamicLocale.set(language);
                    element.addClass('active');
                } else {
                    element.removeClass('active');
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('error', {
                parent: 'app',
                url: '/error',
                data: {
                    authorities: [],
                    pageTitle: 'error.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/error.html'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            })
            .state('accessdenied', {
                parent: 'app',
                url: '/accessdenied',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/accessdenied.html'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            });
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .controller('YcFaqController', YcFaqController);

    YcFaqController.$inject = ['$uibModalInstance'];

    function YcFaqController($uibModalInstance) {
        var vm = this;

        vm.clear = clear;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('home', {
                parent: 'app',
                url: '/',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/home/home.html',
                        controller: 'HomeController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('home');
                        return $translate.refresh();
                    }],
                    thresholdDate: ['AppDatesOpen', function (AppDatesOpen) {
                        return AppDatesOpen('old-curve-threshold').query().$promise;
                    }]
                }
            })

            .state('home.faq', {
                parent: 'home',
                url: 'faq',
                data: {
                    authorities: []
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/home/yc-faq.html',
                        controller: 'YcFaqController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg'
                    }).result.then(function () {
                        $state.go('^', {}, {reload: false});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }
})();

(function () {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .controller('HomeController', HomeController);

    HomeController.$inject = ['$scope', '$rootScope', '$q', '$translate', 'Principal', 'LoginService', 'DateUtils',
        'DataUtils', 'availableDates', 'YieldCurveResultsOpen', 'ParCurvePointOpen', 'YieldCurvePointOpen',
        'DataExportOpen', 'ObservedDataCsv', 'PaperErrorsCsv', 'thresholdDate'];

    function HomeController($scope, $rootScope, $q, $translate, Principal, LoginService, DateUtils, DataUtils, availableDates,
        YieldCurveResultsOpen, ParCurvePointOpen, YieldCurvePointOpen, DataExportOpen, ObservedDataCsv,
        PaperErrorsCsv, thresholdDate) {
        var vm = this;

        //***************************************************************
        // basic auth operations
        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        $scope.$on('authenticationSuccess', function () {
            getAccount();
        });
        getAccount();

        function getAccount() {
            Principal.identity().then(function (account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
            });
        }

        //***************************************************************
        //Y-axis title translation handling
        vm.langKey = $translate.storage().get('NG_TRANSLATE_LANG_KEY').trim().toLowerCase();
        var translateChangeSuccess = $rootScope.$on('$translateChangeSuccess', function () {
            vm.langKey = $translate.storage().get('NG_TRANSLATE_LANG_KEY').trim().toLowerCase();
            updateAxisTitle();
        });
        $rootScope.$on('$destroy', function () {
            if (angular.isDefined(translateChangeSuccess) && translateChangeSuccess !== null) {
                translateChangeSuccess();
            }
        });

        //***************************************************************

        //convert available dates to Moment objects
        vm.availableDates = availableDates.map(function (ad) {
            return moment(ad);
        });
        //define threshold date
        // vm.thresholdDate = moment(thresholdDate[0]).format("ll");
        vm.thresholdDate = null;
        //get the latest available date if any
        vm.lastAvailable = null;
        if (vm.availableDates && vm.availableDates.length > 0) {
            vm.lastAvailable = vm.availableDates[vm.availableDates.length - 1];
        }
        //pre-select the latest available date on page load
        vm.selectedDates = [vm.lastAvailable];
        //switch to the month of the latest available date
        vm.activeMonth = vm.lastAvailable;
        //define default data set for the chart
        vm.chartData = {
            chartId: "yc_chart",
            lineSeries: {par: [], zero: []},
            lineLegends: []
        };
        vm.isSplineInterpolated = true;
        vm.curveType = "zero";
        vm.curveLimits = [];
        vm.chartMinTenor = null;
        vm.chartMaxTenor = null;
        vm.minSlider = 2;
        vm.maxSlider = 30;
        vm.sliderStep = 1;
        vm.curveRangeLimit = null;
        vm.curveRangeModel = null;
        vm.longDownload = false;
        //list all the methods
        vm.clearDates = clearDates;
        vm.getResultsForDate = getResultsForDate;
        vm.onCurveRangeChanged = onCurveRangeChanged;
        vm.onCurveRangeSaved = onCurveRangeSaved;
        vm.onDaySelected = onDaySelected;
        vm.onExcelExportClicked = onExcelExportClicked;
        vm.onParamsExportClicked = onParamsExportClicked;
        vm.onExportAllClicked = onExportAllClicked;
        vm.onErrorsExportClicked = onErrorsExportClicked;
        vm.onGetObsClicked = onGetObsClicked;
        vm.parCurveSelected = parCurveSelected;
        vm.updateAxisTitle = updateAxisTitle;
        vm.zeroCurveSelected = zeroCurveSelected;
        //add latest available curve to the chart (if any)
        if (vm.lastAvailable) {
            onDaySelected([], {date: vm.lastAvailable, mdp: {selected: false}});
            updateAxisTitle();
        }

        //***************************************************************
        function parCurveSelected() {
            vm.curveType = "par";
            updateCurveLimits();
            updateAxisTitle();
            // if (vm.chartMaxTenor === 731) {
            //     vm.chartMaxTenor = Math.min(1827, vm.curveLimits[1]);
            //     vm.curveRangeLimit = Math.min(5, Math.round(vm.curveLimits[1] / 365));
            //     vm.curveRangeModel = Math.min(5, Math.round(vm.curveLimits[1] / 365));
            // }
            // vm.minSlider = Math.min(5, Math.round(vm.curveLimits[1] / 365));
        }

        function zeroCurveSelected() {
            vm.curveType = "zero";
            updateCurveLimits();
            updateAxisTitle();
            // vm.minSlider = Math.max(2, Math.round(vm.curveLimits[0] / 365));
        }

        function onCurveRangeChanged() {
            vm.curveRangeLimit = Math.max(2, vm.curveRangeModel);
            if (vm.langKey === 'ru') {
                vm.sliderTitle = (vm.curveRangeLimit < 5) ? 'года' : 'лет';
            }
        }

        function onCurveRangeSaved() {
            vm.chartMaxTenor = vm.curveRangeLimit * 365 + Math.ceil(vm.curveRangeLimit / 4);
        }

        function onParamsExportClicked() {
            var excelFormat = 'xlsx';
            DataExportOpen('excel-betas')
                .query({
                    format: excelFormat,
                    languageKey: $translate.storage().get('NG_TRANSLATE_LANG_KEY')
                })
                .$promise
                .then(function (response) {
                    var fileNameIndex = response.headers["content-disposition"].indexOf("filename=");
                    var fileName = "exported-parameters." + excelFormat;
                    if (fileNameIndex > -1) {
                        fileName = response.headers["content-disposition"].substr(fileNameIndex + "filename=".length);
                    }
                    DataUtils.saveFile(response.headers["content-type"],
                        response.data, fileName.substr(1, fileName.length - 2));
                });
        }

        function onExportAllClicked() {
            var excelFormat = 'xlsx';
            vm.longDownload = true;
            DataExportOpen('excel-all')
                .query({
                    format: excelFormat,
                    languageKey: $translate.storage().get('NG_TRANSLATE_LANG_KEY')
                })
                .$promise
                .then(function (response) {
                    var fileNameIndex = response.headers["content-disposition"].indexOf("filename=");
                    var fileName = "exported-all-results." + excelFormat;
                    if (fileNameIndex > -1) {
                        fileName = response.headers["content-disposition"].substr(fileNameIndex + "filename=".length);
                    }
                    DataUtils.saveFile(response.headers["content-type"],
                        response.data, fileName.substr(1, fileName.length - 2));
                })
                .finally(function () {
                    vm.longDownload = false;
                });
        }

        function onErrorsExportClicked() {
            PaperErrorsCsv()
                .get({lang: vm.langKey})
                .$promise
                .then(function (response) {
                    DataUtils.saveFile(response.headers["content-type"],
                        response.data, "paper_errors_" + moment().format('YYYYMMDD') + ".csv");
                });
        }

        function onExcelExportClicked() {
            var excelFormat = 'xlsx';
            var dateList = vm.selectedDates.map(function (date) {
                return DateUtils.convertLocalDateToServer(date.toDate());
            });
            if (!dateList || dateList.length === 0) {
                return;
            }
            DataExportOpen('excel')
                .query({
                    date: dateList,
                    format: excelFormat,
                    languageKey: $translate.storage().get('NG_TRANSLATE_LANG_KEY')
                })
                .$promise
                .then(function (response) {
                    var fileNameIndex = response.headers["content-disposition"].indexOf("filename=");
                    var fileName = "exported-data." + excelFormat;
                    if (fileNameIndex > -1) {
                        fileName = response.headers["content-disposition"].substr(fileNameIndex + "filename=".length);
                    }
                    DataUtils.saveFile(response.headers["content-type"],
                        response.data, fileName.substr(1, fileName.length - 2));
                });
        }

        function onGetObsClicked() {
            ObservedDataCsv()
                .get({lang: vm.langKey})
                .$promise
                .then(function (response) {
                    DataUtils.saveFile(response.headers["content-type"],
                        response.data, "observed_data_" + moment().format('YYYYMMDD') + ".csv");
                });
        }

        function onDaySelected(event, dateObj) {
            var unselected = dateObj.mdp.selected;
            var dateString = DateUtils.convertLocalDateToServer(dateObj.date.toDate());
            if (unselected) {
                var curveIndex = vm.chartData.lineLegends
                    .findIndex(function (elem) {
                        return elem === dateString;
                    });
                if (curveIndex > -1) {
                    //remove line from the chart
                    vm.chartData.lineSeries.par.splice(curveIndex, 1);
                    vm.chartData.lineSeries.zero.splice(curveIndex, 1);
                    //remove line from the chart legend
                    vm.chartData.lineLegends.splice(curveIndex, 1);
                    updateCurveLimits();
                }
            } else {
                //load curves data
                getResultsForDate(dateString)
                    .then(function (res) {
                        var promises = [];
                        promises.push(ParCurvePointOpen.query({ycId: res.id}).$promise);
                        promises.push(YieldCurvePointOpen.query({ycId: res.id}).$promise);
                        $q.all(promises)
                            .then(function (resParAndZero) {
                                var resPar = resParAndZero[0];
                                var resZero = resParAndZero[1];
                                //add par line to the chart data
                                vm.chartData.lineSeries.par.push(resPar);
                                //add zero line to the chart data
                                vm.chartData.lineSeries.zero.push(resZero);
                                vm.chartData.lineLegends.push(dateString);
                                updateCurveLimits();
                            });
                    });
            }
        }

        function getResultsForDate(dateString) {
            return YieldCurveResultsOpen.get({date: dateString}).$promise;
        }

        function clearDates() {
            vm.chartData = {
                chartId: "yc_chart",
                lineSeries: {par: [], zero: []},
                lineLegends: []
            };
            vm.selectedDates = [];
        }

        function updateAxisTitle() {
            const transId = (vm.curveType === "par")
                ? 'home.yAxisTitlePar'
                : 'home.yAxisTitle';
            $translate(transId).then(function (translation) {
                vm.yAxisTitle = translation;
            }, function (translationId) {
                vm.yAxisTitle = translationId;
            });
        }

        function updateCurveLimits() {
            var minValue = Number.MAX_VALUE;
            var maxValue = Number.MIN_VALUE;
            const lineData = vm.chartData.lineSeries[vm.curveType];
            for (var ix = 0; ix < lineData.length; ix++) {
                if (angular.isDefined(lineData[ix])) {
                    for (var jx = 0; jx < lineData[ix].length; jx++) {
                        var xNum = parseFloat(lineData[ix][jx].deltaPeriods);
                        minValue = Math.min(minValue, xNum);
                        maxValue = Math.max(maxValue, xNum);
                    }
                }
            }
            vm.chartMinTenor = minValue;
            vm.chartMaxTenor = (vm.chartMaxTenor === null || vm.chartMaxTenor === Number.MIN_VALUE)
                ? maxValue
                : Math.min(maxValue, vm.chartMaxTenor);
            vm.minSlider = Math.max(2, Math.round(minValue / 365));
            vm.maxSlider = Math.round(maxValue / 365);
            vm.curveRangeLimit = Math.round(vm.chartMaxTenor / 365);
            vm.curveRangeModel = Math.round(vm.chartMaxTenor / 365);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('ext', {
                abstract: true,
                resolve: {
                    availableDates: ['YieldCurveResultsOpen', function (YieldCurveResultsOpen) {
                        return YieldCurveResultsOpen.query({datesOnly: ""}, function (res) {
                            return res.sort();
                        }).$promise;
                    }],
                    thresholdDate: ['AppDatesOpen', function (AppDatesOpen) {
                        return AppDatesOpen('old-curve-threshold').query().$promise;
                    }]
                }
            })
            .state('en', {
                parent: 'ext',
                url: '/ext/en',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/ext/ext-en.html',
                        controller: 'ExtController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('ro', {
                parent: 'ext',
                url: '/ext/ro',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/ext/ext-ro.html',
                        controller: 'ExtController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('ru', {
                parent: 'ext',
                url: '/ext/ru',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/ext/ext-ru.html',
                        controller: 'ExtController',
                        controllerAs: 'vm'
                    }
                }
            });
    }
})();

(function () {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .controller('ExtController', ExtController);

    ExtController.$inject = ['$scope', '$rootScope', '$q', '$state', 'Principal', 'LoginService', 'DateUtils',
        'DataUtils', 'availableDates', 'YieldCurveResultsOpen', 'ParCurvePointOpen', 'YieldCurvePointOpen',
        'DataExportOpen', 'thresholdDate'];

    function ExtController($scope, $rootScope, $q, $state, Principal, LoginService, DateUtils, DataUtils, availableDates,
                           YieldCurveResultsOpen, ParCurvePointOpen, YieldCurvePointOpen, DataExportOpen, thresholdDate) {
        var vm = this;
        vm.langKey =
            ($state.current.name === 'ro')
                ? 'ro' : $state.current.name;
        moment.locale(vm.langKey);
        vm.availableDates = availableDates.map(function (ad) {
            return moment(ad);
        });
        // vm.thresholdDate = moment(thresholdDate[0]).format("ll");
        vm.thresholdDate = null;
        //get the latest available date if any
        vm.lastAvailable = null;
        if (vm.availableDates && vm.availableDates.length > 0) {
            vm.lastAvailable = vm.availableDates[vm.availableDates.length - 1];
        }
        //pre-select the latest available date on page load
        vm.selectedDates = [vm.lastAvailable];
        //switch to the month of the latest available date
        vm.activeMonth = vm.lastAvailable;
        //define default data set for the chart
        vm.chartData = {
            chartId: "yc_chart",
            lineSeries: {par: [], zero: []},
            lineLegends: []
        };
        vm.isSplineInterpolated = true;
        vm.curveType = "zero";
        vm.curveLimits = [];
        vm.chartMinTenor = null;
        vm.chartMaxTenor = null;
        vm.minSlider = 2;
        vm.maxSlider = 30;
        vm.sliderStep = 1;
        vm.curveRangeLimit = null;
        vm.curveRangeModel = null;
        vm.longDownload = false;
        vm.sliderTitle = (vm.langKey === 'ro')
            ? 'ani' : (vm.langKey === 'ru') ? 'лет' : 'years';
        //list all the methods
        vm.clearDates = clearDates;
        vm.getResultsForDate = getResultsForDate;
        vm.onCurveRangeChanged = onCurveRangeChanged;
        vm.onCurveRangeSaved = onCurveRangeSaved;
        vm.onDaySelected = onDaySelected;
        vm.onExportAllClicked = onExportAllClicked;
        vm.onExcelExportClicked = onExcelExportClicked;
        vm.onParamsExportClicked = onParamsExportClicked;
        vm.parCurveSelected = parCurveSelected;
        vm.updateAxisTitle = updateAxisTitle;
        vm.zeroCurveSelected = zeroCurveSelected;
        //add latest available curve to the chart (if any)
        if (vm.lastAvailable) {
            onDaySelected([], {date: vm.lastAvailable, mdp: {selected: false}});
            updateAxisTitle();
        }

        //***************************************************************
        function parCurveSelected() {
            vm.curveType = "par";
            updateCurveLimits();
            updateAxisTitle();
        }

        function zeroCurveSelected() {
            vm.curveType = "zero";
            updateCurveLimits();
            updateAxisTitle();
        }

        function onCurveRangeChanged() {
            vm.curveRangeLimit = Math.max(2, vm.curveRangeModel);
            if (vm.langKey === 'ru') {
                vm.sliderTitle = (vm.curveRangeLimit < 5) ? 'года' : 'лет';
            }
        }

        function onCurveRangeSaved() {
            vm.chartMaxTenor = vm.curveRangeLimit * 365 + Math.ceil(vm.curveRangeLimit / 4);
        }

        function onExportAllClicked() {
            var excelFormat = 'xlsx';
            vm.longDownload = true;
            DataExportOpen('excel-all')
                .query({
                    format: excelFormat,
                    languageKey: vm.langKey
                })
                .$promise
                .then(function (response) {
                    var fileNameIndex = response.headers["content-disposition"].indexOf("filename=");
                    var fileName = "exported-all-results." + excelFormat;
                    if (fileNameIndex > -1) {
                        fileName = response.headers["content-disposition"].substr(fileNameIndex + "filename=".length);
                    }
                    DataUtils.saveFile(response.headers["content-type"],
                        response.data, fileName.substr(1, fileName.length - 2));
                })
                .finally(function () {
                    vm.longDownload = false;
                });
        }

        function onParamsExportClicked() {
            var excelFormat = 'xlsx';
            DataExportOpen('excel-betas')
                .query({
                    format: excelFormat,
                    languageKey: vm.langKey
                })
                .$promise
                .then(function (response) {
                    var fileNameIndex = response.headers["content-disposition"].indexOf("filename=");
                    var fileName = "exported-parameters." + excelFormat;
                    if (fileNameIndex > -1) {
                        fileName = response.headers["content-disposition"].substr(fileNameIndex + "filename=".length);
                    }
                    DataUtils.saveFile(response.headers["content-type"],
                        response.data, fileName.substr(1, fileName.length - 2));
                });
        }

        function onExcelExportClicked() {
            var excelFormat = 'xlsx';
            var dateList = vm.selectedDates.map(function (date) {
                return DateUtils.convertLocalDateToServer(date.toDate());
            });
            if (!dateList || dateList.length === 0) {
                return;
            }
            DataExportOpen('excel')
                .query({
                    date: dateList,
                    format: excelFormat,
                    languageKey: vm.langKey
                })
                .$promise
                .then(function (response) {
                    var fileNameIndex = response.headers["content-disposition"].indexOf("filename=");
                    var fileName = "exported-data." + excelFormat;
                    if (fileNameIndex > -1) {
                        fileName = response.headers["content-disposition"].substr(fileNameIndex + "filename=".length);
                    }
                    DataUtils.saveFile(response.headers["content-type"],
                        response.data, fileName.substr(1, fileName.length - 2));
                });
        }

        function onDaySelected(event, dateObj) {
            var unselected = dateObj.mdp.selected;
            var dateString = DateUtils.convertLocalDateToServer(dateObj.date.toDate());
            if (unselected) {
                var curveIndex = vm.chartData.lineLegends
                    .findIndex(function (elem) {
                        return elem === dateString;
                    });
                if (curveIndex > -1) {
                    //remove line from the chart
                    vm.chartData.lineSeries.par.splice(curveIndex, 1);
                    vm.chartData.lineSeries.zero.splice(curveIndex, 1);
                    //remove line from the chart legend
                    vm.chartData.lineLegends.splice(curveIndex, 1);
                    updateCurveLimits();
                }
            } else {
                //load curves data
                getResultsForDate(dateString)
                    .then(function (res) {
                        var promises = [];
                        promises.push(ParCurvePointOpen.query({ycId: res.id}).$promise);
                        promises.push(YieldCurvePointOpen.query({ycId: res.id}).$promise);
                        $q.all(promises)
                            .then(function (resParAndZero) {
                                var resPar = resParAndZero[0];
                                var resZero = resParAndZero[1];
                                //add par line to the chart data
                                vm.chartData.lineSeries.par.push(resPar);
                                //add zero line to the chart data
                                vm.chartData.lineSeries.zero.push(resZero);
                                vm.chartData.lineLegends.push(dateString);
                                updateCurveLimits();
                            });
                    });
            }
        }

        function getResultsForDate(dateString) {
            return YieldCurveResultsOpen.get({date: dateString}).$promise;
        }

        function clearDates() {
            vm.chartData = {
                chartId: "yc_chart",
                lineSeries: {par: [], zero: []},
                lineLegends: []
            };
            vm.selectedDates = [];
        }

        function updateAxisTitle() {
            const compStr = (vm.curveType === 'par')
                ? 'semi-annual coupon / simple interest'
                : 'continuously compounded';
            const compStrRu = (vm.curveType === 'par')
                ? 'полугодовой купон / простой процент'
                : 'непрерывноe начисление';
            const compStrRo = (vm.curveType === 'par')
                ? 'cupon semianual / dobândă simplă'
                : 'capitalizare continuă';
            vm.yAxisTitle = (vm.langKey === 'ro')
                ? 'Randament (%, ' + compStrRo + ')'
                : (vm.langKey === 'ru')
                    ? 'Доходность (%, ' + compStrRu + ')'
                    : 'Yield (%, ' + compStr + ')';
        }

        function updateCurveLimits() {
            var minValue = Number.MAX_VALUE;
            var maxValue = Number.MIN_VALUE;
            const lineData = vm.chartData.lineSeries[vm.curveType];
            for (var ix = 0; ix < lineData.length; ix++) {
                if (angular.isDefined(lineData[ix])) {
                    for (var jx = 0; jx < lineData[ix].length; jx++) {
                        var xNum = parseFloat(lineData[ix][jx].deltaPeriods);
                        minValue = Math.min(minValue, xNum);
                        maxValue = Math.max(maxValue, xNum);
                    }
                }
            }
            vm.chartMinTenor = minValue;
            vm.chartMaxTenor = (vm.chartMaxTenor === null)
                ? maxValue
                : Math.min(maxValue, vm.chartMaxTenor);
            vm.minSlider = Math.max(2, Math.round(minValue / 365));
            vm.maxSlider = Math.round(maxValue / 365);
            vm.curveRangeLimit = Math.round(vm.chartMaxTenor / 365);
            vm.curveRangeModel = Math.round(vm.chartMaxTenor / 365);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .controller('YieldCurveResultsDialogController', YieldCurveResultsDialogController);

    YieldCurveResultsDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'entity', 'YieldCurveResults', 'Quoting', 'EpmParams', 'PaperPrice', 'YieldCurvePoint', 'ParCurvePoint'];

    function YieldCurveResultsDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $q, entity, YieldCurveResults, Quoting, EpmParams, PaperPrice, YieldCurvePoint, ParCurvePoint) {
        var vm = this;

        vm.yieldCurveResults = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.quotings = Quoting.query({filter: 'yieldcurveresults-is-null'});
        $q.all([vm.yieldCurveResults.$promise, vm.quotings.$promise]).then(function() {
            if (!vm.yieldCurveResults.quotingId) {
                return $q.reject();
            }
            return Quoting.get({id : vm.yieldCurveResults.quotingId}).$promise;
        }).then(function(quoting) {
            vm.quotings.push(quoting);
        });
        vm.epmparams = EpmParams.query({filter: 'yieldcurveresults-is-null'});
        $q.all([vm.yieldCurveResults.$promise, vm.epmparams.$promise]).then(function() {
            if (!vm.yieldCurveResults.epmParamsId) {
                return $q.reject();
            }
            return EpmParams.get({id : vm.yieldCurveResults.epmParamsId}).$promise;
        }).then(function(epmParams) {
            vm.epmparams.push(epmParams);
        });
        vm.paperprices = PaperPrice.query();
        vm.yieldcurvepoints = YieldCurvePoint.query();
        vm.parcurvepoints = ParCurvePoint.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.yieldCurveResults.id !== null) {
                YieldCurveResults.update(vm.yieldCurveResults, onSaveSuccess, onSaveError);
            } else {
                YieldCurveResults.save(vm.yieldCurveResults, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('moldovaYieldCurvesApp:yieldCurveResultsUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.date = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .controller('YieldCurveResultsDetailController', YieldCurveResultsDetailController);

    YieldCurveResultsDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'YieldCurveResults', 'Quoting', 'EpmParams', 'PaperPrice', 'YieldCurvePoint', 'ParCurvePoint'];

    function YieldCurveResultsDetailController($scope, $rootScope, $stateParams, previousState, entity, YieldCurveResults, Quoting, EpmParams, PaperPrice, YieldCurvePoint, ParCurvePoint) {
        var vm = this;

        vm.yieldCurveResults = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('moldovaYieldCurvesApp:yieldCurveResultsUpdate', function(event, result) {
            vm.yieldCurveResults = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .controller('YieldCurveResultsDeleteController',YieldCurveResultsDeleteController);

    YieldCurveResultsDeleteController.$inject = ['$uibModalInstance', 'entity', 'YieldCurveResults'];

    function YieldCurveResultsDeleteController($uibModalInstance, entity, YieldCurveResults) {
        var vm = this;

        vm.yieldCurveResults = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            YieldCurveResults.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('yield-curve-results', {
            parent: 'entity',
            url: '/yield-curve-results',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'moldovaYieldCurvesApp.yieldCurveResults.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/yield-curve-results/yield-curve-results.html',
                    controller: 'YieldCurveResultsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('yieldCurveResults');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('yield-curve-results-detail', {
            parent: 'yield-curve-results',
            url: '/yield-curve-results/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'moldovaYieldCurvesApp.yieldCurveResults.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/yield-curve-results/yield-curve-results-detail.html',
                    controller: 'YieldCurveResultsDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('yieldCurveResults');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'YieldCurveResults', function($stateParams, YieldCurveResults) {
                    return YieldCurveResults.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'yield-curve-results',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('yield-curve-results-detail.edit', {
            parent: 'yield-curve-results-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/yield-curve-results/yield-curve-results-dialog.html',
                    controller: 'YieldCurveResultsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['YieldCurveResults', function(YieldCurveResults) {
                            return YieldCurveResults.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('yield-curve-results.new', {
            parent: 'yield-curve-results',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/yield-curve-results/yield-curve-results-dialog.html',
                    controller: 'YieldCurveResultsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                m: null,
                                codeRevisionDate: null,
                                codeRevisionNumber: null,
                                date: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('yield-curve-results', null, { reload: 'yield-curve-results' });
                }, function() {
                    $state.go('yield-curve-results');
                });
            }]
        })
        .state('yield-curve-results.edit', {
            parent: 'yield-curve-results',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/yield-curve-results/yield-curve-results-dialog.html',
                    controller: 'YieldCurveResultsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['YieldCurveResults', function(YieldCurveResults) {
                            return YieldCurveResults.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('yield-curve-results', null, { reload: 'yield-curve-results' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('yield-curve-results.delete', {
            parent: 'yield-curve-results',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/yield-curve-results/yield-curve-results-delete-dialog.html',
                    controller: 'YieldCurveResultsDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['YieldCurveResults', function(YieldCurveResults) {
                            return YieldCurveResults.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('yield-curve-results', null, { reload: 'yield-curve-results' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('moldovaYieldCurvesApp')
        .factory('YieldCurveResults', YieldCurveResults);

    YieldCurveResults.$inject = ['$resource', 'DateUtils'];

    function YieldCurveResults ($resource, DateUtils) {
        var resourceUrl =  'api/yield-curve-results/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.date = DateUtils.convertLocalDateFromServer(data.date);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.date = DateUtils.convertLocalDateToServer(copy.date);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.date = DateUtils.convertLocalDateToServer(copy.date);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .controller('YieldCurveResultsController', YieldCurveResultsController);

    YieldCurveResultsController.$inject = ['YieldCurveResults'];

    function YieldCurveResultsController(YieldCurveResults) {

        var vm = this;

        vm.yieldCurveResults = [];

        loadAll();

        function loadAll() {
            YieldCurveResults.query(function(result) {
                vm.yieldCurveResults = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .controller('YieldCurvePointDialogController', YieldCurvePointDialogController);

    YieldCurvePointDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'YieldCurvePoint', 'YieldCurveResults'];

    function YieldCurvePointDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, YieldCurvePoint, YieldCurveResults) {
        var vm = this;

        vm.yieldCurvePoint = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.yieldcurveresults = YieldCurveResults.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.yieldCurvePoint.id !== null) {
                YieldCurvePoint.update(vm.yieldCurvePoint, onSaveSuccess, onSaveError);
            } else {
                YieldCurvePoint.save(vm.yieldCurvePoint, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('moldovaYieldCurvesApp:yieldCurvePointUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.date = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .controller('YieldCurvePointDetailController', YieldCurvePointDetailController);

    YieldCurvePointDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'YieldCurvePoint', 'YieldCurveResults'];

    function YieldCurvePointDetailController($scope, $rootScope, $stateParams, previousState, entity, YieldCurvePoint, YieldCurveResults) {
        var vm = this;

        vm.yieldCurvePoint = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('moldovaYieldCurvesApp:yieldCurvePointUpdate', function(event, result) {
            vm.yieldCurvePoint = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .controller('YieldCurvePointDeleteController',YieldCurvePointDeleteController);

    YieldCurvePointDeleteController.$inject = ['$uibModalInstance', 'entity', 'YieldCurvePoint'];

    function YieldCurvePointDeleteController($uibModalInstance, entity, YieldCurvePoint) {
        var vm = this;

        vm.yieldCurvePoint = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            YieldCurvePoint.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('yield-curve-point', {
            parent: 'entity',
            url: '/yield-curve-point',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'moldovaYieldCurvesApp.yieldCurvePoint.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/yield-curve-point/yield-curve-points.html',
                    controller: 'YieldCurvePointController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('yieldCurvePoint');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('yield-curve-point-detail', {
            parent: 'yield-curve-point',
            url: '/yield-curve-point/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'moldovaYieldCurvesApp.yieldCurvePoint.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/yield-curve-point/yield-curve-point-detail.html',
                    controller: 'YieldCurvePointDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('yieldCurvePoint');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'YieldCurvePoint', function($stateParams, YieldCurvePoint) {
                    return YieldCurvePoint.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'yield-curve-point',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('yield-curve-point-detail.edit', {
            parent: 'yield-curve-point-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/yield-curve-point/yield-curve-point-dialog.html',
                    controller: 'YieldCurvePointDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['YieldCurvePoint', function(YieldCurvePoint) {
                            return YieldCurvePoint.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('yield-curve-point.new', {
            parent: 'yield-curve-point',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/yield-curve-point/yield-curve-point-dialog.html',
                    controller: 'YieldCurvePointDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                date: null,
                                str: null,
                                deltaPeriods: null,
                                discount: null,
                                zeroRate: null,
                                forwardRate: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('yield-curve-point', null, { reload: 'yield-curve-point' });
                }, function() {
                    $state.go('yield-curve-point');
                });
            }]
        })
        .state('yield-curve-point.edit', {
            parent: 'yield-curve-point',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/yield-curve-point/yield-curve-point-dialog.html',
                    controller: 'YieldCurvePointDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['YieldCurvePoint', function(YieldCurvePoint) {
                            return YieldCurvePoint.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('yield-curve-point', null, { reload: 'yield-curve-point' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('yield-curve-point.delete', {
            parent: 'yield-curve-point',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/yield-curve-point/yield-curve-point-delete-dialog.html',
                    controller: 'YieldCurvePointDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['YieldCurvePoint', function(YieldCurvePoint) {
                            return YieldCurvePoint.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('yield-curve-point', null, { reload: 'yield-curve-point' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('moldovaYieldCurvesApp')
        .factory('YieldCurvePoint', YieldCurvePoint);

    YieldCurvePoint.$inject = ['$resource', 'DateUtils'];

    function YieldCurvePoint ($resource, DateUtils) {
        var resourceUrl =  'api/yield-curve-points/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.date = DateUtils.convertLocalDateFromServer(data.date);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.date = DateUtils.convertLocalDateToServer(copy.date);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.date = DateUtils.convertLocalDateToServer(copy.date);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .controller('YieldCurvePointController', YieldCurvePointController);

    YieldCurvePointController.$inject = ['YieldCurvePoint'];

    function YieldCurvePointController(YieldCurvePoint) {

        var vm = this;

        vm.yieldCurvePoints = [];

        loadAll();

        function loadAll() {
            YieldCurvePoint.query(function(result) {
                vm.yieldCurvePoints = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .controller('TranslationDialogController', TranslationDialogController);

    TranslationDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Translation'];

    function TranslationDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Translation) {
        var vm = this;

        vm.translation = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.translation.id !== null) {
                Translation.update(vm.translation, onSaveSuccess, onSaveError);
            } else {
                Translation.save(vm.translation, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('moldovaYieldCurvesApp:translationUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .controller('TranslationDetailController', TranslationDetailController);

    TranslationDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Translation'];

    function TranslationDetailController($scope, $rootScope, $stateParams, previousState, entity, Translation) {
        var vm = this;

        vm.translation = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('moldovaYieldCurvesApp:translationUpdate', function(event, result) {
            vm.translation = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .controller('TranslationDeleteController',TranslationDeleteController);

    TranslationDeleteController.$inject = ['$uibModalInstance', 'entity', 'Translation'];

    function TranslationDeleteController($uibModalInstance, entity, Translation) {
        var vm = this;

        vm.translation = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Translation.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('translation', {
            parent: 'entity',
            url: '/translation',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'moldovaYieldCurvesApp.translation.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/translation/translations.html',
                    controller: 'TranslationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('translation');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('translation-detail', {
            parent: 'translation',
            url: '/translation/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'moldovaYieldCurvesApp.translation.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/translation/translation-detail.html',
                    controller: 'TranslationDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('translation');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Translation', function($stateParams, Translation) {
                    return Translation.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'translation',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('translation-detail.edit', {
            parent: 'translation-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/translation/translation-dialog.html',
                    controller: 'TranslationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Translation', function(Translation) {
                            return Translation.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('translation.new', {
            parent: 'translation',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/translation/translation-dialog.html',
                    controller: 'TranslationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                keyPhrase: null,
                                languageKey: null,
                                translation: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('translation', null, { reload: 'translation' });
                }, function() {
                    $state.go('translation');
                });
            }]
        })
        .state('translation.edit', {
            parent: 'translation',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/translation/translation-dialog.html',
                    controller: 'TranslationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Translation', function(Translation) {
                            return Translation.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('translation', null, { reload: 'translation' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('translation.delete', {
            parent: 'translation',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/translation/translation-delete-dialog.html',
                    controller: 'TranslationDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Translation', function(Translation) {
                            return Translation.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('translation', null, { reload: 'translation' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('moldovaYieldCurvesApp')
        .factory('Translation', Translation);

    Translation.$inject = ['$resource'];

    function Translation ($resource) {
        var resourceUrl =  'api/translations/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .controller('TranslationController', TranslationController);

    TranslationController.$inject = ['Translation'];

    function TranslationController(Translation) {

        var vm = this;

        vm.translations = [];

        loadAll();

        function loadAll() {
            Translation.query(function(result) {
                vm.translations = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .controller('QuotingDialogController', QuotingDialogController);

    QuotingDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Quoting'];

    function QuotingDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Quoting) {
        var vm = this;

        vm.quoting = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.quoting.id !== null) {
                Quoting.update(vm.quoting, onSaveSuccess, onSaveError);
            } else {
                Quoting.save(vm.quoting, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('moldovaYieldCurvesApp:quotingUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .controller('QuotingDetailController', QuotingDetailController);

    QuotingDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Quoting'];

    function QuotingDetailController($scope, $rootScope, $stateParams, previousState, entity, Quoting) {
        var vm = this;

        vm.quoting = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('moldovaYieldCurvesApp:quotingUpdate', function(event, result) {
            vm.quoting = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .controller('QuotingDeleteController',QuotingDeleteController);

    QuotingDeleteController.$inject = ['$uibModalInstance', 'entity', 'Quoting'];

    function QuotingDeleteController($uibModalInstance, entity, Quoting) {
        var vm = this;

        vm.quoting = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Quoting.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('quoting', {
            parent: 'entity',
            url: '/quoting',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'moldovaYieldCurvesApp.quoting.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/quoting/quotings.html',
                    controller: 'QuotingController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('quoting');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('quoting-detail', {
            parent: 'quoting',
            url: '/quoting/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'moldovaYieldCurvesApp.quoting.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/quoting/quoting-detail.html',
                    controller: 'QuotingDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('quoting');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Quoting', function($stateParams, Quoting) {
                    return Quoting.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'quoting',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('quoting-detail.edit', {
            parent: 'quoting-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/quoting/quoting-dialog.html',
                    controller: 'QuotingDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Quoting', function(Quoting) {
                            return Quoting.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('quoting.new', {
            parent: 'quoting',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/quoting/quoting-dialog.html',
                    controller: 'QuotingDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                compound: null,
                                parCouponFreq: null,
                                deltaPeriods: null,
                                zeroRate: null,
                                forwardRate: null,
                                parRate: null,
                                dirtyPrice: null,
                                cleanPrice: null,
                                ytm: null,
                                residualMaturity: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('quoting', null, { reload: 'quoting' });
                }, function() {
                    $state.go('quoting');
                });
            }]
        })
        .state('quoting.edit', {
            parent: 'quoting',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/quoting/quoting-dialog.html',
                    controller: 'QuotingDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Quoting', function(Quoting) {
                            return Quoting.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('quoting', null, { reload: 'quoting' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('quoting.delete', {
            parent: 'quoting',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/quoting/quoting-delete-dialog.html',
                    controller: 'QuotingDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Quoting', function(Quoting) {
                            return Quoting.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('quoting', null, { reload: 'quoting' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('moldovaYieldCurvesApp')
        .factory('Quoting', Quoting);

    Quoting.$inject = ['$resource'];

    function Quoting ($resource) {
        var resourceUrl =  'api/quotings/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .controller('QuotingController', QuotingController);

    QuotingController.$inject = ['Quoting'];

    function QuotingController(Quoting) {

        var vm = this;

        vm.quotings = [];

        loadAll();

        function loadAll() {
            Quoting.query(function(result) {
                vm.quotings = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .controller('ParCurvePointDialogController', ParCurvePointDialogController);

    ParCurvePointDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ParCurvePoint', 'YieldCurveResults'];

    function ParCurvePointDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ParCurvePoint, YieldCurveResults) {
        var vm = this;

        vm.parCurvePoint = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.yieldcurveresults = YieldCurveResults.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.parCurvePoint.id !== null) {
                ParCurvePoint.update(vm.parCurvePoint, onSaveSuccess, onSaveError);
            } else {
                ParCurvePoint.save(vm.parCurvePoint, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('moldovaYieldCurvesApp:parCurvePointUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.date = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .controller('ParCurvePointDetailController', ParCurvePointDetailController);

    ParCurvePointDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'ParCurvePoint', 'YieldCurveResults'];

    function ParCurvePointDetailController($scope, $rootScope, $stateParams, previousState, entity, ParCurvePoint, YieldCurveResults) {
        var vm = this;

        vm.parCurvePoint = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('moldovaYieldCurvesApp:parCurvePointUpdate', function(event, result) {
            vm.parCurvePoint = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .controller('ParCurvePointDeleteController',ParCurvePointDeleteController);

    ParCurvePointDeleteController.$inject = ['$uibModalInstance', 'entity', 'ParCurvePoint'];

    function ParCurvePointDeleteController($uibModalInstance, entity, ParCurvePoint) {
        var vm = this;

        vm.parCurvePoint = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ParCurvePoint.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('par-curve-point', {
            parent: 'entity',
            url: '/par-curve-point',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'moldovaYieldCurvesApp.parCurvePoint.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/par-curve-point/par-curve-points.html',
                    controller: 'ParCurvePointController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('parCurvePoint');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('par-curve-point-detail', {
            parent: 'par-curve-point',
            url: '/par-curve-point/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'moldovaYieldCurvesApp.parCurvePoint.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/par-curve-point/par-curve-point-detail.html',
                    controller: 'ParCurvePointDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('parCurvePoint');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ParCurvePoint', function($stateParams, ParCurvePoint) {
                    return ParCurvePoint.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'par-curve-point',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('par-curve-point-detail.edit', {
            parent: 'par-curve-point-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/par-curve-point/par-curve-point-dialog.html',
                    controller: 'ParCurvePointDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ParCurvePoint', function(ParCurvePoint) {
                            return ParCurvePoint.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('par-curve-point.new', {
            parent: 'par-curve-point',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/par-curve-point/par-curve-point-dialog.html',
                    controller: 'ParCurvePointDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                date: null,
                                str: null,
                                deltaPeriods: null,
                                parRate: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('par-curve-point', null, { reload: 'par-curve-point' });
                }, function() {
                    $state.go('par-curve-point');
                });
            }]
        })
        .state('par-curve-point.edit', {
            parent: 'par-curve-point',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/par-curve-point/par-curve-point-dialog.html',
                    controller: 'ParCurvePointDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ParCurvePoint', function(ParCurvePoint) {
                            return ParCurvePoint.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('par-curve-point', null, { reload: 'par-curve-point' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('par-curve-point.delete', {
            parent: 'par-curve-point',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/par-curve-point/par-curve-point-delete-dialog.html',
                    controller: 'ParCurvePointDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ParCurvePoint', function(ParCurvePoint) {
                            return ParCurvePoint.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('par-curve-point', null, { reload: 'par-curve-point' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('moldovaYieldCurvesApp')
        .factory('ParCurvePoint', ParCurvePoint);

    ParCurvePoint.$inject = ['$resource', 'DateUtils'];

    function ParCurvePoint ($resource, DateUtils) {
        var resourceUrl =  'api/par-curve-points/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.date = DateUtils.convertLocalDateFromServer(data.date);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.date = DateUtils.convertLocalDateToServer(copy.date);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.date = DateUtils.convertLocalDateToServer(copy.date);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .controller('ParCurvePointController', ParCurvePointController);

    ParCurvePointController.$inject = ['ParCurvePoint'];

    function ParCurvePointController(ParCurvePoint) {

        var vm = this;

        vm.parCurvePoints = [];

        loadAll();

        function loadAll() {
            ParCurvePoint.query(function(result) {
                vm.parCurvePoints = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .controller('PaperPriceDialogController', PaperPriceDialogController);

    PaperPriceDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'PaperPrice', 'YieldCurveResults'];

    function PaperPriceDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, PaperPrice, YieldCurveResults) {
        var vm = this;

        vm.paperPrice = entity;
        vm.clear = clear;
        vm.save = save;
        vm.yieldcurveresults = YieldCurveResults.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.paperPrice.id !== null) {
                PaperPrice.update(vm.paperPrice, onSaveSuccess, onSaveError);
            } else {
                PaperPrice.save(vm.paperPrice, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('moldovaYieldCurvesApp:paperPriceUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .controller('PaperPriceDetailController', PaperPriceDetailController);

    PaperPriceDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'PaperPrice', 'YieldCurveResults'];

    function PaperPriceDetailController($scope, $rootScope, $stateParams, previousState, entity, PaperPrice, YieldCurveResults) {
        var vm = this;

        vm.paperPrice = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('moldovaYieldCurvesApp:paperPriceUpdate', function(event, result) {
            vm.paperPrice = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .controller('PaperPriceDeleteController',PaperPriceDeleteController);

    PaperPriceDeleteController.$inject = ['$uibModalInstance', 'entity', 'PaperPrice'];

    function PaperPriceDeleteController($uibModalInstance, entity, PaperPrice) {
        var vm = this;

        vm.paperPrice = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            PaperPrice.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('paper-price', {
            parent: 'entity',
            url: '/paper-price',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'moldovaYieldCurvesApp.paperPrice.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/paper-price/paper-prices.html',
                    controller: 'PaperPriceController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('paperPrice');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('paper-price-detail', {
            parent: 'paper-price',
            url: '/paper-price/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'moldovaYieldCurvesApp.paperPrice.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/paper-price/paper-price-detail.html',
                    controller: 'PaperPriceDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('paperPrice');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'PaperPrice', function($stateParams, PaperPrice) {
                    return PaperPrice.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'paper-price',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('paper-price-detail.edit', {
            parent: 'paper-price-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/paper-price/paper-price-dialog.html',
                    controller: 'PaperPriceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PaperPrice', function(PaperPrice) {
                            return PaperPrice.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('paper-price.new', {
            parent: 'paper-price',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/paper-price/paper-price-dialog.html',
                    controller: 'PaperPriceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                dirtyPrice: null,
                                cleanPrice: null,
                                ytm: null,
                                residualMaturity: null,
                                code: null,
                                description: null,
                                dayCount: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('paper-price', null, { reload: 'paper-price' });
                }, function() {
                    $state.go('paper-price');
                });
            }]
        })
        .state('paper-price.edit', {
            parent: 'paper-price',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/paper-price/paper-price-dialog.html',
                    controller: 'PaperPriceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PaperPrice', function(PaperPrice) {
                            return PaperPrice.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('paper-price', null, { reload: 'paper-price' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('paper-price.delete', {
            parent: 'paper-price',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/paper-price/paper-price-delete-dialog.html',
                    controller: 'PaperPriceDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PaperPrice', function(PaperPrice) {
                            return PaperPrice.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('paper-price', null, { reload: 'paper-price' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('moldovaYieldCurvesApp')
        .factory('PaperPrice', PaperPrice);

    PaperPrice.$inject = ['$resource'];

    function PaperPrice ($resource) {
        var resourceUrl =  'api/paper-prices/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .controller('PaperPriceController', PaperPriceController);

    PaperPriceController.$inject = ['PaperPrice'];

    function PaperPriceController(PaperPrice) {

        var vm = this;

        vm.paperPrices = [];

        loadAll();

        function loadAll() {
            PaperPrice.query(function(result) {
                vm.paperPrices = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .controller('PaperErrorDialogController', PaperErrorDialogController);

    PaperErrorDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'PaperError', 'YieldCurveResults'];

    function PaperErrorDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, PaperError, YieldCurveResults) {
        var vm = this;

        vm.paperError = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.yieldcurveresults = YieldCurveResults.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.paperError.id !== null) {
                PaperError.update(vm.paperError, onSaveSuccess, onSaveError);
            } else {
                PaperError.save(vm.paperError, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('moldovaYieldCurvesApp:paperErrorUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.settleDate = false;
        vm.datePickerOpenStatus.transDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .controller('PaperErrorDetailController', PaperErrorDetailController);

    PaperErrorDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'PaperError', 'YieldCurveResults'];

    function PaperErrorDetailController($scope, $rootScope, $stateParams, previousState, entity, PaperError, YieldCurveResults) {
        var vm = this;

        vm.paperError = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('moldovaYieldCurvesApp:paperErrorUpdate', function(event, result) {
            vm.paperError = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .controller('PaperErrorDeleteController',PaperErrorDeleteController);

    PaperErrorDeleteController.$inject = ['$uibModalInstance', 'entity', 'PaperError'];

    function PaperErrorDeleteController($uibModalInstance, entity, PaperError) {
        var vm = this;

        vm.paperError = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            PaperError.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('paper-error', {
            parent: 'entity',
            url: '/paper-error',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'moldovaYieldCurvesApp.paperError.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/paper-error/paper-errors.html',
                    controller: 'PaperErrorController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('paperError');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('paper-error-detail', {
            parent: 'paper-error',
            url: '/paper-error/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'moldovaYieldCurvesApp.paperError.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/paper-error/paper-error-detail.html',
                    controller: 'PaperErrorDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('paperError');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'PaperError', function($stateParams, PaperError) {
                    return PaperError.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'paper-error',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('paper-error-detail.edit', {
            parent: 'paper-error-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/paper-error/paper-error-dialog.html',
                    controller: 'PaperErrorDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PaperError', function(PaperError) {
                            return PaperError.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('paper-error.new', {
            parent: 'paper-error',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/paper-error/paper-error-dialog.html',
                    controller: 'PaperErrorDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                paperId: null,
                                settleDate: null,
                                ytmDiff: null,
                                ytmObs: null,
                                ytmThe: null,
                                market: null,
                                residualMaturity: null,
                                weightYtm: null,
                                sigmaMarket: null,
                                sigmaOfftherun: null,
                                sigmaRm: null,
                                sigmaSpr: null,
                                sigmaVol: null,
                                description: null,
                                transDate: null,
                                volume: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('paper-error', null, { reload: 'paper-error' });
                }, function() {
                    $state.go('paper-error');
                });
            }]
        })
        .state('paper-error.edit', {
            parent: 'paper-error',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/paper-error/paper-error-dialog.html',
                    controller: 'PaperErrorDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PaperError', function(PaperError) {
                            return PaperError.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('paper-error', null, { reload: 'paper-error' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('paper-error.delete', {
            parent: 'paper-error',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/paper-error/paper-error-delete-dialog.html',
                    controller: 'PaperErrorDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PaperError', function(PaperError) {
                            return PaperError.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('paper-error', null, { reload: 'paper-error' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('moldovaYieldCurvesApp')
        .factory('PaperError', PaperError);

    PaperError.$inject = ['$resource', 'DateUtils'];

    function PaperError ($resource, DateUtils) {
        var resourceUrl =  'api/paper-errors/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.settleDate = DateUtils.convertLocalDateFromServer(data.settleDate);
                        data.transDate = DateUtils.convertLocalDateFromServer(data.transDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.settleDate = DateUtils.convertLocalDateToServer(copy.settleDate);
                    copy.transDate = DateUtils.convertLocalDateToServer(copy.transDate);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.settleDate = DateUtils.convertLocalDateToServer(copy.settleDate);
                    copy.transDate = DateUtils.convertLocalDateToServer(copy.transDate);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .controller('PaperErrorController', PaperErrorController);

    PaperErrorController.$inject = ['PaperError'];

    function PaperErrorController(PaperError) {

        var vm = this;

        vm.paperErrors = [];

        loadAll();

        function loadAll() {
            PaperError.query(function(result) {
                vm.paperErrors = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .controller('ObservedDataDialogController', ObservedDataDialogController);

    ObservedDataDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ObservedData'];

    function ObservedDataDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ObservedData) {
        var vm = this;

        vm.observedData = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.observedData.id !== null) {
                ObservedData.update(vm.observedData, onSaveSuccess, onSaveError);
            } else {
                ObservedData.save(vm.observedData, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('moldovaYieldCurvesApp:observedDataUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.settlementDate = false;
        vm.datePickerOpenStatus.tradeDate = false;
        vm.datePickerOpenStatus.inceptionDate = false;
        vm.datePickerOpenStatus.maturityDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .controller('ObservedDataDetailController', ObservedDataDetailController);

    ObservedDataDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'ObservedData'];

    function ObservedDataDetailController($scope, $rootScope, $stateParams, previousState, entity, ObservedData) {
        var vm = this;

        vm.observedData = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('moldovaYieldCurvesApp:observedDataUpdate', function(event, result) {
            vm.observedData = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .controller('ObservedDataDeleteController',ObservedDataDeleteController);

    ObservedDataDeleteController.$inject = ['$uibModalInstance', 'entity', 'ObservedData'];

    function ObservedDataDeleteController($uibModalInstance, entity, ObservedData) {
        var vm = this;

        vm.observedData = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ObservedData.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('observed-data', {
            parent: 'entity',
            url: '/observed-data',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'moldovaYieldCurvesApp.observedData.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/observed-data/observed-data.html',
                    controller: 'ObservedDataController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('observedData');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('observed-data-detail', {
            parent: 'observed-data',
            url: '/observed-data/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'moldovaYieldCurvesApp.observedData.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/observed-data/observed-data-detail.html',
                    controller: 'ObservedDataDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('observedData');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ObservedData', function($stateParams, ObservedData) {
                    return ObservedData.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'observed-data',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('observed-data-detail.edit', {
            parent: 'observed-data-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/observed-data/observed-data-dialog.html',
                    controller: 'ObservedDataDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ObservedData', function(ObservedData) {
                            return ObservedData.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('observed-data.new', {
            parent: 'observed-data',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/observed-data/observed-data-dialog.html',
                    controller: 'ObservedDataDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                batchId: null,
                                source: null,
                                isin: null,
                                desc: null,
                                couponRate: null,
                                freq: null,
                                settlementDate: null,
                                tradeDate: null,
                                inceptionDate: null,
                                maturityDate: null,
                                dayCountConvention: null,
                                instrumentType: null,
                                marketType: null,
                                ticketSize: null,
                                dirtyPriceObs: null,
                                cleanPriceObs: null,
                                ytmObs: null,
                                ytmMin: null,
                                ytmMax: null,
                                dirtyPriceThe: null,
                                cleanPriceThe: null,
                                accruedInterestThe: null,
                                ytmThe: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('observed-data', null, { reload: 'observed-data' });
                }, function() {
                    $state.go('observed-data');
                });
            }]
        })
        .state('observed-data.edit', {
            parent: 'observed-data',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/observed-data/observed-data-dialog.html',
                    controller: 'ObservedDataDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ObservedData', function(ObservedData) {
                            return ObservedData.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('observed-data', null, { reload: 'observed-data' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('observed-data.delete', {
            parent: 'observed-data',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/observed-data/observed-data-delete-dialog.html',
                    controller: 'ObservedDataDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ObservedData', function(ObservedData) {
                            return ObservedData.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('observed-data', null, { reload: 'observed-data' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('moldovaYieldCurvesApp')
        .factory('ObservedData', ObservedData);

    ObservedData.$inject = ['$resource', 'DateUtils'];

    function ObservedData ($resource, DateUtils) {
        var resourceUrl =  'api/observed-data/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.settlementDate = DateUtils.convertLocalDateFromServer(data.settlementDate);
                        data.tradeDate = DateUtils.convertLocalDateFromServer(data.tradeDate);
                        data.inceptionDate = DateUtils.convertLocalDateFromServer(data.inceptionDate);
                        data.maturityDate = DateUtils.convertLocalDateFromServer(data.maturityDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.settlementDate = DateUtils.convertLocalDateToServer(copy.settlementDate);
                    copy.tradeDate = DateUtils.convertLocalDateToServer(copy.tradeDate);
                    copy.inceptionDate = DateUtils.convertLocalDateToServer(copy.inceptionDate);
                    copy.maturityDate = DateUtils.convertLocalDateToServer(copy.maturityDate);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.settlementDate = DateUtils.convertLocalDateToServer(copy.settlementDate);
                    copy.tradeDate = DateUtils.convertLocalDateToServer(copy.tradeDate);
                    copy.inceptionDate = DateUtils.convertLocalDateToServer(copy.inceptionDate);
                    copy.maturityDate = DateUtils.convertLocalDateToServer(copy.maturityDate);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .controller('ObservedDataController', ObservedDataController);

    ObservedDataController.$inject = ['ObservedData'];

    function ObservedDataController(ObservedData) {

        var vm = this;

        vm.observedData = [];

        loadAll();

        function loadAll() {
            ObservedData.query(function(result) {
                vm.observedData = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .controller('FileStoreDialogController', FileStoreDialogController);

    FileStoreDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'DataUtils', 'entity', 'FileStore', 'YieldCurveResults'];

    function FileStoreDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $q, DataUtils, entity, FileStore, YieldCurveResults) {
        var vm = this;

        vm.fileStore = entity;
        vm.clear = clear;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.yieldcurveresults = YieldCurveResults.query({filter: 'filestore-is-null'});
        $q.all([vm.fileStore.$promise, vm.yieldcurveresults.$promise]).then(function() {
            if (!vm.fileStore.yieldCurveResultsId) {
                return $q.reject();
            }
            return YieldCurveResults.get({id : vm.fileStore.yieldCurveResultsId}).$promise;
        }).then(function(yieldCurveResults) {
            vm.yieldcurveresults.push(yieldCurveResults);
        });

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.fileStore.id !== null) {
                FileStore.update(vm.fileStore, onSaveSuccess, onSaveError);
            } else {
                FileStore.save(vm.fileStore, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('moldovaYieldCurvesApp:fileStoreUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .controller('FileStoreDetailController', FileStoreDetailController);

    FileStoreDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'FileStore', 'YieldCurveResults'];

    function FileStoreDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, FileStore, YieldCurveResults) {
        var vm = this;

        vm.fileStore = entity;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        var unsubscribe = $rootScope.$on('moldovaYieldCurvesApp:fileStoreUpdate', function(event, result) {
            vm.fileStore = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .controller('FileStoreDeleteController',FileStoreDeleteController);

    FileStoreDeleteController.$inject = ['$uibModalInstance', 'entity', 'FileStore'];

    function FileStoreDeleteController($uibModalInstance, entity, FileStore) {
        var vm = this;

        vm.fileStore = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            FileStore.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('file-store', {
                parent: 'entity',
                url: '/file-store?page&sort&search',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'moldovaYieldCurvesApp.fileStore.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/file-store/file-stores.html',
                        controller: 'FileStoreController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('fileStore');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('file-store-detail', {
                parent: 'file-store',
                url: '/file-store/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'moldovaYieldCurvesApp.fileStore.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/file-store/file-store-detail.html',
                        controller: 'FileStoreDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('fileStore');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'FileStore', function ($stateParams, FileStore) {
                        return FileStore.get({id: $stateParams.id}).$promise;
                    }],
                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'file-store',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })
            .state('file-store-detail.edit', {
                parent: 'file-store-detail',
                url: '/detail/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/file-store/file-store-dialog.html',
                        controller: 'FileStoreDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['FileStore', function (FileStore) {
                                return FileStore.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('^', {}, {reload: false});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('file-store.new', {
                parent: 'file-store',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/file-store/file-store-dialog.html',
                        controller: 'FileStoreDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    fileId: null,
                                    dataBlob: null,
                                    validated: false,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('file-store', null, {reload: 'file-store'});
                    }, function () {
                        $state.go('file-store');
                    });
                }]
            })
            .state('file-store.edit', {
                parent: 'file-store',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/file-store/file-store-dialog.html',
                        controller: 'FileStoreDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['FileStore', function (FileStore) {
                                return FileStore.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('file-store', null, {reload: 'file-store'});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('file-store.delete', {
                parent: 'file-store',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/file-store/file-store-delete-dialog.html',
                        controller: 'FileStoreDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['FileStore', function (FileStore) {
                                return FileStore.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('file-store', null, {reload: 'file-store'});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();

(function() {
    'use strict';
    angular
        .module('moldovaYieldCurvesApp')
        .factory('FileStore', FileStore);

    FileStore.$inject = ['$resource'];

    function FileStore ($resource) {
        var resourceUrl =  'api/file-stores/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .controller('FileStoreController', FileStoreController);

    FileStoreController.$inject = ['$state', 'DataUtils', 'FileStore', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function FileStoreController($state, DataUtils, FileStore, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;

        loadAll();

        function loadAll () {
            FileStore.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.fileStores = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .controller('EpmParamsDialogController', EpmParamsDialogController);

    EpmParamsDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'EpmParams'];

    function EpmParamsDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, EpmParams) {
        var vm = this;

        vm.epmParams = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.epmParams.id !== null) {
                EpmParams.update(vm.epmParams, onSaveSuccess, onSaveError);
            } else {
                EpmParams.save(vm.epmParams, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('moldovaYieldCurvesApp:epmParamsUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .controller('EpmParamsDetailController', EpmParamsDetailController);

    EpmParamsDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'EpmParams'];

    function EpmParamsDetailController($scope, $rootScope, $stateParams, previousState, entity, EpmParams) {
        var vm = this;

        vm.epmParams = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('moldovaYieldCurvesApp:epmParamsUpdate', function(event, result) {
            vm.epmParams = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .controller('EpmParamsDeleteController',EpmParamsDeleteController);

    EpmParamsDeleteController.$inject = ['$uibModalInstance', 'entity', 'EpmParams'];

    function EpmParamsDeleteController($uibModalInstance, entity, EpmParams) {
        var vm = this;

        vm.epmParams = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            EpmParams.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('epm-params', {
            parent: 'entity',
            url: '/epm-params',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'moldovaYieldCurvesApp.epmParams.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/epm-params/epm-params.html',
                    controller: 'EpmParamsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('epmParams');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('epm-params-detail', {
            parent: 'epm-params',
            url: '/epm-params/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'moldovaYieldCurvesApp.epmParams.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/epm-params/epm-params-detail.html',
                    controller: 'EpmParamsDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('epmParams');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'EpmParams', function($stateParams, EpmParams) {
                    return EpmParams.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'epm-params',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('epm-params-detail.edit', {
            parent: 'epm-params-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/epm-params/epm-params-dialog.html',
                    controller: 'EpmParamsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['EpmParams', function(EpmParams) {
                            return EpmParams.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('epm-params.new', {
            parent: 'epm-params',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/epm-params/epm-params-dialog.html',
                    controller: 'EpmParamsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                beta0: null,
                                beta1: null,
                                beta2: null,
                                beta3: null,
                                beta4: null,
                                lambda: null,
                                n: null,
                                m: null,
                                id: null,
                                gfit: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('epm-params', null, { reload: 'epm-params' });
                }, function() {
                    $state.go('epm-params');
                });
            }]
        })
        .state('epm-params.edit', {
            parent: 'epm-params',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/epm-params/epm-params-dialog.html',
                    controller: 'EpmParamsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['EpmParams', function(EpmParams) {
                            return EpmParams.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('epm-params', null, { reload: 'epm-params' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('epm-params.delete', {
            parent: 'epm-params',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/epm-params/epm-params-delete-dialog.html',
                    controller: 'EpmParamsDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['EpmParams', function(EpmParams) {
                            return EpmParams.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('epm-params', null, { reload: 'epm-params' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('moldovaYieldCurvesApp')
        .factory('EpmParams', EpmParams);

    EpmParams.$inject = ['$resource'];

    function EpmParams ($resource) {
        var resourceUrl =  'api/epm-params/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .controller('EpmParamsController', EpmParamsController);

    EpmParamsController.$inject = ['EpmParams'];

    function EpmParamsController(EpmParams) {

        var vm = this;

        vm.epmParams = [];

        loadAll();

        function loadAll() {
            EpmParams.query(function(result) {
                vm.epmParams = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('entity', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .controller('CurveLimitsDialogController', CurveLimitsDialogController);

    CurveLimitsDialogController.$inject = ['$timeout', '$scope', '$rootScope', '$stateParams', '$uibModalInstance', '$translate', 'entity', 'CurveLimits'];

    function CurveLimitsDialogController($timeout, $scope, $rootScope, $stateParams, $uibModalInstance, $translate, entity, CurveLimits) {
        var vm = this;

        vm.curveLimits = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        var tenorLabels = [
            {value: 0, label: {en: "O/N", ro: "O/N"}},
            {value: 1, label: {en: "1 day", ro: "1 zi"}},
            {value: 7, label: {en: "1 week", ro: "1 săptămână"}},
            {value: 14, label: {en: "2 weeks", ro: "2 săptămâni"}},
            {value: 21, label: {en: "3 weeks", ro: "3 săptămâni"}},
            {value: 30, label: {en: "1 month", ro: "1 lună"}},
            {value: 61, label: {en: "2 months", ro: "2 luni"}},
            {value: 91, label: {en: "1 quarter", ro: "1 trimestru"}},
            {value: 183, label: {en: "2 quarters", ro: "2 trimestre"}},
            {value: 274, label: {en: "3 quarters", ro: "3 trimestre"}},
            {value: 365, label: {en: "1 year", ro: "1 an"}},
            {value: 457, label: {en: "5 quarters", ro: "5 trimestre"}},
            {value: 548, label: {en: "6 quarters", ro: "6 trimestre"}},
            {value: 640, label: {en: "7 quarters", ro: "7 trimestre"}},
            {value: 731, label: {en: "2 years", ro: "2 ani"}},
            {value: 1096, label: {en: "3 years", ro: "3 ani"}},
            {value: 1461, label: {en: "4 years", ro: "4 ani"}},
            {value: 1826, label: {en: "5 years", ro: "5 ani"}},
            {value: 2192, label: {en: "6 years", ro: "6 ani"}},
            {value: 2557, label: {en: "7 years", ro: "7 ani"}},
            {value: 2922, label: {en: "8 years", ro: "8 ani"}},
            {value: 3287, label: {en: "9 years", ro: "9 ani"}},
            {value: 3653, label: {en: "10 years", ro: "10 ani"}},
            {value: 4018, label: {en: "11 years", ro: "11 ani"}},
            {value: 4383, label: {en: "12 years", ro: "12 ani"}},
            {value: 4748, label: {en: "13 years", ro: "13 ani"}},
            {value: 5114, label: {en: "14 years", ro: "14 ani"}},
            {value: 5479, label: {en: "15 years", ro: "15 ani"}},
            {value: 5844, label: {en: "16 years", ro: "16 ani"}},
            {value: 6209, label: {en: "17 years", ro: "17 ani"}},
            {value: 6575, label: {en: "18 years", ro: "18 ani"}},
            {value: 6940, label: {en: "19 years", ro: "19 ani"}},
            {value: 7305, label: {en: "20 years", ro: "20 ani"}},
            {value: 7670, label: {en: "21 years", ro: "21 ani"}},
            {value: 8036, label: {en: "22 years", ro: "22 ani"}},
            {value: 8401, label: {en: "23 years", ro: "23 ani"}},
            {value: 8766, label: {en: "24 years", ro: "24 ani"}},
            {value: 9131, label: {en: "25 years", ro: "25 ani"}},
            {value: 9497, label: {en: "26 years", ro: "26 ani"}},
            {value: 9862, label: {en: "27 years", ro: "27 ani"}},
            {value: 10227, label: {en: "28 years", ro: "28 ani"}},
            {value: 10592, label: {en: "29 years", ro: "29 ani"}},
            {value: 10958, label: {en: "30 years", ro: "30 ani"}}
        ];
        vm.langKey = $translate.storage().get('NG_TRANSLATE_LANG_KEY').trim().toLowerCase();
        vm.tenorLabels = tenorLabels.map(function (el) {
            return {value: el.value, label: el.label[vm.langKey]};
        });
        var translateChangeSuccess = $rootScope.$on('$translateChangeSuccess', function () {
            vm.langKey = $translate.storage().get('NG_TRANSLATE_LANG_KEY').trim().toLowerCase();
            vm.tenorLabels = tenorLabels.map(function (el) {
                return {value: el.value, label: el.label[vm.langKey]};
            });
        });
        $rootScope.$on('$destroy', function () {
            if (angular.isDefined(translateChangeSuccess) && translateChangeSuccess !== null) {
                translateChangeSuccess();
            }
        });

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.curveLimits.id !== null) {
                CurveLimits.update(vm.curveLimits, onSaveSuccess, onSaveError);
            } else {
                CurveLimits.save(vm.curveLimits, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('moldovaYieldCurvesApp:curveLimitsUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.validFrom = false;
        vm.datePickerOpenStatus.validTo = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .controller('CurveLimitsDetailController', CurveLimitsDetailController);

    CurveLimitsDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'CurveLimits'];

    function CurveLimitsDetailController($scope, $rootScope, $stateParams, previousState, entity, CurveLimits) {
        var vm = this;

        vm.curveLimits = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('moldovaYieldCurvesApp:curveLimitsUpdate', function(event, result) {
            vm.curveLimits = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .controller('CurveLimitsDeleteController',CurveLimitsDeleteController);

    CurveLimitsDeleteController.$inject = ['$uibModalInstance', 'entity', 'CurveLimits'];

    function CurveLimitsDeleteController($uibModalInstance, entity, CurveLimits) {
        var vm = this;

        vm.curveLimits = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CurveLimits.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('curve-limits', {
            parent: 'admin',
            url: '/curve-limits',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'moldovaYieldCurvesApp.curveLimits.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/curve-limits/curve-limits.html',
                    controller: 'CurveLimitsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('curveLimits');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('curve-limits-detail', {
            parent: 'curve-limits',
            url: '/curve-limits/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'moldovaYieldCurvesApp.curveLimits.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/curve-limits/curve-limits-detail.html',
                    controller: 'CurveLimitsDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('curveLimits');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CurveLimits', function($stateParams, CurveLimits) {
                    return CurveLimits.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'curve-limits',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('curve-limits-detail.edit', {
            parent: 'curve-limits-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/curve-limits/curve-limits-dialog.html',
                    controller: 'CurveLimitsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CurveLimits', function(CurveLimits) {
                            return CurveLimits.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('curve-limits.new', {
            parent: 'curve-limits',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/curve-limits/curve-limits-dialog.html',
                    controller: 'CurveLimitsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                beta0: null,
                                beta1: null,
                                beta2: null,
                                beta3: null,
                                beta4: null,
                                lambda: null,
                                n: null,
                                m: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('curve-limits', null, { reload: 'curve-limits' });
                }, function() {
                    $state.go('curve-limits');
                });
            }]
        })
        .state('curve-limits.edit', {
            parent: 'curve-limits',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/curve-limits/curve-limits-dialog.html',
                    controller: 'CurveLimitsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CurveLimits', function(CurveLimits) {
                            return CurveLimits.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('curve-limits', null, { reload: 'curve-limits' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('curve-limits.delete', {
            parent: 'curve-limits',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/curve-limits/curve-limits-delete-dialog.html',
                    controller: 'CurveLimitsDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CurveLimits', function(CurveLimits) {
                            return CurveLimits.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('curve-limits', null, { reload: 'curve-limits' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function () {
    'use strict';
    angular
        .module('moldovaYieldCurvesApp')
        .factory('CurveLimits', CurveLimits);

    CurveLimits.$inject = ['$resource', 'DateUtils'];

    function CurveLimits($resource, DateUtils) {
        var resourceUrl = 'api/curve-limits/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.validFrom = DateUtils.convertLocalDateFromServer(data.validFrom);
                        data.validTo = DateUtils.convertLocalDateFromServer(data.validTo);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.validFrom = DateUtils.convertLocalDateToServer(copy.validFrom);
                    copy.validTo = DateUtils.convertLocalDateToServer(copy.validTo);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.validFrom = DateUtils.convertLocalDateToServer(copy.validFrom);
                    copy.validTo = DateUtils.convertLocalDateToServer(copy.validTo);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .controller('CurveLimitsController', CurveLimitsController);

    CurveLimitsController.$inject = ['CurveLimits'];

    function CurveLimitsController(CurveLimits) {

        var vm = this;

        vm.curveLimits = [];

        loadAll();

        function loadAll() {
            CurveLimits.query(function(result) {
                vm.curveLimits = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .filter('words', words);

    function words() {
        return wordsFilter;

        function wordsFilter(input, words) {
            if (isNaN(words)) {
                return input;
            }
            if (words <= 0) {
                return '';
            }
            if (input) {
                var inputWords = input.split(/\s+/);
                if (inputWords.length > words) {
                    input = inputWords.slice(0, words).join(' ') + '...';
                }
            }
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .filter('characters', characters);

    function characters () {
        return charactersFilter;

        function charactersFilter(input, chars, breakOnWord) {
            if (isNaN(chars)) {
                return input;
            }
            if (chars <= 0) {
                return '';
            }
            if (input && input.length > chars) {
                input = input.substring(0, chars);

                if (!breakOnWord) {
                    var lastspace = input.lastIndexOf(' ');
                    // Get last space
                    if (lastspace !== -1) {
                        input = input.substr(0, lastspace);
                    }
                } else {
                    while (input.charAt(input.length-1) === ' ') {
                        input = input.substr(0, input.length - 1);
                    }
                }
                return input + '...';
            }
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .directive('jhSortBy', jhSortBy);

    function jhSortBy() {
        var directive = {
            restrict: 'A',
            scope: false,
            require: '^jhSort',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs, parentCtrl) {
            element.bind('click', function () {
                parentCtrl.sort(attrs.jhSortBy);
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .directive('jhSort', jhSort);

    function jhSort () {
        var directive = {
            restrict: 'A',
            scope: {
                predicate: '=jhSort',
                ascending: '=',
                callback: '&'
            },
            controller: SortController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;
    }

    SortController.$inject = ['$scope', '$element'];

    function SortController ($scope, $element) {
        var vm = this;

        vm.applyClass = applyClass;
        vm.resetClasses = resetClasses;
        vm.sort = sort;
        vm.triggerApply = triggerApply;

        $scope.$watchGroup(['vm.predicate', 'vm.ascending'], vm.triggerApply);
        vm.triggerApply();

        function applyClass (element) {
            var thisIcon = element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt',
                remove = sortIcon + ' ' + sortDesc,
                add = sortAsc;
            if (!vm.ascending) {
                remove = sortIcon + ' ' + sortAsc;
                add = sortDesc;
            }
            vm.resetClasses();
            thisIcon.removeClass(remove);
            thisIcon.addClass(add);
        }

        function resetClasses () {
            var allThIcons = $element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt';
            allThIcons.removeClass(sortAsc + ' ' + sortDesc);
            allThIcons.addClass(sortIcon);
        }

        function sort (field) {
            if (field !== vm.predicate) {
                vm.ascending = true;
            } else {
                vm.ascending = !vm.ascending;
            }
            vm.predicate = field;
            $scope.$apply();
            vm.callback();
        }

        function triggerApply (values)  {
            vm.resetClasses();
            if (values && values[0] !== '_score') {
                vm.applyClass($element.find('th[jh-sort-by=\'' + values[0] + '\']'));
            }
        }
    }
})();

(function(){
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .factory('ParseLinks', ParseLinks);

    function ParseLinks () {

        var service = {
            parse : parse
        };

        return service;

        function parse(header) {
            if (header.length === 0) {
                throw new Error('input must not be of zero length');
            }

            // Split parts by comma
            var parts = header.split(',');
            var links = {};
            // Parse each part into a named link
            angular.forEach(parts, function(p) {
                var section = p.split('>;');
                if (section.length !== 2) {
                    throw new Error('section could not be split on ">;"');
                }
                var url = section[0].replace(/<(.*)/, '$1').trim();
                var queryString = {};
                url.replace(
                    new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
                    function($0, $1, $2, $3) { queryString[$1] = $3; }
                );
                var page = queryString.page;
                if (angular.isString(page)) {
                    page = parseInt(page);
                }
                var name = section[1].replace(/rel="(.*)"/, '$1').trim();
                links[name] = page;
            });
            return links;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .factory('PaginationUtil', PaginationUtil);

    function PaginationUtil () {

        var service = {
            parseAscending : parseAscending,
            parsePage : parsePage,
            parsePredicate : parsePredicate
        };

        return service;

        function parseAscending (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                return sort.split(',').slice(-1)[0] === 'asc';
            } else {
                // default to true if no sort defined
                return true;
            }
        }

        // query params are strings, and need to be parsed
        function parsePage (page) {
            return parseInt(page);
        }

        // sort can be in the format `id,asc` or `id`
        function parsePredicate (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                sortArray.pop();
            }
            return sortArray.join(',');
        }
    }
})();

(function() {
    'use strict';

    var jhiItemCount = {
        template: '<div class="info">' +
                    'Showing {{(($ctrl.page - 1) * $ctrl.itemsPerPage) == 0 ? 1 : (($ctrl.page - 1) * $ctrl.itemsPerPage + 1)}} - ' +
                    '{{($ctrl.page * $ctrl.itemsPerPage) < $ctrl.queryCount ? ($ctrl.page * $ctrl.itemsPerPage) : $ctrl.queryCount}} ' +
                    'of {{$ctrl.queryCount}} items.' +
                '</div>',
        bindings: {
            page: '<',
            queryCount: '<total',
            itemsPerPage: '<'
        }
    };

    angular
        .module('moldovaYieldCurvesApp')
        .component('jhiItemCount', jhiItemCount);
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .factory('DateUtils', DateUtils);

    DateUtils.$inject = ['$filter'];

    function DateUtils($filter) {

        var service = {
            convertDateTimeFromServer: convertDateTimeFromServer,
            convertLocalDateFromServer: convertLocalDateFromServer,
            convertLocalDateToServer: convertLocalDateToServer,
            dateformat: dateformat,
            convertDateToTsDate: convertDateToTsDate
        };

        return service;

        function convertDateTimeFromServer(date) {
            if (date) {
                return new Date(date);
            } else {
                return null;
            }
        }

        function convertLocalDateFromServer(date) {
            if (date) {
                var dateString = date.split('-');
                return new Date(dateString[0], dateString[1] - 1, dateString[2]);
            }
            return null;
        }

        function convertLocalDateToServer(date) {
            if (date) {
                return $filter('date')(date, 'yyyy-MM-dd');
            } else {
                return null;
            }
        }

        function dateformat() {
            return 'yyyy-MM-dd';
        }

        /*converts Date object to the IRIS date string formatted according to the dateFormat*/
        function convertDateToTsDate(dateObj, frequency, dateFormat) {
            if (typeof(dateObj)=='string')
                dateObj = new Date(dateObj);
            var y = dateObj.getFullYear();
            var m = dateObj.getMonth();
            var p = ((frequency == 1) ? 1 : (frequency == 4) ? Math.ceil((m + 1) / 3) : m + 1).toString();
            var freqLetter = (frequency == 1) ? 'y' : (frequency == 4) ? 'q' : 'm';
            var dateString = dateFormat;
            dateString = dateString.replace(/yyyy/i, y.toString());
            dateString = dateString.replace(/yy/i, y.toString().slice(-2));
            dateString = dateString.replace(/f/, freqLetter);
            dateString = dateString.replace(/F/, freqLetter.toUpperCase());
            dateString = dateString.replace(/pp/i, p.length == 1 ? '0' + p : p);
            dateString = dateString.replace(/p/i, p);
            // if (frequency == 12) {
            var monthNames = ["January", "February", "March", "April", "May", "June",
                "July", "August", "September", "October", "November", "December"];
            dateString = dateString.replace(/Mmmm/, monthNames[m]);
            dateString = dateString.replace(/mmmm/, monthNames[m].toLowerCase());
            dateString = dateString.replace(/MMMM/, monthNames[m].toUpperCase());
            dateString = dateString.replace(/Mmm/, monthNames[m].slice(0,3));
            dateString = dateString.replace(/mmm/, monthNames[m].toLowerCase().slice(0,3));
            dateString = dateString.replace(/MMM/, monthNames[m].toUpperCase().slice(0,3));
            dateString = dateString.replace(/mm/i, (m<=8)?'0'+(m+1).toString():(m+1).toString());
            dateString = dateString.replace(/m/i, (m+1).toString());
            // }

            return dateString;
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .factory('DataUtils', DataUtils);

    DataUtils.$inject = ['$window', 'FileSaver', 'Blob'];

    function DataUtils($window, FileSaver, Blob) {

        var service = {
            abbreviate: abbreviate,
            byteSize: byteSize,
            openFile: openFile,
            saveFile: saveFile,
            toBase64: toBase64
        };

        return service;

        function abbreviate(text) {
            if (!angular.isString(text)) {
                return '';
            }
            if (text.length < 30) {
                return text;
            }
            return text ? (text.substring(0, 15) + '...' + text.slice(-10)) : '';
        }

        function byteSize(base64String) {
            if (!angular.isString(base64String)) {
                return '';
            }

            function endsWith(suffix, str) {
                return str.indexOf(suffix, str.length - suffix.length) !== -1;
            }

            function paddingSize(base64String) {
                if (endsWith('==', base64String)) {
                    return 2;
                }
                if (endsWith('=', base64String)) {
                    return 1;
                }
                return 0;
            }

            function size(base64String) {
                return base64String.length / 4 * 3 - paddingSize(base64String);
            }

            function formatAsBytes(size) {
                return size.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' bytes';
            }

            return formatAsBytes(size(base64String));
        }

        function openFile(type, data) {
            $window.open('data:' + type + ';base64,' + data, '_blank', 'height=300,width=400');
        }

        function saveFile(type, data, fileName) {
            var blobData = new Blob([data], {type: type});
            FileSaver.saveAs(blobData, fileName);
        }

        function toBase64(file, cb) {
            var fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = function (e) {
                var base64Data = e.target.result.substr(e.target.result.indexOf('base64,') + 'base64,'.length);
                cb(base64Data);
            };
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .filter('capitalize', capitalize);

    function capitalize() {
        return capitalizeFilter;

        function capitalizeFilter (input) {
            if (input !== null) {
                input = input.toLowerCase();
                input = input.substring(0, 1).toUpperCase() + input.substring(1);
            }
            return input;
        }
    }
})();

(function() {
    /*jshint bitwise: false*/
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .factory('Base64', Base64);

    function Base64 () {
        var keyStr = 'ABCDEFGHIJKLMNOP' +
            'QRSTUVWXYZabcdef' +
            'ghijklmnopqrstuv' +
            'wxyz0123456789+/' +
            '=';

        var service = {
            decode : decode,
            encode : encode
        };

        return service;

        function encode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            while (i < input.length) {
                chr1 = input.charCodeAt(i++);
                chr2 = input.charCodeAt(i++);
                chr3 = input.charCodeAt(i++);

                enc1 = chr1 >> 2;
                enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                enc4 = chr3 & 63;

                if (isNaN(chr2)) {
                    enc3 = enc4 = 64;
                } else if (isNaN(chr3)) {
                    enc4 = 64;
                }

                output = output +
                    keyStr.charAt(enc1) +
                    keyStr.charAt(enc2) +
                    keyStr.charAt(enc3) +
                    keyStr.charAt(enc4);
            }

            return output;
        }

        function decode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
            input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

            while (i < input.length) {
                enc1 = keyStr.indexOf(input.charAt(i++));
                enc2 = keyStr.indexOf(input.charAt(i++));
                enc3 = keyStr.indexOf(input.charAt(i++));
                enc4 = keyStr.indexOf(input.charAt(i++));

                chr1 = (enc1 << 2) | (enc2 >> 4);
                chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
                chr3 = ((enc3 & 3) << 6) | enc4;

                output = output + String.fromCharCode(chr1);

                if (enc3 !== 64) {
                    output = output + String.fromCharCode(chr2);
                }
                if (enc4 !== 64) {
                    output = output + String.fromCharCode(chr3);
                }
            }

            return output;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .factory('LoginService', LoginService);

    LoginService.$inject = ['$uibModal'];

    function LoginService ($uibModal) {
        var service = {
            open: open
        };

        var modalInstance = null;
        var resetModal = function () {
            modalInstance = null;
        };

        return service;

        function open () {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/components/login/login.html',
                controller: 'LoginController',
                controllerAs: 'vm',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('login');
                        return $translate.refresh();
                    }]
                }
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .controller('LoginController', LoginController);

    LoginController.$inject = ['$rootScope', '$state', '$timeout', 'Auth', '$uibModalInstance'];

    function LoginController ($rootScope, $state, $timeout, Auth, $uibModalInstance) {
        var vm = this;

        vm.authenticationError = false;
        vm.cancel = cancel;
        vm.credentials = {};
        vm.login = login;
        vm.password = null;
        vm.register = register;
        vm.rememberMe = true;
        vm.requestResetPassword = requestResetPassword;
        vm.username = null;

        $timeout(function (){angular.element('#username').focus();});

        function cancel () {
            vm.credentials = {
                username: null,
                password: null,
                rememberMe: true
            };
            vm.authenticationError = false;
            $uibModalInstance.dismiss('cancel');
        }

        function login (event) {
            event.preventDefault();
            Auth.login({
                username: vm.username,
                password: vm.password,
                rememberMe: vm.rememberMe
            }).then(function () {
                vm.authenticationError = false;
                $uibModalInstance.close();
                if ($state.current.name === 'register' || $state.current.name === 'activate' ||
                    $state.current.name === 'finishReset' || $state.current.name === 'requestReset') {
                    $state.go('home');
                }

                $rootScope.$broadcast('authenticationSuccess');

                // previousState was set in the authExpiredInterceptor before being redirected to login modal.
                // since login is successful, go to stored previousState and clear previousState
                if (Auth.getPreviousState()) {
                    var previousState = Auth.getPreviousState();
                    Auth.resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }
            }).catch(function () {
                vm.authenticationError = true;
            });
        }

        function register () {
            $uibModalInstance.dismiss('cancel');
            $state.go('register');
        }

        function requestResetPassword () {
            $uibModalInstance.dismiss('cancel');
            $state.go('requestReset');
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .factory('JhiLanguageService', JhiLanguageService);

    JhiLanguageService.$inject = ['$q', '$http', '$translate', 'LANGUAGES'];

    function JhiLanguageService ($q, $http, $translate, LANGUAGES) {
        var service = {
            getAll: getAll,
            getCurrent: getCurrent
        };

        return service;

        function getAll () {
            var deferred = $q.defer();
            deferred.resolve(LANGUAGES);
            return deferred.promise;
        }

        function getCurrent () {
            var deferred = $q.defer();
            var language = $translate.storage().get('NG_TRANSLATE_LANG_KEY');

            deferred.resolve(language);

            return deferred.promise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .filter('findLanguageFromKey', findLanguageFromKey);

    function findLanguageFromKey() {
        return findLanguageFromKeyFilter;

        function findLanguageFromKeyFilter(lang) {
            return {
                'ca': 'Català',
                'cs': 'Český',
                'da': 'Dansk',
                'de': 'Deutsch',
                'el': 'Ελληνικά',
                'en': 'English',
                'es': 'Español',
                'et': 'Eesti',
                'fr': 'Français',
                'gl': 'Galego',
                'hu': 'Magyar',
                'hi': 'हिंदी',
                'hy': 'Հայերեն',
                'it': 'Italiano',
                'ja': '日本語',
                'ka': 'ქართული',
                'ko': '한국어',
                'mr': 'मराठी',
                'nl': 'Nederlands',
                'pl': 'Polski',
                'pt-br': 'Português (Brasil)',
                'pt-pt': 'Português',
                'ro': 'Română',
                'ru': 'Русский',
                'sk': 'Slovenský',
                'sr': 'Srpski',
                'sv': 'Svenska',
                'ta': 'தமிழ்',
                'th': 'ไทย',
                'tr': 'Türkçe',
                'uz-latn': 'O‘zbekcha',
                'uz': 'Ўзбекча',
                'vi': 'Tiếng Việt',
                'zh-cn': '中文（简体）',
                'zh-tw': '繁體中文'
            }[lang];
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .controller('JhiLanguageController', JhiLanguageController);

    JhiLanguageController.$inject = ['$translate', 'JhiLanguageService', 'tmhDynamicLocale'];

    function JhiLanguageController ($translate, JhiLanguageService, tmhDynamicLocale) {
        var vm = this;

        vm.changeLanguage = changeLanguage;
        vm.languages = null;

        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function changeLanguage (languageKey) {
            $translate.use(languageKey);
            tmhDynamicLocale.set(languageKey);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')

        /*
         Languages codes are ISO_639-1 codes, see http://en.wikipedia.org/wiki/List_of_ISO_639-1_codes
         They are written in English to avoid character encoding issues (not a perfect solution)
         */
        .constant('LANGUAGES', [
            'en',
            'ru',
            'ro',
            // jhipster-needle-i18n-language-constant - JHipster will add/remove languages in this array
        ]
    );
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .directive('showValidation', showValidation);

    function showValidation () {
        var directive = {
            restrict: 'A',
            require: 'form',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, formCtrl) {
            element.find('.form-group').each(function() {
                var $formGroup = angular.element(this);
                var $inputs = $formGroup.find('input[ng-model],textarea[ng-model],select[ng-model]');

                if ($inputs.length > 0) {
                    $inputs.each(function() {
                        var $input = angular.element(this);
                        var inputName = $input.attr('name');
                        scope.$watch(function() {
                            return formCtrl[inputName].$invalid && formCtrl[inputName].$dirty;
                        }, function(isInvalid) {
                            $formGroup.toggleClass('has-error', isInvalid);
                        });
                    });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .constant('paginationConstants', {
            'itemsPerPage': 5
        });
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .directive('minbytes', minbytes);

    function minbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.minbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) >= attrs.minbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .directive('maxbytes', maxbytes);

    function maxbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.maxbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) <= attrs.maxbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .directive('yieldCurveChart', yieldCurveChart);

    yieldCurveChart.$inject = ['$window', 'chartConfig', 'DateUtils'];

    function yieldCurveChart($window, chartConfig, DateUtils) {
        // Generates chart for one or more timeseries
        // Usage:
        //  <div data-yield-curve-chart chart-data="vm.chartData">
        //  <div data-yield-curve-chart chart-data="vm.chartData" line-style="vm.lineStyle">
        //  <div data-yield-curve-chart chart-data="vm.chartData" min-tenor="vm.minimumDeltaPeriods">
        //  <div data-yield-curve-chart chart-data="vm.chartData" max-tenor="vm.maximumDeltaPeriods">
        //  <div data-yield-curve-chart chart-data="vm.chartData" curve-type="vm.curveType">
        // Input structure:
        //  vm.chartData = {
        //      chartId: "someId",
        //      title: "some title",
        //      lineSeries: {
        //          par: [
        //              [
        //                  {date: Date, str: String, deltaPeriods: Int, par_rate: Double},
        //                  ...
        //              ],
        //              ...
        //          ],
        //          zero: [
        //              [
        //                  {date: Date, str: String, deltaPeriods: Int, discount: Double, zero_rate: Double, forward_rate: Double},
        //                  ...
        //              ],
        //              ...
        //          ]
        //      },
        //      lineLegends: [String, String, ... ]
        //  }
        //  vm.lineStyle = [
        //      {
        //          width: 2,
        //          color: '#3734FF',
        //          dashSetting: [<dashWidth>,<emptySpaceWidth>],
        //          markerSize: 2,
        //          markerShape: <one of the following shapes: None, LeftArrow, RightArrow, Circle, Cross, HorizLine,
        //                                                     VertLine, Diamond, Rectangle, Triangle, InvertedTriangle,
        //                                                     Hexagon, Pentagon, Star, Ellipse, Wedge, Trapezoid,
        //                                                     UpArrow, DownArrow>
        //      },
        //      ...
        //  ]

        var directive = {
            link: linkFunc,
            restrict: 'A',
            scope: {
                chartData: '<',
                lineStyle: '<',
                curveType: '<',
                minTenor: '<',
                maxTenor: '<',
                yAxisTitle: '<',
                isSpline: '<',
                langKey: '<'
            }
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            element.addClass('yieldCurveChart');
            element.attr('id', scope.chartData.chartId);

            makeChart();

            scope.$watch('chartData', updateChart, true);
            scope.$watch('lineStyle', updateChart, true);
            scope.$watch('curveType', updateChart, true);
            scope.$watch('minTenor', updateChart, true);
            scope.$watch('maxTenor', updateChart, true);
            scope.$watch('yAxisTitle', updateChart, true);
            scope.$watch('isSpline', updateChart, true);
            scope.$watch('langKey', updateChart, true);
            //some responsiveness here: when window was resized - recalculate
            // height of the chart based on the parent height
            var win = angular.element($window);
            win.bind("resize", updateChart);
            element.on('$destroy', function () {
                win.unbind("resize", updateChart);
            });

            function updateChart() {
                //unbind this function before removing the chart
                win.unbind("resize", updateChart);
                element.ejChart("destroy");
                element.empty();
                makeChart();
                win.bind("resize", updateChart);
            }

            function makeChart() {
                // console.log('here!');
                //load defaults
                var chartObject = angular.copy(chartConfig.yieldCurveChartDefaults.chartObject);
                var defaultLineStyles = angular.copy(chartConfig.yieldCurveChartDefaults.lineStyles);
                var xTicksTranslations = angular.copy(chartConfig.yieldCurveChartDefaults.xTicksTranslations);
                // //get chart title from chartData
                // chartObject.title.text = angular.copy(scope.chartData.title);

                //get Y-axis title
                var yAxisTitle = angular.copy(scope.yAxisTitle);

                //get chart type ('line' or 'spline')
                var chartType = scope.isSpline ? 'spline' : 'line';

                //get lines' legends from chartData
                var lineLegends = angular.copy(scope.chartData.lineLegends);

                //try getting lines' styles from lineStyle
                var lineStyles = angular.copy(scope.lineStyle);

                //try getting type of the curve from curveType or set it to zero-curve by default
                var curveType = angular.copy(scope.curveType);
                if (!curveType) {
                    curveType = 'zero';
                }

                //get lines' series from chartData
                var lineData;
                if (curveType == "zero") {
                    lineData = angular.copy(scope.chartData.lineSeries.zero);
                } else {
                    lineData = angular.copy(scope.chartData.lineSeries.par);
                }

                //try getting minimum date from minDate
                var minTenor = angular.copy(scope.minTenor);

                //try getting maximum date from maxDate
                var maxTenor = angular.copy(scope.maxTenor);

                //try getting language key and use EN by default
                var langKey = angular.copy(scope.langKey);
                if (!langKey) {
                    langKey = 'en';
                }

                //update chart height based on the height of the parent element
                // console.log(element.parent().height());
                chartObject.size.height = (angular.copy(element.parent().height()) - 10).toString();

                //if there was an error don't try to build a chart
                if (lineData === null) {
                    element.append('<p>Unable to plot the chart</p>');
                    return;
                }

                //if there's no line styles provided fill them in with the default line styles
                var ix;
                if (lineData.length > 0 && (!lineStyles || lineStyles.length === 0)) {
                    lineStyles = [];
                    for (ix = 0; ix < Math.min(6, lineData.length); ix++) {
                        lineStyles.push(defaultLineStyles.predefined[ix]);
                    }
                }

                //if line data is empty show nice watermark
                if (lineData.length === 0) {
                    element.append('<div id="watermark" style="font-size:28px;display:none">Empty</div>');
                    chartObject.annotations[0].visible = true;
                    chartObject.primaryXAxis.visible = false;
                    chartObject.primaryYAxis.visible = false;
                    chartObject.primaryYAxis.majorGridLines.visible = false;
                    chartObject.series = [{}];
                    chartObject.primaryXAxis.stripLine = [];
                    chartObject.legend.visible = false;
                } else {
                    chartObject.annotations[0].visible = false;
                    chartObject.primaryXAxis.visible = true;
                    chartObject.primaryYAxis.visible = true;
                    chartObject.primaryYAxis.majorGridLines.visible = true;
                    chartObject.series = [];
                    chartObject.primaryXAxis.stripLine = [];
                    chartObject.legend.visible = true;
                }
                //cut the range of all chart series
                for (ix = 0; ix < lineData.length; ix++) {
                    if (angular.isDefined(lineData[ix])) {
                        if (minTenor) {
                            lineData[ix] = lineData[ix].filter(function (dataPoint) {
                                if (angular.isUndefined(dataPoint)) {
                                    return false;
                                }
                                return parseFloat(dataPoint.deltaPeriods) >= minTenor;
                            });
                        }
                        if (maxTenor) {
                            lineData[ix] = lineData[ix].filter(function (dataPoint) {
                                if (angular.isUndefined(dataPoint)) {
                                    return false;
                                }
                                return Math.round(parseFloat(dataPoint.deltaPeriods) / 365) <= Math.round(maxTenor / 365);
                            });
                        }
                    }
                }
                //fill in series of chartObject with the lines' data
                var minValue = Number.MAX_VALUE;
                var maxValue = Number.MIN_VALUE;
                for (ix = 0; ix < lineData.length; ix++) {
                    if (angular.isDefined(lineData[ix])) {
                        //construct array of the series points
                        var dataPoints = [];
                        for (var jx = 0; jx < lineData[ix].length; jx++) {
                            if (lineData[ix][jx].deltaPeriods == "0") {
                                continue
                            }
                            var xNum = parseFloat(lineData[ix][jx].deltaPeriods);
                            var yNum = parseFloat(lineData[ix][jx][curveType + "Rate"]);
                            minValue = Math.min(minValue, yNum);
                            maxValue = Math.max(maxValue, yNum);
                            var translatedText = lineData[ix][jx].str;
                            if (angular.isDefined(xTicksTranslations[lineData[ix][jx].str]) && angular.isDefined(xTicksTranslations[lineData[ix][jx].str][langKey])) {
                                translatedText = xTicksTranslations[lineData[ix][jx].str][langKey];
                            }
                            dataPoints.push({
                                x: xNum,
                                y: yNum,
                                text: translatedText
                            });
                        }
                        //use default line style if number of lines is higher the number of predefined lines in config
                        if (lineStyles.length < ix + 1) {
                            lineStyles.push(defaultLineStyles.new);
                        }
                        //use default legend if lineLegends array is shorter
                        var lineName = "";
                        if (!lineLegends || lineLegends.length < ix + 1) {
                            lineName = "curve" + (ix + 1);
                        } else {
                            lineName = lineLegends[ix];
                        }
                        //add series to the chart structure
                        chartObject.series.push({
                            fill: lineStyles[ix].color,//todo -> name: <add some legend string>,
                            width: lineStyles[ix].width,
                            marker: {
                                visible: true,
                                shape: lineStyles[ix].markerShape,
                                size: {width: lineStyles[ix].markerSize, height: lineStyles[ix].markerSize}
                            },
                            dashArray: lineStyles[ix].dashSetting.toString(),
                            type: chartType,
                            points: dataPoints,
                            name: lineName
                            // dataSource: lineData[ix],
                            // xName: "deltaPeriods",
                            // yName: curveType + "Rate"
                        });
                    }
                }
                // change chart X-axis interval if chartMaxTenor is lower than 2Y
                if (maxTenor !== 731) {
                    chartObject.primaryXAxis.range.interval = 365;
                    if (maxTenor > 7305) {
                        chartObject.primaryXAxis.range.interval = 730;
                    }
                } else {
                    chartObject.primaryXAxis.range.interval = 90;
                }
                chartObject.primaryXAxis.range.max = maxTenor;
                // adjust Y-axis range to be tight
                if (lineData.length > 0) {
                    chartObject.primaryYAxis.range = {
                        min: Math.floor(minValue),
                        max: Math.ceil(maxValue)
                    };
                }
                //assign Y-axis title
                chartObject.primaryYAxis.title.text = yAxisTitle;

                // console.log(chartObject);
                //generate the chart from prepared object
                element.ejChart(angular.copy(chartObject));
            }
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .constant('chartConstants', {
            'lineColorSet': [
                '#E4A216',
                '#42ADAC',
                '#A585FF',
                '#5891ED',
                '#F25E5E',
                '#999EA2'
            ]
        });
})();

(function () {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .provider('chartConfig', chartConfig);

    // configuration
    chartConfig.$inject = ['chartConstants'];
    function chartConfig(chartConstants) {
        this.yieldCurveChartDefaultObject = {
            // title: {
            //     //Title text is to be filled in the app
            //     text: '',
            //     //Configure chart title font
            //     font:{
            //         opacity: 1,
            //         fontFamily: "Open Sans",
            //         fontWeight: 'lighter',
            //         color: "#337AB6",
            //         size: '16px'
            //     }
            // },
            //Configure Primary X Axis
            primaryXAxis: {
                font: {
                    size: "13px",
                    fontFamily: "Helvetica",
                    color: "#000000de"
                },
                visible: true, // to be changed for empty charts
                title: {visible: false, text: 'Tenor'},
                axisLine: {visible: true},
                majorGridLines: {visible: true, },
                majorTickLines: {visible: true},
                rangePadding: 'none',
                valueType: 'double',
                labelPlacement: 'onticks',
                labelIntersectAction: 'multipleRows',
                isIndexed: false,
                range: {min: 0, interval: 365}
            },
            //Configure Primary Y Axis
            primaryYAxis: {
                font: {
                    size: "13px",
                    fontFamily: "Helvetica",
                    color: "#000000de"
                },
                title: {
                    visible: true,
                    text: 'Yield (%, annually compounded)',
                    font: {
                        size: "13px",
                        fontFamily: "Helvetica",
                        color: "#000000de"
                    }
                },
                visible: true, // to be changed for empty charts
                axisLine: {visible: true},
                opacity: 0,
                majorGridLines: {visible: true}//, rangePadding: 'additional'
            },
            //Configure Common Properties for all the series
            commonSeriesOptions: {
                enableAnimation: true,
                opacity: 0.75,
                border: {
                    width: 2
                },
                marker: {
                    border: {
                        width: 0
                    }
                },
                highlightSettings: {
                    enable: true,
                    mode: 'series',
                    opacity: 1
                }
            },
            //Series are to be filled in the app
            series: [],
            //Configure Zooming
            zooming: {
                enable: false,
                enableMouseWheel: false,
                enableScrollbar: true,
                type: 'x,y'
            },
            //Configure Trackball
            crosshair: {
                visible: true,
                type: 'trackball'
            },
            //OnLoad event handler
            // load: onChartLoaded,
            //Chart appearance and other properties
            chartArea: {
                border: {
                    opacity: 1
                }
            },
            border: {
                width: 0,
                color: "#5250A1"
            },
            canResize: true,
            isResponsive: true,
            legend: {
                visible: true,
                shape: 'seriesType',
                font: {
                    size: "13px",
                    fontFamily: "Helvetica",
                    color: "#000000de"
                }
            },
            size: {
                height: '250'//,width: '300'
            },
            annotations: [{
                visible: false, // to be changed for empty charts
                content: "watermark",
                opacity: 0.2,
                region: "series"
            }],
            //customize the trackball tooltip
            // tooltip: {visible: true, format: " #point.text# : #point.y#  "},
            trackToolTip: onTooltipShown,
            axesLabelRendering: onAxisLabelRender
        };

        this.yieldCurveChartDefaultLineStyles = {
            predefined: [ //todo: only six lines are predefined so far, will see if more is needed
                {
                    width: 3,
                    color: chartConstants.lineColorSet[0],
                    dashSetting: [1, 0],
                    markerShape: 'Circle',
                    markerSize: 2
                },
                {
                    width: 3,
                    color: chartConstants.lineColorSet[1],
                    dashSetting: [1, 0],
                    markerShape: 'Diamond',
                    markerSize: 2
                },
                {
                    width: 3,
                    color: chartConstants.lineColorSet[2],
                    dashSetting: [1, 0],
                    markerShape: 'InvertedTriangle',
                    markerSize: 2
                },
                {
                    width: 3,
                    color: chartConstants.lineColorSet[3],
                    dashSetting: [1, 0],
                    markerShape: 'Star',
                    markerSize: 2
                },
                {
                    width: 3,
                    color: chartConstants.lineColorSet[4],
                    dashSetting: [1, 0],
                    markerShape: 'Triangle',
                    markerSize: 2
                },
                {
                    width: 3,
                    color: chartConstants.lineColorSet[5],
                    dashSetting: [1, 0],
                    markerShape: 'Pentagon',
                    markerSize: 2
                }
            ],
            new: {
                width: 3,
                color: null, //will be picked automatically
                dashSetting: [1, 0],
                markerShape: 'None',
                markerSize: 0
            }
        };

        this.xTicksTranslations = {
            "today": { en: "today", ru: "сегодня", ro: "azi" },
            "1 day": { en: "1 day", ru: "1 день", ro: "1 zi" },
            "1 week": { en: "1 week", ru: "1 неделя", ro: "1 săptămână" },
            "2 weeks": { en: "2 weeks", ru: "2 недели", ro: "2 săptămâni" },
            "3 weeks": { en: "3 weeks", ru: "3 недели", ro: "3 săptămâni" },
            "1 month": { en: "1 month", ru: "1 месяц", ro: "1 lună" },
            "2 months": { en: "2 months", ru: "2 месяца", ro: "2 luni" },
            "1 quarter": { en: "1 quarter", ru: "1 квартал", ro: "1 trimestru" },
            "2 quarters": { en: "2 quarters", ru: "2 квартала", ro: "2 trimestre" },
            "3 quarters": { en: "3 quarters", ru: "3 квартала", ro: "3 trimestre" },
            "1 year": { en: "1 year", ru: "1 год", ro: "1 an" },
            "5 quarters": { en: "5 quarters", ru: "5 кварталов", ro: "5 trimestre" },
            "6 quarters": { en: "6 quarters", ru: "6 кварталов", ro: "6 trimestre" },
            "7 quarters": { en: "7 quarters", ru: "7 кварталов", ro: "7 trimestre" },
            "2 years": { en: "2 years", ru: "2 года", ro: "2 ani" },
            "3 years": { en: "3 years", ru: "3 года", ro: "3 ani" },
            "4 years": { en: "4 years", ru: "4 года", ro: "4 ani" },
            "5 years": { en: "5 years", ru: "5 лет", ro: "5 ani" },
            "6 years": { en: "6 years", ru: "6 лет", ro: "6 ani" },
            "7 years": { en: "7 years", ru: "7 лет", ro: "7 ani" },
            "8 years": { en: "8 years", ru: "8 лет", ro: "8 ani" },
            "9 years": { en: "9 years", ru: "9 лет", ro: "9 ani" },
            "10 years": { en: "10 years", ru: "10 лет", ro: "10 ani" },
            "11 years": { en: "11 years", ru: "11 лет", ro: "11 ani" },
            "12 years": { en: "12 years", ru: "12 лет", ro: "12 ani" },
            "13 years": { en: "13 years", ru: "13 лет", ro: "13 ani" },
            "14 years": { en: "14 years", ru: "14 лет", ro: "14 ani" },
            "15 years": { en: "15 years", ru: "15 лет", ro: "15 ani" },
            "16 years": { en: "16 years", ru: "16 лет", ro: "16 ani" },
            "17 years": { en: "17 years", ru: "17 лет", ro: "17 ani" },
            "18 years": { en: "18 years", ru: "18 лет", ro: "18 ani" },
            "19 years": { en: "19 years", ru: "19 лет", ro: "19 ani" },
            "20 years": { en: "20 years", ru: "20 лет", ro: "20 ani" },
            "21 years": { en: "21 years", ru: "21 год", ro: "21 de ani" },
            "22 years": { en: "22 years", ru: "22 года", ro: "22 de ani" },
            "23 years": { en: "23 years", ru: "23 года", ro: "23 de ani" },
            "24 years": { en: "24 years", ru: "24 года", ro: "24 de ani" },
            "25 years": { en: "25 years", ru: "25 лет", ro: "25 de ani" },
            "26 years": { en: "26 years", ru: "26 лет", ro: "26 de ani" },
            "27 years": { en: "27 years", ru: "27 лет", ro: "27 de ani" },
            "28 years": { en: "28 years", ru: "28 лет", ro: "28 de ani" },
            "29 years": { en: "29 years", ru: "29 лет", ro: "29 de ani" },
            "30 years": { en: "30 years", ru: "30 лет", ro: "30 de ani" }
        };

        this.$get = function () {
            return {
                yieldCurveChartDefaults: {
                    chartObject: this.yieldCurveChartDefaultObject,
                    lineStyles: this.yieldCurveChartDefaultLineStyles,
                    xTicksTranslations: this.xTicksTranslations
                }
            };
        };

        function onTooltipShown(sender) {
            var dataPoint = sender.data.Series.dataPoint[sender.data.pointIndex];
            //reformat Y number up to 4th precision point
            sender.data.currentText = dataPoint.text + " : " + dataPoint.y.toPrecision(4);
        }

        function onAxisLabelRender(sender) {
            // format horizontal axis
            if (sender.data.axis.orientation === 'horizontal') {
                var actInterval = angular.copy(sender.data.axis.actualRange.interval);
                actInterval = (actInterval >= 365) ? 365 : 1;
                var freqLetter = (actInterval === 365) ? "Y" : "D";
                sender.data.label.Text = (sender.data.label.Text == "0")
                    ? "" // show "" for the zero tenor
                    : parseFloat(sender.data.label.Text) / actInterval + freqLetter;
            }
        }
    }
})();

(function() {
    'use strict';

    var jhiAlertError = {
        template: '<div class="alerts" ng-cloak="" role="alert">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre>{{ alert.msg }}</pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertErrorController
    };

    angular
        .module('moldovaYieldCurvesApp')
        .component('jhiAlertError', jhiAlertError);

    jhiAlertErrorController.$inject = ['$scope', 'AlertService', '$rootScope', '$translate'];

    function jhiAlertErrorController ($scope, AlertService, $rootScope, $translate) {
        var vm = this;

        vm.alerts = [];

        function addErrorAlert (message, key, data) {
            key = key ? key : message;
            vm.alerts.push(
                AlertService.add(
                    {
                        type: 'danger',
                        msg: key,
                        params: data,
                        timeout: 5000,
                        toast: AlertService.isToast(),
                        scoped: true
                    },
                    vm.alerts
                )
            );
        }

        var cleanHttpErrorListener = $rootScope.$on('moldovaYieldCurvesApp.httpError', function (event, httpResponse) {
            var i;
            event.stopPropagation();
            switch (httpResponse.status) {
            // connection refused, server not reachable
            case 0:
                addErrorAlert('Server not reachable','error.server.not.reachable');
                break;

            case 400:
                var headers = Object.keys(httpResponse.headers()).filter(function (header) {
                    return header.indexOf('app-error', header.length - 'app-error'.length) !== -1 || header.indexOf('app-params', header.length - 'app-params'.length) !== -1;
                }).sort();
                var errorHeader = httpResponse.headers(headers[0]);
                var entityKey = httpResponse.headers(headers[1]);
                if (errorHeader) {
                    var entityName = $translate.instant('global.menu.entities.' + entityKey);
                    addErrorAlert(errorHeader, errorHeader, {entityName: entityName});
                } else if (httpResponse.data && httpResponse.data.fieldErrors) {
                    for (i = 0; i < httpResponse.data.fieldErrors.length; i++) {
                        var fieldError = httpResponse.data.fieldErrors[i];
                        // convert 'something[14].other[4].id' to 'something[].other[].id' so translations can be written to it
                        var convertedField = fieldError.field.replace(/\[\d*\]/g, '[]');
                        var fieldName = $translate.instant('moldovaYieldCurvesApp.' + fieldError.objectName + '.' + convertedField);
                        addErrorAlert('Field ' + fieldName + ' cannot be empty', 'error.' + fieldError.message, {fieldName: fieldName});
                    }
                } else if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message, httpResponse.data.message, httpResponse.data);
                } else {
                    addErrorAlert(httpResponse.data);
                }
                break;

            case 404:
                addErrorAlert('Not found','error.url.not.found');
                break;

            default:
                if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message);
                } else {
                    addErrorAlert(angular.toJson(httpResponse));
                }
            }
        });

        $scope.$on('$destroy', function () {
            if(angular.isDefined(cleanHttpErrorListener) && cleanHttpErrorListener !== null){
                cleanHttpErrorListener();
                vm.alerts = [];
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .provider('AlertService', AlertService);

    function AlertService () {
        this.toast = false;
        /*jshint validthis: true */
        this.$get = getService;

        this.showAsToast = function(isToast) {
            this.toast = isToast;
        };

        getService.$inject = ['$timeout', '$sce', '$translate'];

        function getService ($timeout, $sce,$translate) {
            var toast = this.toast,
                alertId = 0, // unique id for each alert. Starts from 0.
                alerts = [],
                timeout = 5000; // default timeout

            return {
                factory: factory,
                isToast: isToast,
                add: addAlert,
                closeAlert: closeAlert,
                closeAlertByIndex: closeAlertByIndex,
                clear: clear,
                get: get,
                success: success,
                error: error,
                info: info,
                warning : warning
            };

            function isToast() {
                return toast;
            }

            function clear() {
                alerts = [];
            }

            function get() {
                return alerts;
            }

            function success(msg, params, position) {
                return this.add({
                    type: 'success',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function error(msg, params, position) {
                return this.add({
                    type: 'danger',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function warning(msg, params, position) {
                return this.add({
                    type: 'warning',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function info(msg, params, position) {
                return this.add({
                    type: 'info',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function factory(alertOptions) {
                var alert = {
                    type: alertOptions.type,
                    msg: $sce.trustAsHtml(alertOptions.msg),
                    id: alertOptions.alertId,
                    timeout: alertOptions.timeout,
                    toast: alertOptions.toast,
                    position: alertOptions.position ? alertOptions.position : 'top right',
                    scoped: alertOptions.scoped,
                    close: function (alerts) {
                        return closeAlert(this.id, alerts);
                    }
                };
                if(!alert.scoped) {
                    alerts.push(alert);
                }
                return alert;
            }

            function addAlert(alertOptions, extAlerts) {
                alertOptions.alertId = alertId++;
                alertOptions.msg = $translate.instant(alertOptions.msg, alertOptions.params);
                var that = this;
                var alert = this.factory(alertOptions);
                if (alertOptions.timeout && alertOptions.timeout > 0) {
                    $timeout(function () {
                        that.closeAlert(alertOptions.alertId, extAlerts);
                    }, alertOptions.timeout);
                }
                return alert;
            }

            function closeAlert(id, extAlerts) {
                var thisAlerts = extAlerts ? extAlerts : alerts;
                return closeAlertByIndex(thisAlerts.map(function(e) { return e.id; }).indexOf(id), thisAlerts);
            }

            function closeAlertByIndex(index, thisAlerts) {
                return thisAlerts.splice(index, 1);
            }
        }
    }
})();

(function() {
    'use strict';

    var jhiAlert = {
        template: '<div class="alerts" ng-cloak="" role="alert">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre ng-bind-html="alert.msg"></pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertController
    };

    angular
        .module('moldovaYieldCurvesApp')
        .component('jhiAlert', jhiAlert);

    jhiAlertController.$inject = ['$scope', 'AlertService'];

    function jhiAlertController($scope, AlertService) {
        var vm = this;

        vm.alerts = AlertService.get();
        $scope.$on('$destroy', function () {
            vm.alerts = [];
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .factory('notificationInterceptor', notificationInterceptor);

    notificationInterceptor.$inject = ['$q', 'AlertService'];

    function notificationInterceptor ($q, AlertService) {
        var service = {
            response: response
        };

        return service;

        function response (response) {
            var headers = Object.keys(response.headers()).filter(function (header) {
                return header.indexOf('app-alert', header.length - 'app-alert'.length) !== -1 || header.indexOf('app-params', header.length - 'app-params'.length) !== -1;
            }).sort();
            var alertKey = response.headers(headers[0]);
            if (angular.isString(alertKey)) {
                AlertService.success(alertKey, { param : response.headers(headers[1])});
            }
            return response;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .factory('errorHandlerInterceptor', errorHandlerInterceptor);

    errorHandlerInterceptor.$inject = ['$q', '$rootScope'];

    function errorHandlerInterceptor ($q, $rootScope) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError (response) {
            if (!(response.status === 401 && (response.data === '' || (response.data.path && response.data.path.indexOf('/api/account') === 0 )))) {
                $rootScope.$emit('moldovaYieldCurvesApp.httpError', response);
            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .factory('authExpiredInterceptor', authExpiredInterceptor);

    authExpiredInterceptor.$inject = ['$rootScope', '$q', '$injector', '$localStorage', '$sessionStorage'];

    function authExpiredInterceptor($rootScope, $q, $injector, $localStorage, $sessionStorage) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError(response) {
            if (response.status === 401) {
                delete $localStorage.authenticationToken;
                delete $sessionStorage.authenticationToken;
                var Principal = $injector.get('Principal');
                if (Principal.isAuthenticated()) {
                    var Auth = $injector.get('Auth');
                    Auth.authorize(true);
                }
            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .factory('authInterceptor', authInterceptor);

    authInterceptor.$inject = ['$rootScope', '$q', '$location', '$localStorage', '$sessionStorage'];

    function authInterceptor ($rootScope, $q, $location, $localStorage, $sessionStorage) {
        var service = {
            request: request
        };

        return service;

        function request (config) {
            /*jshint camelcase: false */
            config.headers = config.headers || {};
            var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;
            if (token && token.expires_at && token.expires_at > new Date().getTime()) {
                config.headers.Authorization = 'Bearer ' + token.access_token;
            }
            return config;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .factory('translationHandler', translationHandler);

    translationHandler.$inject = ['$rootScope', '$window', '$state', '$translate'];

    function translationHandler($rootScope, $window, $state, $translate) {
        return {
            initialize: initialize,
            updateTitle: updateTitle
        };

        function initialize() {
            // if the current translation changes, update the window title
            var translateChangeSuccess = $rootScope.$on('$translateChangeSuccess', function() {
                var langKey = $translate.storage().get('NG_TRANSLATE_LANG_KEY').trim().toLowerCase();
                updateTitle();
                moment.locale(langKey);
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(translateChangeSuccess) && translateChangeSuccess !== null){
                    translateChangeSuccess();
                }
            });
        }

        // update the window title using params in the following
        // precedence
        // 1. titleKey parameter
        // 2. $state.$current.data.pageTitle (current state page title)
        // 3. 'global.title'
        function updateTitle(titleKey) {
            if (!titleKey && $state.$current.data && $state.$current.data.pageTitle) {
                titleKey = $state.$current.data.pageTitle;
            }
            $translate(titleKey || 'global.title').then(function (title) {
                $window.document.title = title;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .factory('stateHandler', stateHandler);

    stateHandler.$inject = ['$rootScope', '$state', '$sessionStorage', '$translate', 'JhiLanguageService', 'translationHandler', '$window',
        'Auth', 'Principal', 'VERSION'];

    function stateHandler($rootScope, $state, $sessionStorage, $translate, JhiLanguageService, translationHandler, $window,
        Auth, Principal, VERSION) {
        return {
            initialize: initialize
        };

        function initialize() {
            $rootScope.VERSION = VERSION;

            var stateChangeStart = $rootScope.$on('$stateChangeStart', function (event, toState, toStateParams, fromState) {
                $rootScope.toState = toState;
                $rootScope.toStateParams = toStateParams;
                $rootScope.fromState = fromState;

                // Redirect to a state with an external URL (http://stackoverflow.com/a/30221248/1098564)
                if (toState.external) {
                    event.preventDefault();
                    $window.open(toState.url, '_self');
                }

                if (Principal.isIdentityResolved()) {
                    Auth.authorize();
                }

                // Update the language
                JhiLanguageService.getCurrent().then(function (language) {
                    $translate.use(language);
                });
            });

            var stateChangeSuccess = $rootScope.$on('$stateChangeSuccess',  function(event, toState, toParams, fromState, fromParams) {
                var titleKey = 'global.title' ;

                // Set the page title key to the one configured in state or use default one
                if (toState.data.pageTitle) {
                    titleKey = toState.data.pageTitle;
                }
                translationHandler.updateTitle(titleKey);
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(stateChangeStart) && stateChangeStart !== null){
                    stateChangeStart();
                }
                if(angular.isDefined(stateChangeSuccess) && stateChangeSuccess !== null){
                    stateChangeSuccess();
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .config(paginationConfig);

    paginationConfig.$inject = ['uibPaginationConfig', 'paginationConstants'];

    function paginationConfig(uibPaginationConfig, paginationConstants) {
        uibPaginationConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPaginationConfig.maxSize = 5;
        uibPaginationConfig.boundaryLinks = true;
        uibPaginationConfig.firstText = '«';
        uibPaginationConfig.previousText = '‹';
        uibPaginationConfig.nextText = '›';
        uibPaginationConfig.lastText = '»';
    }
})();

(function () {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .config(pagerConfig);

    pagerConfig.$inject = ['uibPagerConfig', 'paginationConstants'];

    function pagerConfig(uibPagerConfig, paginationConstants) {
        uibPagerConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPagerConfig.previousText = '«';
        uibPagerConfig.nextText = '»';
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .factory('translationStorageProvider', translationStorageProvider);

    translationStorageProvider.$inject = ['$cookies', '$log', 'LANGUAGES'];

    function translationStorageProvider($cookies, $log, LANGUAGES) {
        return {
            get: get,
            put: put
        };

        function get(name) {
            if (LANGUAGES.indexOf($cookies.getObject(name)) === -1) {
                $log.info('Resetting invalid cookie language "' + $cookies.getObject(name) + '" to preferred language "en"');
                $cookies.putObject(name, 'en');
            }
            return $cookies.getObject(name);
        }

        function put(name, value) {
            $cookies.putObject(name, value);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .config(translationConfig);

    translationConfig.$inject = ['$translateProvider', 'tmhDynamicLocaleProvider'];

    function translationConfig($translateProvider, tmhDynamicLocaleProvider) {
        // Initialize angular-translate
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: 'i18n/{lang}/{part}.json'
        });

        $translateProvider.preferredLanguage('en');
        $translateProvider.useStorage('translationStorageProvider');
        $translateProvider.useSanitizeValueStrategy('escaped');
        $translateProvider.addInterpolation('$translateMessageFormatInterpolation');

        tmhDynamicLocaleProvider.localeLocationPattern('i18n/angular-locale_{{locale}}.js');
        tmhDynamicLocaleProvider.useCookieStorage();
        tmhDynamicLocaleProvider.storageKey('NG_TRANSLATE_LANG_KEY');
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .config(localStorageConfig);

    localStorageConfig.$inject = ['$localStorageProvider', '$sessionStorageProvider'];

    function localStorageConfig($localStorageProvider, $sessionStorageProvider) {
        $localStorageProvider.setKeyPrefix('jhi-');
        $sessionStorageProvider.setKeyPrefix('jhi-');
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .config(httpConfig);

    httpConfig.$inject = ['$urlRouterProvider', '$httpProvider', 'httpRequestInterceptorCacheBusterProvider', '$urlMatcherFactoryProvider'];

    function httpConfig($urlRouterProvider, $httpProvider, httpRequestInterceptorCacheBusterProvider, $urlMatcherFactoryProvider) {
        //Cache everything except rest api requests
        httpRequestInterceptorCacheBusterProvider.setMatchlist([/.*api.*/, /.*protected.*/], true);

        $urlRouterProvider.otherwise('/');

        $httpProvider.interceptors.push('errorHandlerInterceptor');
        $httpProvider.interceptors.push('authExpiredInterceptor');
        $httpProvider.interceptors.push('authInterceptor');
        $httpProvider.interceptors.push('notificationInterceptor');
        // jhipster-needle-angularjs-add-interceptor JHipster will add new application http interceptor here

        $urlMatcherFactoryProvider.type('boolean', {
            name : 'boolean',
            decode: function(val) { return val === true || val === 'true'; },
            encode: function(val) { return val ? 1 : 0; },
            equals: function(a, b) { return this.is(a) && a === b; },
            is: function(val) { return [true,false,0,1].indexOf(val) >= 0; },
            pattern: /bool|true|0|1/
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .config(compileServiceConfig);

    compileServiceConfig.$inject = ['$compileProvider','DEBUG_INFO_ENABLED'];

    function compileServiceConfig($compileProvider,DEBUG_INFO_ENABLED) {
        // disable debug data on prod profile to improve performance
        $compileProvider.debugInfoEnabled(DEBUG_INFO_ENABLED);

        /*
        If you wish to debug an application with this information
        then you should open up a debug console in the browser
        then call this method directly in this console:

		angular.reloadWithDebugInfo();
		*/
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .config(alertServiceConfig);

    alertServiceConfig.$inject = ['AlertServiceProvider'];

    function alertServiceConfig(AlertServiceProvider) {
        // set below to true to make alerts look like toast
        AlertServiceProvider.showAsToast(false);
    }
})();

(function () {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('app', {
            abstract: true,
            views: {
                'navbar@': {
                    templateUrl: 'app/layouts/navbar/navbar.html',
                    controller: 'NavbarController',
                    controllerAs: 'vm'
                },
                'footer@': {
                    templateUrl: 'app/layouts/footer/footer.html'
                }
            },
            resolve: {
                authorize: ['Auth',
                    function (Auth) {
                        return Auth.authorize();
                    }
                ],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                }],
                availableDates: ['YieldCurveResultsOpen', function (YieldCurveResultsOpen) {
                    return YieldCurveResultsOpen.query({datesOnly: ""}, function (res) {
                        return res.sort();
                    }).$promise;
                }],
                availableDatesCorpAaa: ['CorporateCurveResultsOpen', function (CorporateCurveResultsOpen) {
                    return CorporateCurveResultsOpen.query({datesOnly: "", rating: "aaa"}, function (res) {
                        return res.sort();
                    }).$promise;
                }],
                availableDatesCorpBb: ['CorporateCurveResultsOpen', function (CorporateCurveResultsOpen) {
                    return CorporateCurveResultsOpen.query({datesOnly: "", rating: "bb"}, function (res) {
                        return res.sort();
                    }).$promise;
                }]
            }
        });
    }
})();

(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('moldovaYieldCurvesApp')
        .constant('VERSION', "1.0.0-SNAPSHOT")
        .constant('DEBUG_INFO_ENABLED', false)
;
})();

(function () {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .controller('UserManagementDialogController', UserManagementDialogController);

    UserManagementDialogController.$inject = ['$stateParams', '$uibModalInstance', 'entity', 'User', 'JhiLanguageService'];

    function UserManagementDialogController($stateParams, $uibModalInstance, entity, User, JhiLanguageService) {
        var vm = this;

        vm.authoritiesAll = ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_MODOP', 'ROLE_SUPERUSER', 'ROLE_VALIDATOR'];
        vm.authoritiesNoAdmin = ['ROLE_USER', 'ROLE_MODOP', 'ROLE_SUPERUSER', 'ROLE_VALIDATOR'];
        vm.clear = clear;
        vm.languages = null;
        vm.save = save;
        vm.user = entity;


        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function onSaveSuccess(result) {
            vm.isSaving = false;
            $uibModalInstance.close(result);
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function save() {
            vm.isSaving = true;
            if (vm.user.id !== null) {
                User.update(vm.user, onSaveSuccess, onSaveError);
            } else {
                User.save(vm.user, onSaveSuccess, onSaveError);
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .controller('UserManagementDetailController', UserManagementDetailController);

    UserManagementDetailController.$inject = ['$stateParams', 'User'];

    function UserManagementDetailController ($stateParams, User) {
        var vm = this;

        vm.load = load;
        vm.user = {};

        vm.load($stateParams.login);

        function load (login) {
            User.get({login: login}, function(result) {
                vm.user = result;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .controller('UserManagementDeleteController', UserManagementDeleteController);

    UserManagementDeleteController.$inject = ['$uibModalInstance', 'entity', 'User'];

    function UserManagementDeleteController ($uibModalInstance, entity, User) {
        var vm = this;

        vm.user = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (login) {
            User.delete({login: login},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('user-management', {
            parent: 'admin',
            url: '/user-management?page&sort',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUPERUSER'],
                pageTitle: 'userManagement.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user-management/user-management.html',
                    controller: 'UserManagementController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort)
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('user-management');
                    return $translate.refresh();
                }]

            }        })
        .state('user-management.new', {
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUPERUSER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null, login: null, firstName: null, lastName: null, email: null,
                                activated: true, langKey: null, createdBy: null, createdDate: null,
                                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                                resetKey: null, authorities: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('user-management');
                });
            }]
        })
        .state('user-management.edit', {
            url: '/{login}/edit',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUPERUSER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login});
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('user-management-detail', {
            parent: 'user-management',
            url: '/user/{login}',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUPERUSER'],
                pageTitle: 'user-management.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user-management/user-management-detail.html',
                    controller: 'UserManagementDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('user-management');
                    return $translate.refresh();
                }]
            }
        })
        .state('user-management.delete', {
            url: '/{login}/delete',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUPERUSER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-delete-dialog.html',
                    controller: 'UserManagementDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login});
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .controller('UserManagementController', UserManagementController);

    UserManagementController.$inject = ['Principal', 'User', 'ParseLinks', 'AlertService', '$state', 'pagingParams', 'paginationConstants', 'JhiLanguageService'];

    function UserManagementController(Principal, User, ParseLinks, AlertService, $state, pagingParams, paginationConstants, JhiLanguageService) {
        var vm = this;

        vm.authorities = ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_MODOP', 'ROLE_SUPERUSER', 'ROLE_VALIDATOR'];
        vm.currentAccount = null;
        vm.languages = null;
        vm.loadAll = loadAll;
        vm.setActive = setActive;
        vm.users = [];
        vm.page = 1;
        vm.totalItems = null;
        vm.clear = clear;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.transition = transition;

        vm.loadAll();
        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });
        Principal.identity().then(function (account) {
            vm.currentAccount = account;
        });

        function setActive(user, isActivated) {
            user.activated = isActivated;
            User.update(user, function () {
                vm.loadAll();
                vm.clear();
            });
        }

        function loadAll() {
            User.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
        }

        function onSuccess(data, headers) {
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count');
            vm.queryCount = vm.totalItems;
            vm.page = pagingParams.page;
            vm.users = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function clear() {
            vm.user = {
                id: null, login: null, firstName: null, lastName: null, email: null,
                activated: null, langKey: null, createdBy: null, createdDate: null,
                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                resetKey: null, authorities: null
            };
        }

        function sort() {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-metrics', {
            parent: 'admin',
            url: '/metrics',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'metrics.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/metrics/metrics.html',
                    controller: 'JhiMetricsMonitoringController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('metrics');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .factory('JhiMetricsService', JhiMetricsService);

    JhiMetricsService.$inject = ['$rootScope', '$http'];

    function JhiMetricsService ($rootScope, $http) {
        var service = {
            getMetrics: getMetrics,
            threadDump: threadDump
        };

        return service;

        function getMetrics () {
            return $http.get('management/metrics').then(function (response) {
                return response.data;
            });
        }

        function threadDump () {
            return $http.get('management/dump').then(function (response) {
                return response.data;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .controller('JhiMetricsMonitoringModalController', JhiMetricsMonitoringModalController);

    JhiMetricsMonitoringModalController.$inject = ['$uibModalInstance', 'threadDump'];

    function JhiMetricsMonitoringModalController ($uibModalInstance, threadDump) {
        var vm = this;

        vm.cancel = cancel;
        vm.getLabelClass = getLabelClass;
        vm.threadDump = threadDump;
        vm.threadDumpAll = 0;
        vm.threadDumpBlocked = 0;
        vm.threadDumpRunnable = 0;
        vm.threadDumpTimedWaiting = 0;
        vm.threadDumpWaiting = 0;

        angular.forEach(threadDump, function(value) {
            if (value.threadState === 'RUNNABLE') {
                vm.threadDumpRunnable += 1;
            } else if (value.threadState === 'WAITING') {
                vm.threadDumpWaiting += 1;
            } else if (value.threadState === 'TIMED_WAITING') {
                vm.threadDumpTimedWaiting += 1;
            } else if (value.threadState === 'BLOCKED') {
                vm.threadDumpBlocked += 1;
            }
        });

        vm.threadDumpAll = vm.threadDumpRunnable + vm.threadDumpWaiting +
            vm.threadDumpTimedWaiting + vm.threadDumpBlocked;

        function cancel () {
            $uibModalInstance.dismiss('cancel');
        }

        function getLabelClass (threadState) {
            if (threadState === 'RUNNABLE') {
                return 'label-success';
            } else if (threadState === 'WAITING') {
                return 'label-info';
            } else if (threadState === 'TIMED_WAITING') {
                return 'label-warning';
            } else if (threadState === 'BLOCKED') {
                return 'label-danger';
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .controller('JhiMetricsMonitoringController', JhiMetricsMonitoringController);

    JhiMetricsMonitoringController.$inject = ['$scope','JhiMetricsService', '$uibModal'];

    function JhiMetricsMonitoringController ($scope, JhiMetricsService, $uibModal) {
        var vm = this;

        vm.metrics = {};
        vm.refresh = refresh;
        vm.refreshThreadDumpData = refreshThreadDumpData;
        vm.servicesStats = {};
        vm.updatingMetrics = true;

        vm.refresh();

        $scope.$watch('vm.metrics', function (newValue) {
            vm.servicesStats = {};
            angular.forEach(newValue.timers, function (value, key) {
                if (key.indexOf('web.rest') !== -1 || key.indexOf('service') !== -1) {
                    vm.servicesStats[key] = value;
                }
            });

        });

        function refresh () {
            vm.updatingMetrics = true;
            JhiMetricsService.getMetrics().then(function (promise) {
                vm.metrics = promise;
                vm.updatingMetrics = false;
            }, function (promise) {
                vm.metrics = promise.data;
                vm.updatingMetrics = false;
            });
        }

        function refreshThreadDumpData () {
            JhiMetricsService.threadDump().then(function(data) {
                $uibModal.open({
                    templateUrl: 'app/admin/metrics/metrics.modal.html',
                    controller: 'JhiMetricsMonitoringModalController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        threadDump: function() {
                            return data;
                        }

                    }
                });
            });
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('logs', {
            parent: 'admin',
            url: '/logs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'logs.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/logs/logs.html',
                    controller: 'LogsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('logs');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .factory('LogsService', LogsService);

    LogsService.$inject = ['$resource'];

    function LogsService ($resource) {
        var service = $resource('management/logs', {}, {
            'findAll': { method: 'GET', isArray: true},
            'changeLevel': { method: 'PUT'}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .controller('LogsController', LogsController);

    LogsController.$inject = ['LogsService'];

    function LogsController (LogsService) {
        var vm = this;

        vm.changeLevel = changeLevel;
        vm.loggers = LogsService.findAll();

        function changeLevel (name, level) {
            LogsService.changeLevel({name: name, level: level}, function () {
                vm.loggers = LogsService.findAll();
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-health', {
            parent: 'admin',
            url: '/health',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'health.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/health/health.html',
                    controller: 'JhiHealthCheckController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('health');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .factory('JhiHealthService', JhiHealthService);

    JhiHealthService.$inject = ['$rootScope', '$http'];

    function JhiHealthService ($rootScope, $http) {
        var separator = '.';
        var service = {
            checkHealth: checkHealth,
            transformHealthData: transformHealthData,
            getBaseName: getBaseName,
            getSubSystemName: getSubSystemName
        };

        return service;

        function checkHealth () {
            return $http.get('management/health').then(function (response) {
                return response.data;
            });
        }

        function transformHealthData (data) {
            var response = [];
            flattenHealthData(response, null, data);
            return response;
        }

        function getBaseName (name) {
            if (name) {
                var split = name.split('.');
                return split[0];
            }
        }

        function getSubSystemName (name) {
            if (name) {
                var split = name.split('.');
                split.splice(0, 1);
                var remainder = split.join('.');
                return remainder ? ' - ' + remainder : '';
            }
        }

        /* private methods */
        function flattenHealthData (result, path, data) {
            angular.forEach(data, function (value, key) {
                if (isHealthObject(value)) {
                    if (hasSubSystem(value)) {
                        addHealthObject(result, false, value, getModuleName(path, key));
                        flattenHealthData(result, getModuleName(path, key), value);
                    } else {
                        addHealthObject(result, true, value, getModuleName(path, key));
                    }
                }
            });
            return result;
        }

        function addHealthObject (result, isLeaf, healthObject, name) {

            var healthData = {
                'name': name
            };
            var details = {};
            var hasDetails = false;

            angular.forEach(healthObject, function (value, key) {
                if (key === 'status' || key === 'error') {
                    healthData[key] = value;
                } else {
                    if (!isHealthObject(value)) {
                        details[key] = value;
                        hasDetails = true;
                    }
                }
            });

            // Add the of the details
            if (hasDetails) {
                angular.extend(healthData, { 'details': details});
            }

            // Only add nodes if they provide additional information
            if (isLeaf || hasDetails || healthData.error) {
                result.push(healthData);
            }
            return healthData;
        }

        function getModuleName (path, name) {
            var result;
            if (path && name) {
                result = path + separator + name;
            }  else if (path) {
                result = path;
            } else if (name) {
                result = name;
            } else {
                result = '';
            }
            return result;
        }

        function hasSubSystem (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value) {
                if (value && value.status) {
                    result = true;
                }
            });
            return result;
        }

        function isHealthObject (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value, key) {
                if (key === 'status') {
                    result = true;
                }
            });
            return result;
        }

    }
})();

(function() {
    'use strict';

    angular.module('moldovaYieldCurvesApp')
        .controller('HealthModalController', HealthModalController);

    HealthModalController.$inject = ['$uibModalInstance', 'currentHealth', 'baseName', 'subSystemName'];

    function HealthModalController ($uibModalInstance, currentHealth, baseName, subSystemName) {
        var vm = this;

        vm.cancel = cancel;
        vm.currentHealth = currentHealth;
        vm.baseName = baseName;
        vm.subSystemName = subSystemName;

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .controller('JhiHealthCheckController', JhiHealthCheckController);

    JhiHealthCheckController.$inject = ['JhiHealthService', '$uibModal'];

    function JhiHealthCheckController (JhiHealthService, $uibModal) {
        var vm = this;

        vm.updatingHealth = true;
        vm.getLabelClass = getLabelClass;
        vm.refresh = refresh;
        vm.showHealth = showHealth;
        vm.baseName = JhiHealthService.getBaseName;
        vm.subSystemName = JhiHealthService.getSubSystemName;

        vm.refresh();

        function getLabelClass (statusState) {
            if (statusState === 'UP') {
                return 'label-success';
            } else {
                return 'label-danger';
            }
        }

        function refresh () {
            vm.updatingHealth = true;
            JhiHealthService.checkHealth().then(function (response) {
                vm.healthData = JhiHealthService.transformHealthData(response);
                vm.updatingHealth = false;
            }, function (response) {
                vm.healthData =  JhiHealthService.transformHealthData(response.data);
                vm.updatingHealth = false;
            });
        }

        function showHealth (health) {
            $uibModal.open({
                templateUrl: 'app/admin/health/health.modal.html',
                controller: 'HealthModalController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    currentHealth: function() {
                        return health;
                    },
                    baseName: function() {
                        return vm.baseName;
                    },
                    subSystemName: function() {
                        return vm.subSystemName;
                    }

                }
            });
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('docs', {
            parent: 'admin',
            url: '/docs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'global.menu.admin.apidocs'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/docs/docs.html'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', function ($translate) {
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-configuration', {
            parent: 'admin',
            url: '/configuration',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'configuration.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/configuration/configuration.html',
                    controller: 'JhiConfigurationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('configuration');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .factory('JhiConfigurationService', JhiConfigurationService);

    JhiConfigurationService.$inject = ['$filter', '$http'];

    function JhiConfigurationService ($filter, $http) {
        var service = {
            get: get,
            getEnv: getEnv
        };

        return service;

        function get () {
            return $http.get('management/configprops').then(getConfigPropsComplete);

            function getConfigPropsComplete (response) {
                var properties = [];
                angular.forEach(response.data, function (data) {
                    properties.push(data);
                });
                var orderBy = $filter('orderBy');
                return orderBy(properties, 'prefix');
            }
        }

        function getEnv () {
            return $http.get('management/env').then(getEnvComplete);

            function getEnvComplete (response) {
                var properties = {};
                angular.forEach(response.data, function (val,key) {
                    var vals = [];
                    angular.forEach(val, function (v,k) {
                        vals.push({ key:k, val:v });
                    });
                    properties[key] = vals;
                });
                return properties;
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .controller('JhiConfigurationController', JhiConfigurationController);

    JhiConfigurationController.$inject = ['$filter','JhiConfigurationService'];

    function JhiConfigurationController (filter,JhiConfigurationService) {
        var vm = this;

        vm.allConfiguration = null;
        vm.configuration = null;

        JhiConfigurationService.get().then(function(configuration) {
            vm.configuration = configuration;
        });
        JhiConfigurationService.getEnv().then(function (configuration) {
            vm.allConfiguration = configuration;
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('audits', {
            parent: 'admin',
            url: '/audits',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'audits.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/audits/audits.html',
                    controller: 'AuditsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('audits');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .factory('AuditsService', AuditsService);

    AuditsService.$inject = ['$resource'];

    function AuditsService ($resource) {
        var service = $resource('management/audits/:id', {}, {
            'get': {
                method: 'GET',
                isArray: true
            },
            'query': {
                method: 'GET',
                isArray: true,
                params: {fromDate: null, toDate: null}
            }
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .controller('AuditsController', AuditsController);

    AuditsController.$inject = ['$filter', 'AuditsService', 'ParseLinks'];

    function AuditsController ($filter, AuditsService, ParseLinks) {
        var vm = this;

        vm.audits = null;
        vm.fromDate = null;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.onChangeDate = onChangeDate;
        vm.page = 1;
        vm.previousMonth = previousMonth;
        vm.toDate = null;
        vm.today = today;
        vm.totalItems = null;

        vm.today();
        vm.previousMonth();
        vm.onChangeDate();

        function onChangeDate () {
            var dateFormat = 'yyyy-MM-dd';
            var fromDate = $filter('date')(vm.fromDate, dateFormat);
            var toDate = $filter('date')(vm.toDate, dateFormat);

            AuditsService.query({page: vm.page -1, size: 20, fromDate: fromDate, toDate: toDate}, function(result, headers){
                vm.audits = result;
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
            });
        }

        // Date picker configuration
        function today () {
            // Today + 1 day - needed if the current day must be included
            var today = new Date();
            vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
        }

        function previousMonth () {
            var fromDate = new Date();
            if (fromDate.getMonth() === 0) {
                fromDate = new Date(fromDate.getFullYear() - 1, 11, fromDate.getDate());
            } else {
                fromDate = new Date(fromDate.getFullYear(), fromDate.getMonth() - 1, fromDate.getDate());
            }

            vm.fromDate = fromDate;
        }

        function loadPage (page) {
            vm.page = page;
            vm.onChangeDate();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('admin', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('settings', {
            parent: 'account',
            url: '/settings',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.menu.account.settings'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/settings/settings.html',
                    controller: 'SettingsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('settings');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .controller('SettingsController', SettingsController);

    SettingsController.$inject = ['Principal', 'Auth', 'JhiLanguageService', '$translate'];

    function SettingsController (Principal, Auth, JhiLanguageService, $translate) {
        var vm = this;

        vm.error = null;
        vm.save = save;
        vm.settingsAccount = null;
        vm.success = null;

        /**
         * Store the "settings account" in a separate variable, and not in the shared "account" variable.
         */
        var copyAccount = function (account) {
            return {
                activated: account.activated,
                email: account.email,
                firstName: account.firstName,
                langKey: account.langKey,
                lastName: account.lastName,
                login: account.login
            };
        };

        Principal.identity().then(function(account) {
            vm.settingsAccount = copyAccount(account);
        });

        function save () {
            Auth.updateAccount(vm.settingsAccount).then(function() {
                vm.error = null;
                vm.success = 'OK';
                Principal.identity(true).then(function(account) {
                    vm.settingsAccount = copyAccount(account);
                });
                JhiLanguageService.getCurrent().then(function(current) {
                    if (vm.settingsAccount.langKey !== current) {
                        $translate.use(vm.settingsAccount.langKey);
                    }
                });
            }).catch(function() {
                vm.success = null;
                vm.error = 'ERROR';
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('requestReset', {
            parent: 'account',
            url: '/reset/request',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/request/reset.request.html',
                    controller: 'RequestResetController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .controller('RequestResetController', RequestResetController);

    RequestResetController.$inject = ['$timeout', 'Auth'];

    function RequestResetController ($timeout, Auth) {
        var vm = this;

        vm.error = null;
        vm.errorEmailNotExists = null;
        vm.requestReset = requestReset;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#email').focus();});

        function requestReset () {

            vm.error = null;
            vm.errorEmailNotExists = null;

            Auth.resetPasswordInit(vm.resetAccount.email).then(function () {
                vm.success = 'OK';
            }).catch(function (response) {
                vm.success = null;
                if (response.status === 400 && response.data === 'e-mail address not registered') {
                    vm.errorEmailNotExists = 'ERROR';
                } else {
                    vm.error = 'ERROR';
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('finishReset', {
            parent: 'account',
            url: '/reset/finish?key',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/finish/reset.finish.html',
                    controller: 'ResetFinishController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .controller('ResetFinishController', ResetFinishController);

    ResetFinishController.$inject = ['$stateParams', '$timeout', 'Auth', 'LoginService'];

    function ResetFinishController ($stateParams, $timeout, Auth, LoginService) {
        var vm = this;

        vm.keyMissing = angular.isUndefined($stateParams.key);
        vm.confirmPassword = null;
        vm.doNotMatch = null;
        vm.error = null;
        vm.finishReset = finishReset;
        vm.login = LoginService.open;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#password').focus();});

        function finishReset() {
            vm.doNotMatch = null;
            vm.error = null;
            if (vm.resetAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                Auth.resetPasswordFinish({key: $stateParams.key, newPassword: vm.resetAccount.password}).then(function () {
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('register', {
            parent: 'account',
            url: '/register',
            data: {
                authorities: [],
                pageTitle: 'register.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/register/register.html',
                    controller: 'RegisterController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('register');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .controller('RegisterController', RegisterController);


    RegisterController.$inject = ['$translate', '$timeout', 'Auth', 'LoginService'];

    function RegisterController ($translate, $timeout, Auth, LoginService) {
        var vm = this;

        vm.doNotMatch = null;
        vm.error = null;
        vm.errorUserExists = null;
        vm.login = LoginService.open;
        vm.register = register;
        vm.registerAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#login').focus();});

        function register () {
            if (vm.registerAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                vm.registerAccount.langKey = $translate.use();
                vm.doNotMatch = null;
                vm.error = null;
                vm.errorUserExists = null;
                vm.errorEmailExists = null;

                Auth.createAccount(vm.registerAccount).then(function () {
                    vm.success = 'OK';
                }).catch(function (response) {
                    vm.success = null;
                    if (response.status === 400 && response.data === 'login already in use') {
                        vm.errorUserExists = 'ERROR';
                    } else if (response.status === 400 && response.data === 'e-mail address already in use') {
                        vm.errorEmailExists = 'ERROR';
                    } else {
                        vm.error = 'ERROR';
                    }
                });
            }
        }
    }
})();

/* globals $ */
(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .directive('passwordStrengthBar', passwordStrengthBar);

    function passwordStrengthBar () {
        var directive = {
            replace: true,
            restrict: 'E',
            template: '<div id="strength">' +
                '<small data-translate="global.messages.validate.newpassword.strength">Password strength:</small>' +
                '<ul id="strengthBar">' +
                '<li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li>' +
                '</ul>' +
                '</div>',
            scope: {
                passwordToCheck: '='
            },
            link: linkFunc
        };

        return directive;

        /* private helper methods*/

        function linkFunc(scope, iElement) {
            var strength = {
                colors: ['#F00', '#F90', '#FF0', '#9F0', '#0F0'],
                mesureStrength: function (p) {

                    var _force = 0;
                    var _regex = /[$-/:-?{-~!"^_`\[\]]/g; // "

                    var _lowerLetters = /[a-z]+/.test(p);
                    var _upperLetters = /[A-Z]+/.test(p);
                    var _numbers = /[0-9]+/.test(p);
                    var _symbols = _regex.test(p);

                    var _flags = [_lowerLetters, _upperLetters, _numbers, _symbols];
                    var _passedMatches = $.grep(_flags, function (el) {
                        return el === true;
                    }).length;

                    _force += 2 * p.length + ((p.length >= 10) ? 1 : 0);
                    _force += _passedMatches * 10;

                    // penalty (short password)
                    _force = (p.length <= 6) ? Math.min(_force, 10) : _force;

                    // penalty (poor variety of characters)
                    _force = (_passedMatches === 1) ? Math.min(_force, 10) : _force;
                    _force = (_passedMatches === 2) ? Math.min(_force, 20) : _force;
                    _force = (_passedMatches === 3) ? Math.min(_force, 40) : _force;

                    return _force;

                },
                getColor: function (s) {

                    var idx;
                    if (s <= 10) {
                        idx = 0;
                    }
                    else if (s <= 20) {
                        idx = 1;
                    }
                    else if (s <= 30) {
                        idx = 2;
                    }
                    else if (s <= 40) {
                        idx = 3;
                    }
                    else {
                        idx = 4;
                    }

                    return { idx: idx + 1, col: this.colors[idx] };
                }
            };
            scope.$watch('passwordToCheck', function (password) {
                if (password) {
                    var c = strength.getColor(strength.mesureStrength(password));
                    iElement.removeClass('ng-hide');
                    iElement.find('ul').children('li')
                        .css({ 'background-color': '#DDD' })
                        .slice(0, c.idx)
                        .css({ 'background-color': c.col });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('password', {
            parent: 'account',
            url: '/password',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.menu.account.password'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/password/password.html',
                    controller: 'PasswordController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('password');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .controller('PasswordController', PasswordController);

    PasswordController.$inject = ['Auth', 'Principal'];

    function PasswordController (Auth, Principal) {
        var vm = this;

        vm.changePassword = changePassword;
        vm.doNotMatch = null;
        vm.error = null;
        vm.success = null;

        Principal.identity().then(function(account) {
            vm.account = account;
        });

        function changePassword () {
            if (vm.password !== vm.confirmPassword) {
                vm.error = null;
                vm.success = null;
                vm.doNotMatch = 'ERROR';
            } else {
                vm.doNotMatch = null;
                Auth.changePassword(vm.password).then(function () {
                    vm.error = null;
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('activate', {
            parent: 'account',
            url: '/activate?key',
            data: {
                authorities: [],
                pageTitle: 'activate.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/activate/activate.html',
                    controller: 'ActivationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('activate');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .controller('ActivationController', ActivationController);

    ActivationController.$inject = ['$stateParams', 'Auth', 'LoginService'];

    function ActivationController ($stateParams, Auth, LoginService) {
        var vm = this;

        Auth.activateAccount({key: $stateParams.key}).then(function () {
            vm.error = null;
            vm.success = 'OK';
        }).catch(function () {
            vm.success = null;
            vm.error = 'ERROR';
        });

        vm.login = LoginService.open;
    }
})();

(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('account', {
            abstract: true,
            parent: 'app'
        });
    }
})();
(function(){angular.module('moldovaYieldCurvesApp').run(['$templateCache', function($templateCache) {$templateCache.put('app/ext/ext-en.html','<div ng-cloak><div class="row"><div class="col-md-12"><!--            <h1>Moldova | Yield Curves</h1>--><div class="row"><div class="col-lg-9 col-md-8 thumbnail chart-pane"><div data-yield-curve-chart data-chart-data="vm.chartData" data-min-tenor="vm.chartMinTenor" data-max-tenor="vm.chartMaxTenor" data-curve-type="vm.curveType" data-y-axis-title="vm.yAxisTitle" data-is-spline="vm.isSplineInterpolated" data-lang-key="\'en\'"></div></div><div class="col-lg-3 col-md-4"><div class="thumbnail" style="text-align: center"><!--                        <h3>Add Curve</h3>--><div style="display:inline-block; min-height:290px"><multiple-date-picker ng-model="vm.selectedDates" day-click="vm.onDaySelected" days-allowed="vm.availableDates" month="vm.activeMonth"></multiple-date-picker></div><div style="padding: 10px 5px"><a type="button" class="btn btn-default btn-md" title="Clear selected dates" ng-click="vm.clearDates()"><span>Clear</span></a></div></div><div class="row"><div class="col-xs-6"><div class="thumbnail" style="text-align: center"><h3 title="Type of the yield curve - Zero or Par">Curve Type</h3><div class="btn-group btn-group-justified btn-group-sm" role="group" style="padding: 10px 5px"><a type="button" class="btn btn-default no-padding-left no-padding-right" ng-click="vm.zeroCurveSelected()" ng-class="{active: vm.curveType==\'zero\'}" title="Zero Curve">Zero </a><a type="button" class="btn btn-default no-padding-left no-padding-right" ng-click="vm.parCurveSelected()" ng-class="{active: vm.curveType==\'par\'}" title="Par Curve">Par</a></div></div></div><div class="col-xs-6"><div class="thumbnail" style="text-align: center"><h3 title="Maximum tenor on the chart">Curve Range</h3><div style="font-size: small">{{vm.curveRangeLimit}} <span>{{vm.sliderTitle}}</span></div><div style="padding: 6px 10px"><slider ng-model="vm.curveRangeModel" ng-change="vm.onCurveRangeChanged()" on-stop-slide="vm.onCurveRangeSaved()" min="vm.minSlider" max="vm.maxSlider" step="vm.sliderStep" tooltip="hide"></slider></div></div></div></div><div class="row"><div class="col-sm-4 col-md-12" style="padding-bottom: 5px"><a type="button" class="btn btn-default btn-block btn-md" title="Download Excel file with the selected curves" ng-click="vm.onExcelExportClicked()" ng-class="{disabled: (!vm.selectedDates || vm.selectedDates.length == 0)}"><span class="glyphicon glyphicon-download-alt"></span>&nbsp;| <span>Export Data</span></a></div><div class="col-sm-4 col-md-12" style="padding-bottom: 5px"><a type="button" class="btn btn-default btn-block btn-md" title="Download Excel file with the parameters of selected curves" ng-click="vm.onParamsExportClicked()"><span class="glyphicon glyphicon-download"></span>&nbsp;| <span>Export Betas</span></a></div><div class="col-sm-4 col-md-12" style="padding-bottom: 5px"><a type="button" class="btn btn-default btn-block btn-md" title="Download all published results and parameters" ng-click="vm.onExportAllClicked()"><span class="glyphicon glyphicon-download-alt"></span>&nbsp; <span class="glyphicon glyphicon-download"></span>&nbsp;| <span>Export All</span><div class="loading-spinner" ng-if="vm.longDownload"></div></a></div></div></div></div></div></div></div>');
$templateCache.put('app/ext/ext-ro.html','<div ng-cloak><div class="row"><div class="col-md-12"><!--            <h1>Moldova | Yield Curves</h1>--><div class="row"><div class="col-lg-9 col-md-8 thumbnail chart-pane"><div data-yield-curve-chart data-chart-data="vm.chartData" data-min-tenor="vm.chartMinTenor" data-max-tenor="vm.chartMaxTenor" data-curve-type="vm.curveType" data-y-axis-title="vm.yAxisTitle" data-is-spline="vm.isSplineInterpolated" data-lang-key="\'ro\'"></div></div><div class="col-lg-3 col-md-4"><div class="thumbnail" style="text-align: center"><!--                        <h3>Add Curve</h3>--><div style="display:inline-block; min-height:290px"><multiple-date-picker ng-model="vm.selectedDates" day-click="vm.onDaySelected" days-allowed="vm.availableDates" month="vm.activeMonth"></multiple-date-picker></div><div style="padding: 10px 5px"><a type="button" class="btn btn-default btn-md" title="\u0218terge datele selectate" ng-click="vm.clearDates()"><span>\u0218terge selecta\u021Bia</span></a></div></div><div class="row"><div class="col-xs-6"><div class="thumbnail" style="text-align: center"><h3 title="Tipul curbei - zero sau par">Tipul curbei</h3><div class="btn-group btn-group-justified btn-group-sm" role="group" style="padding: 10px 5px"><a type="button" class="btn btn-default no-padding-left no-padding-right" ng-click="vm.zeroCurveSelected()" ng-class="{active: vm.curveType==\'zero\'}" title="Curba zero">Zero </a><a type="button" class="btn btn-default no-padding-left no-padding-right" ng-click="vm.parCurveSelected()" ng-class="{active: vm.curveType==\'par\'}" title="Curba par">Par</a></div></div></div><div class="col-xs-6"><div class="thumbnail" style="text-align: center"><h3 title="Scaden\u021Ba maxim\u0103 pe grafic">Intervalul curbei</h3><div style="font-size: small">{{vm.curveRangeLimit}} <span>{{vm.sliderTitle}}</span></div><div style="padding: 6px 10px"><slider ng-model="vm.curveRangeModel" ng-change="vm.onCurveRangeChanged()" on-stop-slide="vm.onCurveRangeSaved()" min="vm.minSlider" max="vm.maxSlider" step="vm.sliderStep" tooltip="hide"></slider></div></div></div></div><div class="row"><div class="col-sm-4 col-md-12" style="padding-bottom: 5px"><a type="button" class="btn btn-default btn-block btn-md" title="Descarc\u0103 fi\u0219ierul Excel cu curbele selectate" ng-click="vm.onExcelExportClicked()" ng-class="{disabled: (!vm.selectedDates || vm.selectedDates.length == 0)}"><span class="glyphicon glyphicon-download-alt"></span>&nbsp;| <span>Export\u0103 datele</span></a></div><div class="col-sm-4 col-md-12" style="padding-bottom: 5px"><a type="button" class="btn btn-default btn-block btn-md" title="Descarc\u0103 fi\u0219ierul Excel cu parametrii curbelor selectate" ng-click="vm.onParamsExportClicked()"><span class="glyphicon glyphicon-download"></span>&nbsp;| <span>Export\u0103 beta</span></a></div><div class="col-sm-4 col-md-12" style="padding-bottom: 5px"><a type="button" class="btn btn-default btn-block btn-md" title="Descarc\u0103 toate rezultatele \u0219i parametrii publica\u021Bi" ng-click="vm.onExportAllClicked()"><span class="glyphicon glyphicon-download-alt"></span>&nbsp; <span class="glyphicon glyphicon-download"></span>&nbsp;| <span>Export\u0103 tot</span><div class="loading-spinner" ng-if="vm.longDownload"></div></a></div></div></div></div></div></div></div>');
$templateCache.put('app/ext/ext-ru.html','<div ng-cloak><div class="row"><div class="col-md-12"><!--            <h1>Moldova | Yield Curves</h1>--><div class="row"><div class="col-lg-9 col-md-8 thumbnail chart-pane"><div data-yield-curve-chart data-chart-data="vm.chartData" data-min-tenor="vm.chartMinTenor" data-max-tenor="vm.chartMaxTenor" data-curve-type="vm.curveType" data-y-axis-title="vm.yAxisTitle" data-is-spline="vm.isSplineInterpolated" data-lang-key="\'ru\'"></div></div><div class="col-lg-3 col-md-4"><div class="thumbnail" style="text-align: center"><div style="display:inline-block; min-height:290px"><multiple-date-picker ng-model="vm.selectedDates" day-click="vm.onDaySelected" days-allowed="vm.availableDates" month="vm.activeMonth"></multiple-date-picker></div><div style="padding: 10px 5px"><a type="button" class="btn btn-default btn-md" title="\u0421\u0431\u0440\u043E\u0441\u0438\u0442\u044C \u0432\u044B\u0431\u0440\u0430\u043D\u043D\u044B\u0435 \u0434\u0430\u0442\u044B" ng-click="vm.clearDates()"><span>\u041E\u0442\u043C\u0435\u043D\u0438\u0442\u044C \u0432\u044B\u0431\u043E\u0440</span></a></div></div><div class="row"><div class="col-xs-6"><div class="thumbnail" style="text-align: center"><h3 title="\u0422\u0438\u043F \u043A\u0440\u0438\u0432\u043E\u0439 \u0434\u043E\u0445\u043E\u0434\u043D\u043E\u0441\u0442\u0438 - \u0431\u0435\u0441\u043A\u0443\u043F\u043E\u043D\u043D\u0430\u044F \u0438\u043B\u0438 \u043F\u043E \u043D\u043E\u043C\u0438\u043D\u0430\u043B\u0443">\u0422\u0438\u043F \u041A\u0440\u0438\u0432\u043E\u0439</h3><div class="btn-group btn-group-justified btn-group-sm" role="group" style="padding: 10px 5px"><a type="button" class="btn btn-default no-padding-left no-padding-right" ng-click="vm.zeroCurveSelected()" ng-class="{active: vm.curveType==\'zero\'}" title="\u041A\u0440\u0438\u0432\u0430\u044F \u0411\u0435\u0441\u043A\u0443\u043F\u043E\u043D\u043D\u043E\u0439 \u0414\u043E\u0445\u043E\u0434\u043D\u043E\u0441\u0442\u0438">Zero </a><a type="button" class="btn btn-default no-padding-left no-padding-right" ng-click="vm.parCurveSelected()" ng-class="{active: vm.curveType==\'par\'}" title="\u041A\u0440\u0438\u0432\u0430\u044F \u0414\u043E\u0445\u043E\u0434\u043D\u043E\u0441\u0442\u0438 \u043F\u043E \u041D\u043E\u043C\u0438\u043D\u0430\u043B\u0443">Par</a></div></div></div><div class="col-xs-6"><div class="thumbnail" style="text-align: center"><h3 title="\u041C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u044B\u0439 \u0441\u0440\u043E\u043A \u043F\u043E\u0433\u0430\u0448\u0435\u043D\u0438\u044F \u043D\u0430 \u0433\u0440\u0430\u0444\u0438\u043A\u0435">\u0414\u0438\u0430\u043F\u0430\u0437\u043E\u043D</h3><div style="font-size: small">{{vm.curveRangeLimit}} <span>{{vm.sliderTitle}}</span></div><div style="padding: 6px 10px"><slider ng-model="vm.curveRangeModel" ng-change="vm.onCurveRangeChanged()" on-stop-slide="vm.onCurveRangeSaved()" min="vm.minSlider" max="vm.maxSlider" step="vm.sliderStep" tooltip="hide"></slider></div></div></div></div><div class="row"><div class="col-sm-4 col-md-12" style="padding-bottom: 5px"><a type="button" class="btn btn-default btn-block btn-md" title="\u0421\u043A\u0430\u0447\u0430\u0442\u044C Excel \u0444\u0430\u0439\u043B \u0441 \u0432\u044B\u0431\u0440\u0430\u043D\u043D\u044B\u043C\u0438 \u043A\u0440\u0438\u0432\u044B\u043C\u0438" ng-click="vm.onExcelExportClicked()" ng-class="{disabled: (!vm.selectedDates || vm.selectedDates.length == 0)}"><span class="glyphicon glyphicon-download-alt"></span>&nbsp;| <span>\u0421\u043A\u0430\u0447\u0430\u0442\u044C \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u044B</span></a></div><div class="col-sm-4 col-md-12" style="padding-bottom: 5px"><a type="button" class="btn btn-default btn-block btn-md" title="\u0421\u043A\u0430\u0447\u0430\u0442\u044C Excel \u0444\u0430\u0439\u043B \u0441 \u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u0430\u043C\u0438 \u0432\u044B\u0431\u0440\u0430\u043D\u043D\u044B\u0445 \u043A\u0440\u0438\u0432\u044B\u0445" ng-click="vm.onParamsExportClicked()"><span class="glyphicon glyphicon-download"></span>&nbsp;| <span>\u0421\u043A\u0430\u0447\u0430\u0442\u044C \u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u044B</span></a></div><div class="col-sm-4 col-md-12" style="padding-bottom: 5px"><a type="button" class="btn btn-default btn-block btn-md" title="\u0421\u043A\u0430\u0447\u0430\u0442\u044C \u0432\u0441\u0435 \u043E\u043F\u0443\u0431\u043B\u0438\u043A\u043E\u0432\u0430\u043D\u043D\u044B\u0435 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u044B \u0438 \u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u044B" ng-click="vm.onExportAllClicked()"><span class="glyphicon glyphicon-download-alt"></span>&nbsp; <span class="glyphicon glyphicon-download"></span>&nbsp;| <span>\u0421\u043A\u0430\u0447\u0430\u0442\u044C \u0432\u0441\u0435</span><div class="loading-spinner" ng-if="vm.longDownload"></div></a></div></div></div></div></div></div></div>');
$templateCache.put('app/home/home.html','<div ng-cloak><div class="row"><!--        <div class="col-md-12">--><!--            <a type="button"--><!--               ui-sref="home.faq"--><!--               title="{{\'home.faq.buttonTitle\' | translate}}"--><!--               class="btn btn-default btn-md pull-right">--><!--                <span class="glyphicon glyphicon-question-sign"></span>&nbsp;|--><!--                <span data-translate="home.faq.button">FAQ</span>--><!--            </a>--><!--        </div>--><div class="col-md-12"><!--<div class="row">--><!--<div class="col-xs-9">--><h1 data-translate="home.title">Sovereign Yield Curve</h1><!--</div>--><!--<div class="col-xs-3">--><!--<h1>></h1>--><!--</div>--><!--</div>--><div class="row"><div class="col-lg-9 col-md-8 thumbnail chart-pane"><div data-yield-curve-chart data-chart-data="vm.chartData" data-min-tenor="vm.chartMinTenor" data-max-tenor="vm.chartMaxTenor" data-curve-type="vm.curveType" data-y-axis-title="vm.yAxisTitle" data-is-spline="vm.isSplineInterpolated" data-lang-key="vm.langKey"></div><div class="threshold-footnote" ng-if="vm.curveType === \'zero\' && vm.thresholdDate" data-translate="home.thresholdNote" translate-values="{date: \'{{vm.thresholdDate}}\'}"></div></div><div class="col-lg-3 col-md-4"><div class="thumbnail" style="text-align: center"><!--                        <h3 data-translate="home.addCurve">Add Curve</h3>--><div style="display:inline-block; min-height:290px"><multiple-date-picker ng-model="vm.selectedDates" day-click="vm.onDaySelected" days-allowed="vm.availableDates" month="vm.activeMonth"></multiple-date-picker></div><div style="padding: 10px 5px"><a type="button" class="btn btn-default btn-md" title="{{\'home.clearSelectedDatesTooltip\' | translate}}" ng-click="vm.clearDates()"><span translate="home.clearSelectedDates">Clear</span></a></div></div><div class="row"><div class="col-xs-6"><div class="thumbnail" style="text-align: center"><h3 data-translate="home.curveType" title="{{\'home.curveTypeTooltip\' | translate}}">Curve Type</h3><div class="btn-group btn-group-justified btn-group-sm" role="group" style="padding: 10px 5px"><a type="button" class="btn btn-default no-padding-left no-padding-right" ng-click="vm.zeroCurveSelected()" ng-class="{active: vm.curveType==\'zero\'}" title="{{\'home.zeroCurveButton\' | translate}}">Zero </a><a type="button" class="btn btn-default no-padding-left no-padding-right" ng-click="vm.parCurveSelected()" ng-class="{active: vm.curveType==\'par\'}" title="{{\'home.parCurveButton\' | translate}}">Par</a></div></div></div><div class="col-xs-6"><div class="thumbnail" style="text-align: center"><h3 data-translate="home.curveRange" title="{{\'home.curveRangeTooltip\' | translate}}">Curve Range</h3><div style="font-size: small">{{vm.curveRangeLimit}} <span ng-if="vm.langKey !== \'ru\' || vm.curveRangeLimit > 4" translate="home.sliderTitle"></span> <span ng-if="vm.langKey === \'ru\' && vm.curveRangeLimit <= 4" translate="home.sliderTitle2"></span></div><div style="padding: 6px 10px"><slider ng-model="vm.curveRangeModel" ng-change="vm.onCurveRangeChanged()" on-stop-slide="vm.onCurveRangeSaved()" min="vm.minSlider" max="vm.maxSlider" step="vm.sliderStep" tooltip="hide"></slider></div></div></div></div><div class="row"><div class="col-sm-4 col-md-12" style="padding-bottom: 5px"><a type="button" class="btn btn-default btn-block btn-md" title="{{\'home.exportDataTooltip\' | translate}}" ng-click="vm.onExcelExportClicked()" ng-class="{disabled: (!vm.selectedDates || vm.selectedDates.length == 0)}"><span class="glyphicon glyphicon-download-alt"></span>&nbsp;| <span translate="home.exportData">Export Data</span></a></div><div class="col-sm-4 col-md-12" style="padding-bottom: 5px"><a type="button" class="btn btn-default btn-block btn-md" title="{{\'home.exportNSParamsTooltip\' | translate}}" ng-click="vm.onParamsExportClicked()"><span class="glyphicon glyphicon-download"></span>&nbsp;| <span translate="home.exportNSParams">Export Betas</span></a></div><div class="col-sm-4 col-md-12" style="padding-bottom: 5px"><a type="button" class="btn btn-default btn-block btn-md" title="{{\'home.exportAllTooltip\' | translate}}" ng-click="vm.onExportAllClicked()"><span class="glyphicon glyphicon-download-alt"></span>&nbsp; <span class="glyphicon glyphicon-download"></span>&nbsp;| <span translate="home.exportAll">Export All</span><div class="loading-spinner" ng-if="vm.longDownload"></div></a></div><div class="col-sm-4 col-md-12" style="padding-bottom: 5px"><div ng-switch="vm.isAuthenticated()"><div ng-switch-when="true"><div has-any-authority="ROLE_USER,ROLE_MODOP,ROLE_ADMIN,ROLE_SUPERUSER,ROLE_VALIDATOR"><a type="button" class="btn btn-default btn-block btn-md" title="{{\'home.exportPaperErrorsTitle\' | translate}}" ng-click="vm.onErrorsExportClicked()"><span class="glyphicon glyphicon-download"></span>&nbsp;| <span translate="home.exportPaperErrors">Export Errors</span></a></div></div></div></div><div class="col-sm-4 col-md-12" style="padding-bottom: 5px"><div ng-switch="vm.isAuthenticated()"><div ng-switch-when="true"><div has-any-authority="ROLE_USER,ROLE_MODOP,ROLE_ADMIN,ROLE_SUPERUSER,ROLE_VALIDATOR"><a type="button" class="btn btn-default btn-block btn-md" title="{{\'home.getObsDataTitle\' | translate}}" ng-click="vm.onGetObsClicked()"><span class="glyphicon glyphicon-download"></span>&nbsp;| <span translate="home.getObsData">Observed Data</span></a></div></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/home/yc-faq.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h2 class="modal-title" data-translate="home.faq.title"></h2></div><div class="modal-body"><div><h3 data-translate="home.faq.q1"></h3><div data-translate="home.faq.par1"></div><h3 data-translate="home.faq.q2"></h3><div data-translate="home.faq.par2"></div><h3 data-translate="home.faq.q3" id="q3"></h3><div data-translate="home.faq.par3"></div><h3 data-translate="home.faq.q4"></h3><div data-translate="home.faq.par4"></div><h3 data-translate="home.faq.q5"></h3><div data-translate="home.faq.par5"></div><h3 data-translate="home.faq.q6"></h3><div data-translate="home.faq.par6"></div><h3 data-translate="home.faq.q7"></h3><div><p data-translate="home.faq.par7p1"></p><p data-translate="home.faq.par7p2"></p><p><span data-translate="home.faq.par7p3f1"></span><katex expr="D1=0.943/1.03=0.916"></katex>,<katex expr="D2=0.885/1.03^2=0.834"></katex>,<katex expr="D3=0.825/1.03^3=0.755"></katex>,<katex expr="D4=0.768/1.03^4=0.682"></katex>, <span data-translate="home.faq.par7p3f2"></span><katex expr="D5=0.713/1.03^5=0.615"></katex><span data-translate="home.faq.par7p3f3"></span><katex expr="{100000}/{(D1+D2+D3+D4+D5)}={100000}/{3.802}=26301"></katex><span data-translate="home.faq.par7p3f4"></span></p></div><h3 data-translate="home.faq.q8"></h3><div data-translate="home.faq.par8"></div><h3 data-translate="home.faq.q9"></h3><div data-translate="home.faq.par9"></div><h3 data-translate="home.faq.q10"></h3><div><p><span data-translate="home.faq.par10p1"></span></p><p><span data-translate="home.faq.par10p2"></span></p></div><h3 data-translate="home.faq.q11"></h3><div><p><span data-translate="home.faq.par11p1"></span></p><p><span data-translate="home.faq.par11p2"></span></p></div><h3 data-translate="home.faq.q12"></h3><div data-translate="home.faq.par12"></div><h3 data-translate="home.faq.q13"></h3><div><p><span data-translate="home.faq.par13p1f1"></span><katex expr="\\beta_0=7.713"></katex>,<katex expr="\\beta_1=-2.196"></katex>,<katex expr="\\beta_2=-1.433"></katex>, <span data-translate="home.faq.par13p1f2"></span><katex expr="\\lambda=0.001965"></katex><span data-translate="home.faq.par13p1f3"></span><katex expr="t=1096"></katex><span data-translate="home.faq.par13p1f4"></span><katex display-mode expr="Y=\\beta_0+\n                       \\beta_1\\cdot\\dfrac{1-e^{-\\lambda t}}{\\lambda t}+\n                       \\beta_2\\cdot\\left[\\dfrac{1-e^{-\\lambda t}}{\\lambda t}-e^{-\\lambda t}\\right]=\n                       \\beta_0+\\beta_1\\cdot0.4104+\\beta_2\\cdot0.2944=6.390\\%"></katex></p><p><span data-translate="home.faq.par13p2f1"></span><katex expr="100\\cdot\\left(e^{6.390/100}-1\\right)=6.599\\%"></katex><span data-translate="home.faq.par13p2f2"></span><katex expr="\\exp\\left(\\dfrac{-6.390\\cdot t}{365\\cdot100}\\right)=0.8254"></katex><span data-translate="home.faq.par13p2f3"></span></p></div><h3 data-translate="home.faq.q14"></h3><div data-translate="home.faq.par14"></div><h3 data-translate="home.faq.q15"></h3><div data-translate="home.faq.par15"></div></div></div>');
$templateCache.put('app/account/activate/activate.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1 data-translate="activate.title">Activation</h1><div class="alert alert-success" ng-show="vm.success" data-translate="activate.messages.success" translate-compile><strong>Your user has been activated.</strong> Please <a class="alert-link" href="" ng-click="vm.login()">sign in</a>.</div><div class="alert alert-danger" ng-show="vm.error" data-translate="activate.messages.error"><strong>Your user could not be activated.</strong> Please use the registration form to sign up.</div></div></div></div>');
$templateCache.put('app/account/password/password.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h2 data-translate="password.title" translate-values="{username: \'{{vm.account.login}}\'}">Password for [<b>{{vm.account.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success" data-translate="password.messages.success"><strong>Password changed!</strong></div><div class="alert alert-danger" ng-show="vm.error" data-translate="password.messages.error"><strong>An error has occurred!</strong> The password could not be changed.</div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div><form name="form" role="form" novalidate ng-submit="vm.changePassword()" show-validation><div class="form-group"><label class="control-label" for="password" data-translate="global.form.newpassword">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" data-translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your confirmation password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="password.form.button">Save</button></form></div></div></div>');
$templateCache.put('app/account/register/register.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1 data-translate="register.title">Registration</h1><div class="alert alert-success" ng-show="vm.success" data-translate="register.messages.success"><strong>Registration saved!</strong> Please check your email for confirmation.</div><div class="alert alert-danger" ng-show="vm.error" data-translate="register.messages.error.fail"><strong>Registration failed!</strong> Please try again later.</div><div class="alert alert-danger" ng-show="vm.errorUserExists" data-translate="register.messages.error.userexists"><strong>Login name already registered!</strong> Please choose another one.</div><div class="alert alert-danger" ng-show="vm.errorEmailExists" data-translate="register.messages.error.emailexists"><strong>E-mail is already in use!</strong> Please choose another one.</div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div></div><div class="col-md-8 col-md-offset-2"><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.register()" show-validation><div class="form-group"><label class="control-label" for="login" data-translate="global.form.username">Username</label><input type="text" class="form-control" id="login" name="login" placeholder="{{\'global.form.username.placeholder\' | translate}}" ng-model="vm.registerAccount.login" ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/" required><div ng-show="form.login.$dirty && form.login.$invalid"><p class="help-block" ng-show="form.login.$error.required" data-translate="register.messages.validate.login.required">Your username is required.</p><p class="help-block" ng-show="form.login.$error.minlength" data-translate="register.messages.validate.login.minlength">Your username is required to be at least 1 character.</p><p class="help-block" ng-show="form.login.$error.maxlength" data-translate="register.messages.validate.login.maxlength">Your username cannot be longer than 50 characters.</p><p class="help-block" ng-show="form.login.$error.pattern" data-translate="register.messages.validate.login.pattern">Your username can only contain lower-case letters and digits.</p></div></div><div class="form-group"><label class="control-label" for="email" data-translate="global.form.email">E-mail</label><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.registerAccount.email" ng-minlength="5" ng-maxlength="100" required><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" data-translate="global.messages.validate.email.required">Your e-mail is required.</p><p class="help-block" ng-show="form.email.$error.email" data-translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" data-translate="global.messages.validate.email.minlength">Your e-mail is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" data-translate="global.messages.validate.email.maxlength">Your e-mail cannot be longer than 100 characters.</p></div></div><div class="form-group"><label class="control-label" for="password" data-translate="global.form.newpassword">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.registerAccount.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.registerAccount.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" data-translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your confirmation password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="register.form.button">Register</button></form><p></p><!--<div class="alert alert-warning" data-translate="global.messages.info.authenticated" translate-compile>--><!--    If you want to <a class="alert-link" href="" ng-click="vm.login()">sign in</a>, you can try the default accounts:<br/>- Administrator (login="admin" and password="admin") <br/>- User (login="user" and password="user").--><!--</div>--></div></div></div>');
$templateCache.put('app/account/settings/settings.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h2 data-translate="settings.title" translate-values="{username: \'{{vm.settingsAccount.login}}\'}">User settings for [<b>{{vm.settingsAccount.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success" data-translate="settings.messages.success"><strong>Settings saved!</strong></div><jhi-alert-error></jhi-alert-error><form name="form" role="form" novalidate ng-submit="vm.save()" show-validation><div class="form-group"><label class="control-label" for="firstName" data-translate="settings.form.firstname">First Name</label><input type="text" class="form-control" id="firstName" name="firstName" placeholder="{{\'settings.form.firstname.placeholder\' | translate}}" ng-model="vm.settingsAccount.firstName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.firstName.$dirty && form.firstName.$invalid"><p class="help-block" ng-show="form.firstName.$error.required" data-translate="settings.messages.validate.firstname.required">Your first name is required.</p><p class="help-block" ng-show="form.firstName.$error.minlength" data-translate="settings.messages.validate.firstname.minlength">Your first name is required to be at least 1 character.</p><p class="help-block" ng-show="form.firstName.$error.maxlength" data-translate="settings.messages.validate.firstname.maxlength">Your first name cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="lastName" data-translate="settings.form.lastname">Last Name</label><input type="text" class="form-control" id="lastName" name="lastName" placeholder="{{\'settings.form.lastname.placeholder\' | translate}}" ng-model="vm.settingsAccount.lastName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.lastName.$dirty && form.lastName.$invalid"><p class="help-block" ng-show="form.lastName.$error.required" data-translate="settings.messages.validate.lastname.required">Your last name is required.</p><p class="help-block" ng-show="form.lastName.$error.minlength" data-translate="settings.messages.validate.lastname.minlength">Your last name is required to be at least 1 character.</p><p class="help-block" ng-show="form.lastName.$error.maxlength" data-translate="settings.messages.validate.lastname.maxlength">Your last name cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="email" data-translate="global.form.email">E-mail</label><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.settingsAccount.email" ng-minlength="5" ng-maxlength="100" required maxlength="100"><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" data-translate="global.messages.validate.email.required">Your e-mail is required.</p><p class="help-block" ng-show="form.email.$error.email" data-translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" data-translate="global.messages.validate.email.minlength">Your e-mail is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" data-translate="global.messages.validate.email.maxlength">Your e-mail cannot be longer than 100 characters.</p></div></div><div class="form-group"><label for="langKey" data-translate="settings.form.language">Language</label><select id="langKey" name="langKey" class="form-control" ng-model="vm.settingsAccount.langKey" ng-controller="JhiLanguageController as languageVm" ng-options="code as (code | findLanguageFromKey) for code in languageVm.languages"></select></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="settings.form.button">Save</button></form></div></div></div>');
$templateCache.put('app/admin/audits/audits.html','<div><h2 data-translate="audits.title">Audits</h2><div class="row"><div class="col-md-5"><h4 data-translate="audits.filter.title">Filter by date</h4><p class="input-group"><span class="input-group-addon" data-translate="audits.filter.from">from</span> <input type="date" class="input-sm form-control" name="start" ng-model="vm.fromDate" ng-change="vm.onChangeDate()" required> <span class="input-group-addon" data-translate="audits.filter.to">to</span> <input type="date" class="input-sm form-control" name="end" ng-model="vm.toDate" ng-change="vm.onChangeDate()" required></p></div></div><table class="table table-condensed table-striped table-bordered table-responsive"><thead><tr><th ng-click="predicate = \'timestamp\'; reverse=!reverse"><span data-translate="audits.table.header.date">Date</span></th><th ng-click="predicate = \'principal\'; reverse=!reverse"><span data-translate="audits.table.header.principal">User</span></th><th ng-click="predicate = \'type\'; reverse=!reverse"><span data-translate="audits.table.header.status">State</span></th><th ng-click="predicate = \'data.message\'; reverse=!reverse"><span data-translate="audits.table.header.data">Extra data</span></th></tr></thead><tr ng-repeat="audit in vm.audits | filter:filter | orderBy:predicate:reverse" ng-hide="audit.filtered"><td><span>{{audit.timestamp| date:\'medium\'}}</span></td><td><small>{{audit.principal}}</small></td><td>{{audit.type}}</td><td><span ng-show="audit.data.message">{{audit.data.message}}</span> <span ng-show="audit.data.remoteAddress"><span data-translate="audits.table.data.remoteAddress">Remote Address</span> {{audit.data.remoteAddress}}</span></td></tr></table><div class="text-center"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.loadPage(vm.page)"></uib-pagination></div></div>');
$templateCache.put('app/admin/configuration/configuration.html','<div><h2 data-translate="configuration.title">Configuration</h2><span data-translate="configuration.filter">Filter (by prefix)</span> <input type="text" ng-model="filter" class="form-control"><label ng-hide="filteredConfig.length == 0">Spring configuration</label><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filteredConfig.length == 0"><thead><tr><th ng-click="predicate = \'prefix\'; reverse=!reverse" class="col-sm-4"><span data-translate="configuration.table.prefix">Prefix</span></th><th data-translate="configuration.table.properties" class="col-sm-8">Properties</th></tr></thead><tr ng-repeat="entry in filtered = (vm.configuration | filter:filter | orderBy:predicate:reverse)"><td><span>{{entry.prefix}}</span></td><td><div class="row" ng-repeat="(key, value) in entry.properties"><div class="col-md-4">{{key}}</div><div class="col-md-8"><span class="pull-right label label-default break">{{value}}</span></div></div></td></tr></table><div ng-repeat="(key, value) in vm.allConfiguration"><label ng-hide="filtered.length == 0"><span>{{key}}</span></label><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filtered.length == 0"><thead><tr><th class="col-sm-4">Property</th><th class="col-sm-8">Value</th></tr></thead><tbody><tr ng-repeat="item in filtered = (value | filter:filter)"><td class="break">{{item.key}}</td><td class="break"><span class="pull-right label label-default break">{{item.val}}</span></td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/docs/docs.html','<iframe src="swagger-ui/index.html" frameborder="0" marginheight="0" marginwidth="0" width="100%" height="900" scrolling="auto" target="_top" title="Swagger UI"></iframe>');
$templateCache.put('app/admin/logs/logs.html','<div class="table-responsive"><h2 data-translate="logs.title">Logs</h2><p data-translate="logs.nbloggers" translate-values="{total: \'{{ vm.loggers.length }}\'}">There are {{ vm.loggers.length }} loggers.</p><span data-translate="logs.filter">Filter</span> <input type="text" ng-model="filter" class="form-control"><table class="table table-condensed table-striped table-bordered"><thead><tr title="click to order"><th ng-click="predicate = \'name\'; reverse=!reverse"><span data-translate="logs.table.name">Name</span></th><th ng-click="predicate = \'level\'; reverse=!reverse"><span data-translate="logs.table.level">Level</span></th></tr></thead><tr ng-repeat="logger in vm.loggers | filter:filter | orderBy:predicate:reverse"><td><small>{{logger.name | characters:140}}</small></td><td><button ng-click="vm.changeLevel(logger.name, \'TRACE\')" ng-class="(logger.level==\'TRACE\') ? \'btn-danger\' : \'btn-default\'" class="btn btn-default btn-xs">TRACE</button> <button ng-click="vm.changeLevel(logger.name, \'DEBUG\')" ng-class="(logger.level==\'DEBUG\') ? \'btn-warning\' : \'btn-default\'" class="btn btn-default btn-xs">DEBUG</button> <button ng-click="vm.changeLevel(logger.name, \'INFO\')" ng-class="(logger.level==\'INFO\') ? \'btn-info\' : \'btn-default\'" class="btn btn-default btn-xs">INFO</button> <button ng-click="vm.changeLevel(logger.name, \'WARN\')" ng-class="(logger.level==\'WARN\') ? \'btn-success\' : \'btn-default\'" class="btn btn-default btn-xs">WARN</button> <button ng-click="vm.changeLevel(logger.name, \'ERROR\')" ng-class="(logger.level==\'ERROR\') ? \'btn-primary\' : \'btn-default\'" class="btn btn-default btn-xs">ERROR</button></td></tr></table></div>');
$templateCache.put('app/admin/health/health.html','<div><h2 data-translate="health.title">Health Checks</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span data-translate="health.refresh.button">Refresh</span></button></p><table id="healthCheck" class="table table-striped"><thead><tr><th class="col-md-7" data-translate="health.table.service">Service Name</th><th class="col-md-2 text-center" data-translate="health.table.status">Status</th><th class="col-md-2 text-center" data-translate="health.details.details">Details</th></tr></thead><tbody><tr ng-repeat="health in vm.healthData"><td>{{\'health.indicator.\' + vm.baseName(health.name) | translate}} {{vm.subSystemName(health.name)}}</td><td class="text-center"><span class="label" ng-class="vm.getLabelClass(health.status)">{{\'health.status.\' + health.status | translate}}</span></td><td class="text-center"><a class="hand" ng-click="vm.showHealth(health)" ng-show="health.details || health.error"><i class="glyphicon glyphicon-eye-open"></i></a></td></tr></tbody></table></div>');
$templateCache.put('app/admin/health/health.modal.html','<div class="modal-header"><button aria-label="Close" data-dismiss="modal" class="close" type="button" ng-click="vm.cancel()"><span aria-hidden="true">&times;</span></button><h4 class="modal-title" id="showHealthLabel">{{\'health.indicator.\' + vm.baseName(vm.currentHealth.name) | translate}} {{vm.subSystemName(vm.currentHealth.name)}}</h4></div><div class="modal-body pad"><div ng-show="vm.currentHealth.details"><h4 data-translate="health.details.properties">Properties</h4><table class="table table-striped"><thead><tr><th class="col-md-6 text-left" data-translate="health.details.name">Name</th><th class="col-md-6 text-left" data-translate="health.details.value">Value</th></tr></thead><tbody><tr ng-repeat="(k,v) in vm.currentHealth.details"><td class="col-md-6 text-left">{{k}}</td><td class="col-md-6 text-left">{{v}}</td></tr></tbody></table></div><div ng-show="vm.currentHealth.error"><h4 data-translate="health.details.error">Error</h4><pre>{{vm.currentHealth.error}}</pre></div></div><div class="modal-footer"><button data-dismiss="modal" class="btn btn-default pull-left" type="button" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/metrics/metrics.html','<div><h2 data-translate="metrics.title">Application Metrics</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span data-translate="metrics.refresh.button">Refresh</span></button></p><h3 data-translate="metrics.jvm.title">JVM Metrics</h3><div class="row" ng-hide="vm.updatingMetrics"><div class="col-md-4"><b data-translate="metrics.jvm.memory.title">Memory</b><p><span data-translate="metrics.jvm.memory.total">Total Memory</span> ({{vm.metrics.gauges[\'jvm.memory.total.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.total.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.total.max\'].value" value="vm.metrics.gauges[\'jvm.memory.total.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.total.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.total.max\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.memory.heap">Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.heap.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.heap.max\'].value" value="vm.metrics.gauges[\'jvm.memory.heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.heap.max\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.memory.nonheap">Non-Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value" value="vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b data-translate="metrics.jvm.threads.title">Threads</b> (Total: {{vm.metrics.gauges[\'jvm.threads.count\'].value}}) <a class="hand" ng-click="vm.refreshThreadDumpData()" data-toggle="modal" data-target="#threadDump"><i class="glyphicon glyphicon-eye-open"></i></a><p><span data-translate="metrics.jvm.threads.runnable">Runnable</span> {{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value}}</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.runnable.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.timedwaiting">Timed Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.waiting">Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.blocked">Blocked</span> ({{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.blocked.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b data-translate="metrics.jvm.gc.title">Garbage collections</b><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.marksweepcount">Mark Sweep count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.count\'].value}}</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.marksweeptime">Mark Sweep time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.time\'].value}}ms</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.scavengecount">Scavenge count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.count\'].value}}</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.scavengetime">Scavenge time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.time\'].value}}ms</div></div></div></div><div class="well well-lg" ng-show="vm.updatingMetrics" data-translate="metrics.updating">Updating...</div><h3 data-translate="metrics.jvm.http.title">HTTP requests (events per second)</h3><p><span data-translate="metrics.jvm.http.active">Active requests</span> <b>{{vm.metrics.counters[\'com.codahale.metrics.servlet.InstrumentedFilter.activeRequests\'].count | number:0}}</b> - <span data-translate="metrics.jvm.http.total">Total requests</span> <b>{{vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count | number:0}}</b></p><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="metrics.jvm.http.table.code">Code</th><th data-translate="metrics.jvm.http.table.count">Count</th><th class="text-right" data-translate="metrics.jvm.http.table.mean">Mean</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (1 min)</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (5 min)</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (15 min)</th></tr></thead><tbody><tr><td data-translate="metrics.jvm.http.code.ok">OK</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m15_rate | number:2}}</td></tr><tr><td data-translate="metrics.jvm.http.code.notfound">Not Found</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m15_rate | number:2}}</td></tr><tr><td data-translate="metrics.jvm.http.code.servererror">Server error</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m15_rate | number:2}}</td></tr></tbody></table></div><h3 data-translate="metrics.servicesstats.title">Services statistics (time in millisecond)</h3><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="metrics.servicesstats.table.name">Service name</th><th class="text-right" data-translate="metrics.servicesstats.table.count">Count</th><th class="text-right" data-translate="metrics.servicesstats.table.mean">Mean</th><th class="text-right" data-translate="metrics.servicesstats.table.min">Min</th><th class="text-right" data-translate="metrics.servicesstats.table.p50">p50</th><th class="text-right" data-translate="metrics.servicesstats.table.p75">p75</th><th class="text-right" data-translate="metrics.servicesstats.table.p95">p95</th><th class="text-right" data-translate="metrics.servicesstats.table.p99">p99</th><th class="text-right" data-translate="metrics.servicesstats.table.max">Max</th></tr></thead><tbody><tr ng-repeat="(k, v) in vm.servicesStats"><td>{{k}}</td><td class="text-right">{{v.count}}</td><td class="text-right">{{v.mean * 1000 | number:0}}</td><td class="text-right">{{v.min * 1000 | number:0}}</td><td class="text-right">{{v.p50 * 1000 | number:0}}</td><td class="text-right">{{v.p75 * 1000 | number:0}}</td><td class="text-right">{{v.p95 * 1000 | number:0}}</td><td class="text-right">{{v.p99 * 1000 | number:0}}</td><td class="text-right">{{v.max * 1000 | number:0}}</td></tr></tbody></table></div><h3 data-translate="metrics.datasource.title" ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0">DataSource statistics (time in millisecond)</h3><div class="table-responsive" ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0"><table class="table table-striped"><thead><tr><th><span data-translate="metrics.datasource.usage">Usage</span> ({{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value}} / {{vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value}})</th><th class="text-right" data-translate="metrics.datasource.count">Count</th><th class="text-right" data-translate="metrics.datasource.mean">Mean</th><th class="text-right" data-translate="metrics.datasource.min">Min</th><th class="text-right" data-translate="metrics.datasource.p50">p50</th><th class="text-right" data-translate="metrics.datasource.p75">p75</th><th class="text-right" data-translate="metrics.datasource.p95">p95</th><th class="text-right" data-translate="metrics.datasource.p99">p99</th><th class="text-right" data-translate="metrics.datasource.max">Max</th></tr></thead><tbody><tr><td><div class="progress progress-striped"><uib-progressbar min="0" max="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value" value="vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value * 100 / vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value | number:0}}%</span></uib-progressbar></div></td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].count}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].mean | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].min | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p50 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p75 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p95 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p99 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].max | number:2}}</td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/metrics/metrics.modal.html','<!-- Modal used to display the threads dump --><div class="modal-header"><button type="button" class="close" ng-click="vm.cancel()">&times;</button><h4 class="modal-title" data-translate="metrics.jvm.threads.dump.title">Threads dump</h4></div><div class="modal-body pad"><span class="label label-primary" ng-click="threadDumpFilter = {}">All&nbsp;<span class="badge">{{vm.threadDumpAll}}</span></span>&nbsp; <span class="label label-success" ng-click="threadDumpFilter = {threadState: \'RUNNABLE\'}">Runnable&nbsp;<span class="badge">{{vm.threadDumpRunnable}}</span></span>&nbsp; <span class="label label-info" ng-click="threadDumpFilter = {threadState: \'WAITING\'}">Waiting&nbsp;<span class="badge">{{vm.threadDumpWaiting}}</span></span>&nbsp; <span class="label label-warning" ng-click="threadDumpFilter = {threadState: \'TIMED_WAITING\'}">Timed Waiting&nbsp;<span class="badge">{{vm.threadDumpTimedWaiting}}</span></span>&nbsp; <span class="label label-danger" ng-click="threadDumpFilter = {threadState: \'BLOCKED\'}">Blocked&nbsp;<span class="badge">{{vm.threadDumpBlocked}}</span></span>&nbsp;<div class="voffset2">&nbsp;</div>Filter <input type="text" ng-model="threadDumpFilter" class="form-control"><div class="row pad" ng-repeat="(k, v) in vm.threadDump | filter:threadDumpFilter"><h5><span class="label" ng-class="vm.getLabelClass(v.threadState)">{{v.threadState}}</span>&nbsp;{{v.threadName}} (ID {{v.threadId}}) <a ng-click="show = !show"><span ng-show="!show" data-translate="metrics.jvm.threads.dump.show">Show StackTrace</span> <span ng-show="show" data-translate="metrics.jvm.threads.dump.hide">Hide StackTrace</span></a></h5><div class="well" ng-show="show"><div ng-repeat="(stK, stV) in v.stackTrace">{{stV.className}}.{{stV.methodName}}({{stV.fileName}}:{{stV.lineNumber}}) <span class="voffset1"></span></div></div><table class="table table-condensed"><thead><tr><th class="text-right" data-translate="metrics.jvm.threads.dump.blockedtime">Blocked Time</th><th class="text-right" data-translate="metrics.jvm.threads.dump.blockedcount">Blocked Count</th><th class="text-right" data-translate="metrics.jvm.threads.dump.waitedtime">Waited Time</th><th class="text-right" data-translate="metrics.jvm.threads.dump.waitedcount">Waited Count</th><th data-translate="metrics.jvm.threads.dump.lockname">Lock Name</th></tr></thead><tbody><tr><td>{{v.blockedTime}}</td><td>{{v.blockedCount}}</td><td>{{v.waitedTime}}</td><td>{{v.waitedCount}}</td><td>{{v.lockName}}</td></tr></tbody></table></div></div><div class="modal-footer"><button type="button" class="btn btn-default pull-left" data-dismiss="modal" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/user-management/user-management-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.user.login)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="userManagement.delete.question" translate-values="{login: \'{{vm.user.login}}\'}">Are you sure you want to delete this User?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management-detail.html','<div><h2><span data-translate="userManagement.detail.title">User</span> [<b>{{vm.user.login}}</b>]</h2><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="userManagement.login">Login</span></dt><dd><span>{{vm.user.login}}</span> <span class="label label-danger" ng-show="!vm.user.activated" data-translate="userManagement.deactivated">Deactivated</span> <span class="label label-success" ng-show="vm.user.activated" data-translate="userManagement.activated">Activated</span></dd><dt><span data-translate="userManagement.firstName">First Name</span></dt><dd>{{vm.user.firstName}}</dd><dt><span data-translate="userManagement.lastName">Last Name</span></dt><dd>{{vm.user.lastName}}</dd><dt><span data-translate="userManagement.email">Email</span></dt><dd>{{vm.user.email}}</dd><dt><span data-translate="userManagement.langKey">Lang Key</span></dt><dd>{{vm.user.langKey}}</dd><dt><span data-translate="userManagement.createdBy">Created By</span></dt><dd>{{vm.user.createdBy}}</dd><dt><span data-translate="userManagement.createdDate">Created Date</span></dt><dd>{{vm.user.createdDate | date:\'dd/MM/yy HH:mm\' }}</dd><dt><span data-translate="userManagement.lastModifiedBy">Last Modified By</span></dt><dd>{{vm.user.lastModifiedBy}}</dd><dt><span data-translate="userManagement.lastModifiedDate">Last Modified Date</span></dt><dd>{{vm.user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</dd><dt><span data-translate="userManagement.profiles">Profiles</span></dt><dd><ul class="list-unstyled"><li ng-repeat="authority in vm.user.authorities"><span class="label label-info">{{authority}}</span></li></ul></dd></dl><button type="submit" ui-sref="user-management" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button></div>');
$templateCache.put('app/admin/user-management/user-management-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myUserLabel" data-translate="userManagement.home.createOrEditLabel">Create or edit a User</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label data-translate="global.field.id">ID</label><input type="text" class="form-control" name="id" ng-model="vm.user.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="userManagement.login">Login</label><input type="text" class="form-control" name="login" ng-model="vm.user.login" ng-required="vm.user.id == null" ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/"><div ng-show="editForm.login.$invalid"><p class="help-block" ng-show="editForm.login.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.login.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="userManagement.firstName">First Name</label><input type="text" class="form-control" name="firstName" ng-model="vm.user.firstName" ng-maxlength="50"><div ng-show="editForm.firstName.$invalid"><p class="help-block" ng-show="editForm.firstName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label data-translate="userManagement.lastName">Last Name</label><input type="text" class="form-control" name="lastName" ng-model="vm.user.lastName" ng-maxlength="50"><div ng-show="editForm.lastName.$invalid"><p class="help-block" ng-show="editForm.lastName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="userManagement.email">Email</label><input type="email" class="form-control" name="email" ng-model="vm.user.email" required ng-maxlength="100"><div ng-show="editForm.email.$invalid"><p class="help-block" ng-show="editForm.email.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.email.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p><p class="help-block" ng-show="editForm.email.$error.email" data-translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p></div></div><div class="form-group"><label for="activated"><input ng-disabled="vm.user.id === null" type="checkbox" id="activated" name="activated" ng-model="vm.user.activated"> <span data-translate="userManagement.activated">Activated</span></label></div><div class="form-group"><label data-translate="userManagement.langKey">Lang Key</label><select class="form-control" name="langKey" ng-model="vm.user.langKey" ng-options="language as language for language in vm.languages track by language"></select></div><div class="form-group"><label data-translate="userManagement.profiles">Profiles</label><select class="form-control" multiple="multiple" name="authority" ng-model="vm.user.authorities" has-authority="ROLE_SUPERUSER" ng-options="authority for authority in vm.authoritiesNoAdmin"></select><select class="form-control" multiple="multiple" name="authority" ng-model="vm.user.authorities" has-authority="ROLE_ADMIN" ng-options="authority for authority in vm.authoritiesAll"></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management.html','<div><h2 data-translate="userManagement.home.title">Users</h2><jhi-alert></jhi-alert><div class="row"><div class="col-md-4"><button class="btn btn-primary" ui-sref="user-management.new"><span class="glyphicon glyphicon-flash"></span> <span data-translate="userManagement.home.createLabel">Create a new User</span></button></div></div><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span><span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="login"><span data-translate="userManagement.login">Login</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="email"><span data-translate="userManagement.email">Email</span> <span class="glyphicon glyphicon-sort"></span></th><th></th><th jh-sort-by="langKey"><span data-translate="userManagement.langKey">Lang Key</span> <span class="glyphicon glyphicon-sort"></span></th><th><span data-translate="userManagement.profiles">Profiles</span></th><th jh-sort-by="createdDate"><span data-translate="userManagement.createdDate">Created Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastModifiedBy"><span data-translate="userManagement.lastModifiedBy">Last Modified By</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastModifiedDate"><span data-translate="userManagement.lastModifiedDate">Last Modified Date</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="user in vm.users track by user.id"><td><a ui-sref="user-management-detail({login:user.login})">{{user.id}}</a></td><td style="max-width: 70pt; overflow-wrap: break-word">{{user.login}}</td><td style="max-width: 150pt; overflow-wrap: break-word">{{user.email}}</td><td><button class="btn btn-danger btn-xs" ng-click="vm.setActive(user, true)" ng-show="!user.activated" data-translate="userManagement.deactivated">Deactivated</button> <button class="btn btn-success btn-xs" ng-click="vm.setActive(user, false)" ng-show="user.activated" ng-disabled="vm.currentAccount.login==user.login" data-translate="userManagement.activated">Activated</button></td><td>{{user.langKey}}</td><td><div ng-repeat="authority in user.authorities"><span class="label label-info">{{ authority }}</span></div></td><td>{{user.createdDate | date:\'dd/MM/yy HH:mm\'}}</td><td>{{user.lastModifiedBy}}</td><td>{{user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="user-management-detail({login:user.login})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="user-management.edit({login:user.login})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="user-management.delete({login:user.login})" class="btn btn-danger btn-sm" ng-disabled="vm.currentAccount.login==user.login"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/components/login/login.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.cancel()">&times;</button><h4 class="modal-title" data-translate="login.title">Sign in</h4></div><div class="modal-body"><div class="row"><div class="col-md-4 col-md-offset-4"><h1 data-translate="login.title">Sign in</h1></div><div class="col-md-8 col-md-offset-2"><div class="alert alert-danger" ng-show="vm.authenticationError" data-translate="login.messages.error.authentication"><strong>Failed to sign in!</strong> Please check your credentials and try again.</div></div><div class="col-md-8 col-md-offset-2"><form class="form" role="form" ng-submit="vm.login($event)"><div class="form-group"><label for="username" data-translate="global.form.username">Login</label><input type="text" class="form-control" id="username" placeholder="{{\'global.form.username.placeholder\' | translate}}" ng-model="vm.username"></div><div class="form-group"><label for="password" data-translate="login.form.password">Password</label><input type="password" class="form-control" id="password" placeholder="{{\'login.form.password.placeholder\' | translate}}" ng-model="vm.password"></div><button type="submit" class="btn btn-primary" data-translate="login.form.button">Sign in</button></form><p></p><div class="alert alert-warning"><a class="alert-link" href="" ng-click="vm.requestResetPassword()" data-translate="login.password.forgot">Did you forget your password?</a></div></div></div></div>');
$templateCache.put('app/entities/curve-limits/curve-limits-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.curveLimits.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="moldovaYieldCurvesApp.curveLimits.delete.question" translate-values="{id: \'{{vm.curveLimits.id}}\'}">Are you sure you want to delete this Curve Limits entry?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/curve-limits/curve-limits-detail.html','<div><h2><span data-translate="moldovaYieldCurvesApp.curveLimits.detail.title">Curve Limits</span> {{vm.curveLimits.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="moldovaYieldCurvesApp.curveLimits.minTenorDays">minTenorDays</span></dt><dd><span>{{vm.curveLimits.minTenorDays}}</span></dd><dt><span data-translate="moldovaYieldCurvesApp.curveLimits.maxTenorDays">maxTenorDays</span></dt><dd><span>{{vm.curveLimits.maxTenorDays}}</span></dd><dt><span data-translate="moldovaYieldCurvesApp.curveLimits.validFrom">validFrom</span></dt><dd><span>{{vm.curveLimits.validFrom | date:\'mediumDate\'}}</span></dd><dt><span data-translate="moldovaYieldCurvesApp.curveLimits.validTo">validTo</span></dt><dd><span>{{vm.curveLimits.validTo | date:\'mediumDate\'}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="curve-limits-detail.edit({id:vm.curveLimits.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/curve-limits/curve-limits-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myCurveLimitsLabel" data-translate="moldovaYieldCurvesApp.curveLimits.home.createOrEditLabel">Create or edit Curve Limits entry</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.curveLimits.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.curveLimits.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="moldovaYieldCurvesApp.curveLimits.minTenorLabel" for="field_minTenorDays">minTenorDays</label><select class="form-control" name="minTenorDays" ng-model="vm.curveLimits.minTenorDays" id="field_minTenorDays" ng-options="tenor.value as tenor.label for tenor in vm.tenorLabels"></select></div><div class="form-group"><label class="control-label" data-translate="moldovaYieldCurvesApp.curveLimits.maxTenorLabel" for="field_maxTenorDays">minTenorDays</label><select class="form-control" name="maxTenorDays" ng-model="vm.curveLimits.maxTenorDays" id="field_maxTenorDays" ng-options="tenor.value as tenor.label for tenor in vm.tenorLabels"></select></div><div class="form-group"><label class="control-label" data-translate="moldovaYieldCurvesApp.curveLimits.validFrom" for="field_validFrom">validFrom</label><div class="input-group"><input id="field_validFrom" type="text" class="form-control" name="validFrom" uib-datepicker-popup="{{dateformat}}" ng-model="vm.curveLimits.validFrom" is-open="vm.datePickerOpenStatus.validFrom"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'validFrom\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="moldovaYieldCurvesApp.curveLimits.validTo" for="field_validTo">validTo</label><div class="input-group"><input id="field_validTo" type="text" class="form-control" name="validTo" uib-datepicker-popup="{{dateformat}}" ng-model="vm.curveLimits.validTo" is-open="vm.datePickerOpenStatus.validTo"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'validTo\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/curve-limits/curve-limits.html','<div><h2 data-translate="moldovaYieldCurvesApp.curveLimits.home.title">Curve Limits</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="curve-limits.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="moldovaYieldCurvesApp.curveLimits.home.createLabel">Create new Curve Limits</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="moldovaYieldCurvesApp.curveLimits.minTenorDays">minTenorDays</span></th><th><span data-translate="moldovaYieldCurvesApp.curveLimits.maxTenorDays">maxTenorDays</span></th><th><span data-translate="moldovaYieldCurvesApp.curveLimits.validFrom">validFrom</span></th><th><span data-translate="moldovaYieldCurvesApp.curveLimits.validTo">validTo</span></th><th></th></tr></thead><tbody><tr ng-repeat="curveLimits in vm.curveLimits track by curveLimits.id"><td><a ui-sref="curve-limits-detail({id:curveLimits.id})">{{curveLimits.id}}</a></td><td>{{curveLimits.minTenorDays}}</td><td>{{curveLimits.maxTenorDays}}</td><td>{{curveLimits.validFrom | date:\'mediumDate\'}}</td><td>{{curveLimits.validTo | date:\'mediumDate\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="curve-limits-detail({id:curveLimits.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="curve-limits.edit({id:curveLimits.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="curve-limits.delete({id:curveLimits.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/epm-params/epm-params-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.epmParams.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="moldovaYieldCurvesApp.epmParams.delete.question" translate-values="{id: \'{{vm.epmParams.id}}\'}">Are you sure you want to delete this Epm Params?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/epm-params/epm-params-detail.html','<div><h2><span data-translate="moldovaYieldCurvesApp.epmParams.detail.title">Epm Params</span> {{vm.epmParams.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="moldovaYieldCurvesApp.epmParams.beta0">Beta 0</span></dt><dd><span>{{vm.epmParams.beta0}}</span></dd><dt><span data-translate="moldovaYieldCurvesApp.epmParams.beta1">Beta 1</span></dt><dd><span>{{vm.epmParams.beta1}}</span></dd><dt><span data-translate="moldovaYieldCurvesApp.epmParams.beta2">Beta 2</span></dt><dd><span>{{vm.epmParams.beta2}}</span></dd><dt><span data-translate="moldovaYieldCurvesApp.epmParams.beta3">Beta 3</span></dt><dd><span>{{vm.epmParams.beta3}}</span></dd><dt><span data-translate="moldovaYieldCurvesApp.epmParams.beta4">Beta 4</span></dt><dd><span>{{vm.epmParams.beta4}}</span></dd><dt><span data-translate="moldovaYieldCurvesApp.epmParams.lambda">Lambda</span></dt><dd><span>{{vm.epmParams.lambda}}</span></dd><dt><span data-translate="moldovaYieldCurvesApp.epmParams.n">N</span></dt><dd><span>{{vm.epmParams.n}}</span></dd><dt><span data-translate="moldovaYieldCurvesApp.epmParams.m">M</span></dt><dd><span>{{vm.epmParams.m}}</span></dd><dt><span data-translate="moldovaYieldCurvesApp.epmParams.gfit">Goodness of fit</span></dt><dd><span>{{vm.epmParams.gfit}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="epm-params-detail.edit({id:vm.epmParams.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/epm-params/epm-params-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myEpmParamsLabel" data-translate="moldovaYieldCurvesApp.epmParams.home.createOrEditLabel">Create or edit a Epm Params</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.epmParams.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.epmParams.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="moldovaYieldCurvesApp.epmParams.beta0" for="field_beta0">Beta 0</label><input type="number" class="form-control" name="beta0" id="field_beta0" ng-model="vm.epmParams.beta0"></div><div class="form-group"><label class="control-label" data-translate="moldovaYieldCurvesApp.epmParams.beta1" for="field_beta1">Beta 1</label><input type="number" class="form-control" name="beta1" id="field_beta1" ng-model="vm.epmParams.beta1"></div><div class="form-group"><label class="control-label" data-translate="moldovaYieldCurvesApp.epmParams.beta2" for="field_beta2">Beta 2</label><input type="number" class="form-control" name="beta2" id="field_beta2" ng-model="vm.epmParams.beta2"></div><div class="form-group"><label class="control-label" data-translate="moldovaYieldCurvesApp.epmParams.beta3" for="field_beta3">Beta 3</label><input type="number" class="form-control" name="beta3" id="field_beta3" ng-model="vm.epmParams.beta3"></div><div class="form-group"><label class="control-label" data-translate="moldovaYieldCurvesApp.epmParams.beta4" for="field_beta4">Beta 4</label><input type="number" class="form-control" name="beta4" id="field_beta4" ng-model="vm.epmParams.beta4"></div><div class="form-group"><label class="control-label" data-translate="moldovaYieldCurvesApp.epmParams.lambda" for="field_lambda">Lambda</label><input type="number" class="form-control" name="lambda" id="field_lambda" ng-model="vm.epmParams.lambda"></div><div class="form-group"><label class="control-label" data-translate="moldovaYieldCurvesApp.epmParams.n" for="field_n">N</label><input type="number" class="form-control" name="n" id="field_n" ng-model="vm.epmParams.n"></div><div class="form-group"><label class="control-label" data-translate="moldovaYieldCurvesApp.epmParams.m" for="field_m">M</label><input type="number" class="form-control" name="m" id="field_m" ng-model="vm.epmParams.m"></div><div class="form-group"><label class="control-label" data-translate="moldovaYieldCurvesApp.epmParams.gfit" for="field_gfit">Goodness of fit</label><input type="number" class="form-control" name="lambda" id="field_gfit" ng-model="vm.epmParams.gfit"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/epm-params/epm-params.html','<div><h2 data-translate="moldovaYieldCurvesApp.epmParams.home.title">Epm Params</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="epm-params.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="moldovaYieldCurvesApp.epmParams.home.createLabel">Create new Epm Params</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="moldovaYieldCurvesApp.epmParams.beta0">Beta 0</span></th><th><span data-translate="moldovaYieldCurvesApp.epmParams.beta1">Beta 1</span></th><th><span data-translate="moldovaYieldCurvesApp.epmParams.beta2">Beta 2</span></th><th><span data-translate="moldovaYieldCurvesApp.epmParams.beta3">Beta 3</span></th><th><span data-translate="moldovaYieldCurvesApp.epmParams.beta4">Beta 4</span></th><th><span data-translate="moldovaYieldCurvesApp.epmParams.lambda">Lambda</span></th><th><span data-translate="moldovaYieldCurvesApp.epmParams.n">N</span></th><th><span data-translate="moldovaYieldCurvesApp.epmParams.m">M</span></th><th><span data-translate="moldovaYieldCurvesApp.epmParams.gfit">Goodness of fit</span></th><th></th></tr></thead><tbody><tr ng-repeat="epmParams in vm.epmParams track by epmParams.id"><td><a ui-sref="epm-params-detail({id:epmParams.id})">{{epmParams.id}}</a></td><td>{{epmParams.beta0}}</td><td>{{epmParams.beta1}}</td><td>{{epmParams.beta2}}</td><td>{{epmParams.beta3}}</td><td>{{epmParams.beta4}}</td><td>{{epmParams.lambda}}</td><td>{{epmParams.n}}</td><td>{{epmParams.m}}</td><td>{{epmParams.gfit}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="epm-params-detail({id:epmParams.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="epm-params.edit({id:epmParams.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="epm-params.delete({id:epmParams.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/file-store/file-store-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.fileStore.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="moldovaYieldCurvesApp.fileStore.delete.question" translate-values="{id: \'{{vm.fileStore.id}}\'}">Are you sure you want to delete this File Store?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/file-store/file-store-detail.html','<div><h2><span data-translate="moldovaYieldCurvesApp.fileStore.detail.title">File Store</span> {{vm.fileStore.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="moldovaYieldCurvesApp.fileStore.fileId">File Id</span></dt><dd><span>{{vm.fileStore.fileId}}</span></dd><dt><span data-translate="moldovaYieldCurvesApp.fileStore.dataBlob">Data Blob</span></dt><dd><span>{{vm.fileStore.dataBlob}}</span></dd><dt><span data-translate="moldovaYieldCurvesApp.fileStore.validated">Validated</span></dt><dd><span>{{vm.fileStore.validated}}</span></dd><dt><span data-translate="moldovaYieldCurvesApp.fileStore.yieldCurveResults">Yield Curve Results</span></dt><dd><a ui-sref="yield-curve-results-detail({id:vm.fileStore.yieldCurveResultsId})">{{vm.fileStore.yieldCurveResultsId}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="file-store-detail.edit({id:vm.fileStore.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/file-store/file-store-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myFileStoreLabel" data-translate="moldovaYieldCurvesApp.fileStore.home.createOrEditLabel">Create or edit a File Store</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.fileStore.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.fileStore.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="moldovaYieldCurvesApp.fileStore.fileId" for="field_fileId">File Id</label><input type="text" class="form-control" name="fileId" id="field_fileId" ng-model="vm.fileStore.fileId" required ng-minlength="1" ng-maxlength="128"><div ng-show="editForm.fileId.$invalid"><p class="help-block" ng-show="editForm.fileId.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.fileId.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="1">This field is required to be at least 1 characters.</p><p class="help-block" ng-show="editForm.fileId.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="128">This field cannot be longer than 128 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="moldovaYieldCurvesApp.fileStore.dataBlob" for="field_dataBlob">Data Blob</label><textarea class="form-control" name="dataBlob" id="field_dataBlob" ng-model="vm.fileStore.dataBlob"></textarea></div><div class="form-group"><label class="control-label" for="field_validated"><input type="checkbox" id="field_validated" name="field_validated" ng-model="vm.fileStore.validated"> <span data-translate="moldovaYieldCurvesApp.fileStore.validated">Validated</span></label></div><div class="form-group"><label data-translate="moldovaYieldCurvesApp.fileStore.yieldCurveResults" for="field_yieldCurveResults">Yield Curve Results</label><select class="form-control" id="field_yieldCurveResults" name="yieldCurveResults" ng-model="vm.fileStore.yieldCurveResultsId" ng-options="yieldCurveResults.id as yieldCurveResults.id for yieldCurveResults in vm.yieldcurveresults | orderBy:\'id\'"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/file-store/file-stores.html','<div><h2 data-translate="moldovaYieldCurvesApp.fileStore.home.title">File Stores</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="file-store.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="moldovaYieldCurvesApp.fileStore.home.createLabel">Create new File Store</span></button></div></div></div><br><uib-pager total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pager><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="fileId"><span data-translate="moldovaYieldCurvesApp.fileStore.fileId">File Id</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="dataBlob"><span data-translate="moldovaYieldCurvesApp.fileStore.dataBlob">Data Blob</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="validated"><span data-translate="moldovaYieldCurvesApp.fileStore.validated">Validated</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="yieldCurveResultsId"><span data-translate="moldovaYieldCurvesApp.fileStore.yieldCurveResults">Yield Curve Results</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="fileStore in vm.fileStores track by fileStore.id"><td><a ui-sref="file-store-detail({id:fileStore.id})">{{fileStore.id}}</a></td><td>{{fileStore.fileId}}</td><td><div class="data-blob-cell">{{fileStore.dataBlob}}</div></td><td><span class="label label-danger" ng-show="!fileStore.validated" data-translate="moldovaYieldCurvesApp.fileStore.notValidated">Not Validated</span> <span class="label label-success" ng-show="fileStore.validated" data-translate="moldovaYieldCurvesApp.fileStore.validated">Validated</span></td><td><a ui-sref="yield-curve-results-detail({id:fileStore.yieldCurveResultsId})">{{fileStore.yieldCurveResultsId}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="file-store-detail({id:fileStore.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="file-store.edit({id:fileStore.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="file-store.delete({id:fileStore.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div><uib-pager total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pager></div>');
$templateCache.put('app/entities/observed-data/observed-data-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.observedData.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="moldovaYieldCurvesApp.observedData.delete.question" translate-values="{id: \'{{vm.observedData.id}}\'}">Are you sure you want to delete this Observed Data?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/observed-data/observed-data-detail.html','<div><h2><span data-translate="moldovaYieldCurvesApp.observedData.detail.title">Observed Data</span> {{vm.observedData.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="moldovaYieldCurvesApp.observedData.batchId">Batch Id</span></dt><dd><span>{{vm.observedData.batchId}}</span></dd><dt><span data-translate="moldovaYieldCurvesApp.observedData.source">Source</span></dt><dd><span>{{vm.observedData.source}}</span></dd><dt><span data-translate="moldovaYieldCurvesApp.observedData.isin">Isin</span></dt><dd><span>{{vm.observedData.isin}}</span></dd><dt><span data-translate="moldovaYieldCurvesApp.observedData.description">Desc</span></dt><dd><span>{{vm.observedData.description}}</span></dd><dt><span data-translate="moldovaYieldCurvesApp.observedData.couponRate">Coupon Rate</span></dt><dd><span>{{vm.observedData.couponRate}}</span></dd><dt><span data-translate="moldovaYieldCurvesApp.observedData.freq">Freq</span></dt><dd><span>{{vm.observedData.freq}}</span></dd><dt><span data-translate="moldovaYieldCurvesApp.observedData.settlementDate">Settlement Date</span></dt><dd><span>{{vm.observedData.settlementDate | date:\'mediumDate\'}}</span></dd><dt><span data-translate="moldovaYieldCurvesApp.observedData.tradeDate">Trade Date</span></dt><dd><span>{{vm.observedData.tradeDate | date:\'mediumDate\'}}</span></dd><dt><span data-translate="moldovaYieldCurvesApp.observedData.inceptionDate">Inception Date</span></dt><dd><span>{{vm.observedData.inceptionDate | date:\'mediumDate\'}}</span></dd><dt><span data-translate="moldovaYieldCurvesApp.observedData.maturityDate">Maturity Date</span></dt><dd><span>{{vm.observedData.maturityDate | date:\'mediumDate\'}}</span></dd><dt><span data-translate="moldovaYieldCurvesApp.observedData.dayCountConvention">Day Count Convention</span></dt><dd><span>{{vm.observedData.dayCountConvention}}</span></dd><dt><span data-translate="moldovaYieldCurvesApp.observedData.instrumentType">Instrument Type</span></dt><dd><span>{{vm.observedData.instrumentType}}</span></dd><dt><span data-translate="moldovaYieldCurvesApp.observedData.marketType">Market Type</span></dt><dd><span>{{vm.observedData.marketType}}</span></dd><dt><span data-translate="moldovaYieldCurvesApp.observedData.ticketSize">Ticket Size</span></dt><dd><span>{{vm.observedData.ticketSize}}</span></dd><dt><span data-translate="moldovaYieldCurvesApp.observedData.dirtyPriceObs">Dirty Price Obs</span></dt><dd><span>{{vm.observedData.dirtyPriceObs}}</span></dd><dt><span data-translate="moldovaYieldCurvesApp.observedData.cleanPriceObs">Clean Price Obs</span></dt><dd><span>{{vm.observedData.cleanPriceObs}}</span></dd><dt><span data-translate="moldovaYieldCurvesApp.observedData.ytmObs">Ytm Obs</span></dt><dd><span>{{vm.observedData.ytmObs}}</span></dd><dt><span data-translate="moldovaYieldCurvesApp.observedData.ytmMin">Ytm Min</span></dt><dd><span>{{vm.observedData.ytmMin}}</span></dd><dt><span data-translate="moldovaYieldCurvesApp.observedData.ytmMax">Ytm Max</span></dt><dd><span>{{vm.observedData.ytmMax}}</span></dd><dt><span data-translate="moldovaYieldCurvesApp.observedData.dirtyPriceThe">Dirty Price The</span></dt><dd><span>{{vm.observedData.dirtyPriceThe}}</span></dd><dt><span data-translate="moldovaYieldCurvesApp.observedData.cleanPriceThe">Clean Price The</span></dt><dd><span>{{vm.observedData.cleanPriceThe}}</span></dd><dt><span data-translate="moldovaYieldCurvesApp.observedData.accruedInterestThe">Accrued Interest The</span></dt><dd><span>{{vm.observedData.accruedInterestThe}}</span></dd><dt><span data-translate="moldovaYieldCurvesApp.observedData.ytmThe">Ytm The</span></dt><dd><span>{{vm.observedData.ytmThe}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="observed-data-detail.edit({id:vm.observedData.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/observed-data/observed-data-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myObservedDataLabel" data-translate="moldovaYieldCurvesApp.observedData.home.createOrEditLabel">Create or edit a Observed Data</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.observedData.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.observedData.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="moldovaYieldCurvesApp.observedData.batchId" for="field_batchId">Batch Id</label><input type="text" class="form-control" name="batchId" id="field_batchId" ng-model="vm.observedData.batchId"></div><div class="form-group"><label class="control-label" data-translate="moldovaYieldCurvesApp.observedData.source" for="field_source">Source</label><input type="text" class="form-control" name="source" id="field_source" ng-model="vm.observedData.source"></div><div class="form-group"><label class="control-label" data-translate="moldovaYieldCurvesApp.observedData.isin" for="field_isin">Isin</label><input type="text" class="form-control" name="isin" id="field_isin" ng-model="vm.observedData.isin"></div><div class="form-group"><label class="control-label" data-translate="moldovaYieldCurvesApp.observedData.description" for="field_desc">Desc</label><input type="text" class="form-control" name="description" id="field_desc" ng-model="vm.observedData.description"></div><div class="form-group"><label class="control-label" data-translate="moldovaYieldCurvesApp.observedData.couponRate" for="field_couponRate">Coupon Rate</label><input type="number" class="form-control" name="couponRate" id="field_couponRate" ng-model="vm.observedData.couponRate"></div><div class="form-group"><label class="control-label" data-translate="moldovaYieldCurvesApp.observedData.freq" for="field_freq">Freq</label><input type="number" class="form-control" name="freq" id="field_freq" ng-model="vm.observedData.freq"></div><div class="form-group"><label class="control-label" data-translate="moldovaYieldCurvesApp.observedData.settlementDate" for="field_settlementDate">Settlement Date</label><div class="input-group"><input id="field_settlementDate" type="text" class="form-control" name="settlementDate" uib-datepicker-popup="{{dateformat}}" ng-model="vm.observedData.settlementDate" is-open="vm.datePickerOpenStatus.settlementDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'settlementDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="moldovaYieldCurvesApp.observedData.tradeDate" for="field_tradeDate">Trade Date</label><div class="input-group"><input id="field_tradeDate" type="text" class="form-control" name="tradeDate" uib-datepicker-popup="{{dateformat}}" ng-model="vm.observedData.tradeDate" is-open="vm.datePickerOpenStatus.tradeDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'tradeDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="moldovaYieldCurvesApp.observedData.inceptionDate" for="field_inceptionDate">Inception Date</label><div class="input-group"><input id="field_inceptionDate" type="text" class="form-control" name="inceptionDate" uib-datepicker-popup="{{dateformat}}" ng-model="vm.observedData.inceptionDate" is-open="vm.datePickerOpenStatus.inceptionDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'inceptionDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="moldovaYieldCurvesApp.observedData.maturityDate" for="field_maturityDate">Maturity Date</label><div class="input-group"><input id="field_maturityDate" type="text" class="form-control" name="maturityDate" uib-datepicker-popup="{{dateformat}}" ng-model="vm.observedData.maturityDate" is-open="vm.datePickerOpenStatus.maturityDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'maturityDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="moldovaYieldCurvesApp.observedData.dayCountConvention" for="field_dayCountConvention">Day Count Convention</label><input type="text" class="form-control" name="dayCountConvention" id="field_dayCountConvention" ng-model="vm.observedData.dayCountConvention"></div><div class="form-group"><label class="control-label" data-translate="moldovaYieldCurvesApp.observedData.instrumentType" for="field_instrumentType">Instrument Type</label><input type="text" class="form-control" name="instrumentType" id="field_instrumentType" ng-model="vm.observedData.instrumentType"></div><div class="form-group"><label class="control-label" data-translate="moldovaYieldCurvesApp.observedData.marketType" for="field_marketType">Market Type</label><input type="text" class="form-control" name="marketType" id="field_marketType" ng-model="vm.observedData.marketType"></div><div class="form-group"><label class="control-label" data-translate="moldovaYieldCurvesApp.observedData.ticketSize" for="field_ticketSize">Ticket Size</label><input type="number" class="form-control" name="ticketSize" id="field_ticketSize" ng-model="vm.observedData.ticketSize"></div><div class="form-group"><label class="control-label" data-translate="moldovaYieldCurvesApp.observedData.dirtyPriceObs" for="field_dirtyPriceObs">Dirty Price Obs</label><input type="number" class="form-control" name="dirtyPriceObs" id="field_dirtyPriceObs" ng-model="vm.observedData.dirtyPriceObs"></div><div class="form-group"><label class="control-label" data-translate="moldovaYieldCurvesApp.observedData.cleanPriceObs" for="field_cleanPriceObs">Clean Price Obs</label><input type="number" class="form-control" name="cleanPriceObs" id="field_cleanPriceObs" ng-model="vm.observedData.cleanPriceObs"></div><div class="form-group"><label class="control-label" data-translate="moldovaYieldCurvesApp.observedData.ytmObs" for="field_ytmObs">Ytm Obs</label><input type="number" class="form-control" name="ytmObs" id="field_ytmObs" ng-model="vm.observedData.ytmObs"></div><div class="form-group"><label class="control-label" data-translate="moldovaYieldCurvesApp.observedData.ytmMin" for="field_ytmMin">Ytm Min</label><input type="number" class="form-control" name="ytmMin" id="field_ytmMin" ng-model="vm.observedData.ytmMin"></div><div class="form-group"><label class="control-label" data-translate="moldovaYieldCurvesApp.observedData.ytmMax" for="field_ytmMax">Ytm Max</label><input type="number" class="form-control" name="ytmMax" id="field_ytmMax" ng-model="vm.observedData.ytmMax"></div><div class="form-group"><label class="control-label" data-translate="moldovaYieldCurvesApp.observedData.dirtyPriceThe" for="field_dirtyPriceThe">Dirty Price The</label><input type="number" class="form-control" name="dirtyPriceThe" id="field_dirtyPriceThe" ng-model="vm.observedData.dirtyPriceThe"></div><div class="form-group"><label class="control-label" data-translate="moldovaYieldCurvesApp.observedData.cleanPriceThe" for="field_cleanPriceThe">Clean Price The</label><input type="number" class="form-control" name="cleanPriceThe" id="field_cleanPriceThe" ng-model="vm.observedData.cleanPriceThe"></div><div class="form-group"><label class="control-label" data-translate="moldovaYieldCurvesApp.observedData.accruedInterestThe" for="field_accruedInterestThe">Accrued Interest The</label><input type="number" class="form-control" name="accruedInterestThe" id="field_accruedInterestThe" ng-model="vm.observedData.accruedInterestThe"></div><div class="form-group"><label class="control-label" data-translate="moldovaYieldCurvesApp.observedData.ytmThe" for="field_ytmThe">Ytm The</label><input type="number" class="form-control" name="ytmThe" id="field_ytmThe" ng-model="vm.observedData.ytmThe"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/observed-data/observed-data.html','<div><h2 data-translate="moldovaYieldCurvesApp.observedData.home.title">Observed Data</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="observed-data.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="moldovaYieldCurvesApp.observedData.home.createLabel">Create new Observed Data</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="moldovaYieldCurvesApp.observedData.batchId">Batch Id</span></th><th><span data-translate="moldovaYieldCurvesApp.observedData.source">Source</span></th><th><span data-translate="moldovaYieldCurvesApp.observedData.isin">Isin</span></th><th><span data-translate="moldovaYieldCurvesApp.observedData.description">Desc</span></th><th><span data-translate="moldovaYieldCurvesApp.observedData.couponRate">Coupon Rate</span></th><th><span data-translate="moldovaYieldCurvesApp.observedData.freq">Freq</span></th><th><span data-translate="moldovaYieldCurvesApp.observedData.settlementDate">Settlement Date</span></th><th><span data-translate="moldovaYieldCurvesApp.observedData.tradeDate">Trade Date</span></th><th><span data-translate="moldovaYieldCurvesApp.observedData.inceptionDate">Inception Date</span></th><th><span data-translate="moldovaYieldCurvesApp.observedData.maturityDate">Maturity Date</span></th><th><span data-translate="moldovaYieldCurvesApp.observedData.dayCountConvention">Day Count Convention</span></th><th><span data-translate="moldovaYieldCurvesApp.observedData.instrumentType">Instrument Type</span></th><th><span data-translate="moldovaYieldCurvesApp.observedData.marketType">Market Type</span></th><th><span data-translate="moldovaYieldCurvesApp.observedData.ticketSize">Ticket Size</span></th><th><span data-translate="moldovaYieldCurvesApp.observedData.dirtyPriceObs">Dirty Price Obs</span></th><th><span data-translate="moldovaYieldCurvesApp.observedData.cleanPriceObs">Clean Price Obs</span></th><th><span data-translate="moldovaYieldCurvesApp.observedData.ytmObs">Ytm Obs</span></th><th><span data-translate="moldovaYieldCurvesApp.observedData.ytmMin">Ytm Min</span></th><th><span data-translate="moldovaYieldCurvesApp.observedData.ytmMax">Ytm Max</span></th><th><span data-translate="moldovaYieldCurvesApp.observedData.dirtyPriceThe">Dirty Price The</span></th><th><span data-translate="moldovaYieldCurvesApp.observedData.cleanPriceThe">Clean Price The</span></th><th><span data-translate="moldovaYieldCurvesApp.observedData.accruedInterestThe">Accrued Interest The</span></th><th><span data-translate="moldovaYieldCurvesApp.observedData.ytmThe">Ytm The</span></th><th></th></tr></thead><tbody><tr ng-repeat="observedData in vm.observedData track by observedData.id"><td><a ui-sref="observed-data-detail({id:observedData.id})">{{observedData.id}}</a></td><td>{{observedData.batchId}}</td><td>{{observedData.source}}</td><td>{{observedData.isin}}</td><td>{{observedData.description}}</td><td>{{observedData.couponRate}}</td><td>{{observedData.freq}}</td><td>{{observedData.settlementDate | date:\'mediumDate\'}}</td><td>{{observedData.tradeDate | date:\'mediumDate\'}}</td><td>{{observedData.inceptionDate | date:\'mediumDate\'}}</td><td>{{observedData.maturityDate | date:\'mediumDate\'}}</td><td>{{observedData.dayCountConvention}}</td><td>{{observedData.instrumentType}}</td><td>{{observedData.marketType}}</td><td>{{observedData.ticketSize}}</td><td>{{observedData.dirtyPriceObs}}</td><td>{{observedData.cleanPriceObs}}</td><td>{{observedData.ytmObs}}</td><td>{{observedData.ytmMin}}</td><td>{{observedData.ytmMax}}</td><td>{{observedData.dirtyPriceThe}}</td><td>{{observedData.cleanPriceThe}}</td><td>{{observedData.accruedInterestThe}}</td><td>{{observedData.ytmThe}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="observed-data-detail({id:observedData.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="observed-data.edit({id:observedData.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="observed-data.delete({id:observedData.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/paper-error/paper-error-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.paperError.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="moldovaYieldCurvesApp.paperError.delete.question" translate-values="{id: \'{{vm.paperError.id}}\'}">Are you sure you want to delete this Paper Error?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/paper-error/paper-error-detail.html','<div><h2><span data-translate="moldovaYieldCurvesApp.paperError.detail.title">Paper Error</span> {{vm.paperError.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="moldovaYieldCurvesApp.paperError.paperId">Paper Id</span></dt><dd><span>{{vm.paperError.paperId}}</span></dd><dt><span data-translate="moldovaYieldCurvesApp.paperError.settleDate">Settlement Date</span></dt><dd><span>{{vm.paperError.settleDate | date:\'mediumDate\'}}</span></dd><dt><span data-translate="moldovaYieldCurvesApp.paperError.ytmDiff">Ytm Diff</span></dt><dd><span>{{vm.paperError.ytmDiff}}</span></dd><dt><span data-translate="moldovaYieldCurvesApp.paperError.ytmObs">Ytm Obs</span></dt><dd><span>{{vm.paperError.ytmObs}}</span></dd><dt><span data-translate="moldovaYieldCurvesApp.paperError.ytmThe">Ytm The</span></dt><dd><span>{{vm.paperError.ytmThe}}</span></dd><dt><span data-translate="moldovaYieldCurvesApp.paperError.market">Market</span></dt><dd><span>{{vm.paperError.market}}</span></dd><dt><span data-translate="moldovaYieldCurvesApp.paperError.residualMaturity">Residual Maturity</span></dt><dd><span>{{vm.paperError.residualMaturity}}</span></dd><dt><span data-translate="moldovaYieldCurvesApp.paperError.weightYtm">Weight Ytm</span></dt><dd><span>{{vm.paperError.weightYtm}}</span></dd><dt><span data-translate="moldovaYieldCurvesApp.paperError.sigmaMarket">Sigma Market</span></dt><dd><span>{{vm.paperError.sigmaMarket}}</span></dd><dt><span data-translate="moldovaYieldCurvesApp.paperError.sigmaOfftherun">Sigma Offtherun</span></dt><dd><span>{{vm.paperError.sigmaOfftherun}}</span></dd><dt><span data-translate="moldovaYieldCurvesApp.paperError.sigmaRm">Sigma Rm</span></dt><dd><span>{{vm.paperError.sigmaRm}}</span></dd><dt><span data-translate="moldovaYieldCurvesApp.paperError.sigmaSpr">Sigma Spr</span></dt><dd><span>{{vm.paperError.sigmaSpr}}</span></dd><dt><span data-translate="moldovaYieldCurvesApp.paperError.sigmaVol">Sigma Vol</span></dt><dd><span>{{vm.paperError.sigmaVol}}</span></dd><dt><span data-translate="moldovaYieldCurvesApp.paperError.description">Description</span></dt><dd><span>{{vm.paperError.description}}</span></dd><dt><span data-translate="moldovaYieldCurvesApp.paperError.transDate">Transaction Date</span></dt><dd><span>{{vm.paperError.transDate | date:\'mediumDate\'}}</span></dd><dt><span data-translate="moldovaYieldCurvesApp.paperError.volume">Volume</span></dt><dd><span>{{vm.paperError.volume}}</span></dd><dt><span data-translate="moldovaYieldCurvesApp.paperError.yieldCurveResults">Yield Curve Results</span></dt><dd><a ui-sref="yield-curve-results-detail({id:vm.paperError.yieldCurveResultsId})">{{vm.paperError.yieldCurveResultsDate}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="paper-error-detail.edit({id:vm.paperError.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/paper-error/paper-error-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myPaperErrorLabel" data-translate="moldovaYieldCurvesApp.paperError.home.createOrEditLabel">Create or edit a Paper Error</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.paperError.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.paperError.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="moldovaYieldCurvesApp.paperError.paperId" for="field_paperId">Paper Id</label><input type="text" class="form-control" name="paperId" id="field_paperId" ng-model="vm.paperError.paperId" ng-minlength="2"><div ng-show="editForm.paperId.$invalid"><p class="help-block" ng-show="editForm.paperId.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="2">This field is required to be at least 2 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="moldovaYieldCurvesApp.paperError.settleDate" for="field_settleDate">Settlement Date</label><div class="input-group"><input id="field_settleDate" type="text" class="form-control" name="settleDate" uib-datepicker-popup="{{dateformat}}" ng-model="vm.paperError.settleDate" is-open="vm.datePickerOpenStatus.settleDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'settleDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="moldovaYieldCurvesApp.paperError.ytmDiff" for="field_ytmDiff">Ytm Diff</label><input type="number" class="form-control" name="ytmDiff" id="field_ytmDiff" ng-model="vm.paperError.ytmDiff"></div><div class="form-group"><label class="control-label" data-translate="moldovaYieldCurvesApp.paperError.ytmObs" for="field_ytmObs">Ytm Obs</label><input type="number" class="form-control" name="ytmObs" id="field_ytmObs" ng-model="vm.paperError.ytmObs"></div><div class="form-group"><label class="control-label" data-translate="moldovaYieldCurvesApp.paperError.ytmThe" for="field_ytmThe">Ytm The</label><input type="number" class="form-control" name="ytmThe" id="field_ytmThe" ng-model="vm.paperError.ytmThe"></div><div class="form-group"><label class="control-label" data-translate="moldovaYieldCurvesApp.paperError.market" for="field_market">Market</label><input type="text" class="form-control" name="market" id="field_market" ng-model="vm.paperError.market"></div><div class="form-group"><label class="control-label" data-translate="moldovaYieldCurvesApp.paperError.residualMaturity" for="field_residualMaturity">Residual Maturity</label><input type="number" class="form-control" name="residualMaturity" id="field_residualMaturity" ng-model="vm.paperError.residualMaturity"></div><div class="form-group"><label class="control-label" data-translate="moldovaYieldCurvesApp.paperError.weightYtm" for="field_weightYtm">Weight Ytm</label><input type="number" class="form-control" name="weightYtm" id="field_weightYtm" ng-model="vm.paperError.weightYtm"></div><div class="form-group"><label class="control-label" data-translate="moldovaYieldCurvesApp.paperError.sigmaMarket" for="field_sigmaMarket">Sigma Market</label><input type="number" class="form-control" name="sigmaMarket" id="field_sigmaMarket" ng-model="vm.paperError.sigmaMarket"></div><div class="form-group"><label class="control-label" data-translate="moldovaYieldCurvesApp.paperError.sigmaOfftherun" for="field_sigmaOfftherun">Sigma Offtherun</label><input type="number" class="form-control" name="sigmaOfftherun" id="field_sigmaOfftherun" ng-model="vm.paperError.sigmaOfftherun"></div><div class="form-group"><label class="control-label" data-translate="moldovaYieldCurvesApp.paperError.sigmaRm" for="field_sigmaRm">Sigma Rm</label><input type="number" class="form-control" name="sigmaRm" id="field_sigmaRm" ng-model="vm.paperError.sigmaRm"></div><div class="form-group"><label class="control-label" data-translate="moldovaYieldCurvesApp.paperError.sigmaSpr" for="field_sigmaSpr">Sigma Spr</label><input type="number" class="form-control" name="sigmaSpr" id="field_sigmaSpr" ng-model="vm.paperError.sigmaSpr"></div><div class="form-group"><label class="control-label" data-translate="moldovaYieldCurvesApp.paperError.sigmaVol" for="field_sigmaVol">Sigma Vol</label><input type="number" class="form-control" name="sigmaVol" id="field_sigmaVol" ng-model="vm.paperError.sigmaVol"></div><div class="form-group"><label class="control-label" data-translate="moldovaYieldCurvesApp.paperError.description" for="field_description">Description</label><input type="text" class="form-control" name="description" id="field_description" ng-model="vm.paperError.description" ng-maxlength="1023"><div ng-show="editForm.description.$invalid"><p class="help-block" ng-show="editForm.description.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="1023">This field cannot be longer than 1023 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="moldovaYieldCurvesApp.paperError.transDate" for="field_transDate">Transaction Date</label><div class="input-group"><input id="field_transDate" type="text" class="form-control" name="transDate" uib-datepicker-popup="{{dateformat}}" ng-model="vm.paperError.transDate" is-open="vm.datePickerOpenStatus.transDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'transDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="moldovaYieldCurvesApp.paperError.volume" for="field_volume">Volume</label><input type="number" class="form-control" name="volume" id="field_volume" ng-model="vm.paperError.volume"></div><div class="form-group"><label data-translate="moldovaYieldCurvesApp.paperError.yieldCurveResults" for="field_yieldCurveResults">Yield Curve Results</label><select class="form-control" id="field_yieldCurveResults" name="yieldCurveResults" ng-model="vm.paperError.yieldCurveResultsId" ng-options="yieldCurveResults.id as yieldCurveResults.date for yieldCurveResults in vm.yieldcurveresults"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/paper-error/paper-errors.html','<div><h2 data-translate="moldovaYieldCurvesApp.paperError.home.title">Paper Errors</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="paper-error.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="moldovaYieldCurvesApp.paperError.home.createLabel">Create new Paper Error</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="moldovaYieldCurvesApp.paperError.paperId">Paper Id</span></th><th><span data-translate="moldovaYieldCurvesApp.paperError.settleDate">Settlement Date</span></th><th><span data-translate="moldovaYieldCurvesApp.paperError.ytmDiff">Ytm Diff</span></th><th><span data-translate="moldovaYieldCurvesApp.paperError.ytmObs">Ytm Obs</span></th><th><span data-translate="moldovaYieldCurvesApp.paperError.ytmThe">Ytm The</span></th><th><span data-translate="moldovaYieldCurvesApp.paperError.market">Market</span></th><th><span data-translate="moldovaYieldCurvesApp.paperError.residualMaturity">Residual Maturity</span></th><th><span data-translate="moldovaYieldCurvesApp.paperError.weightYtm">Weight Ytm</span></th><th><span data-translate="moldovaYieldCurvesApp.paperError.sigmaMarket">Sigma Market</span></th><th><span data-translate="moldovaYieldCurvesApp.paperError.sigmaOfftherun">Sigma Offtherun</span></th><th><span data-translate="moldovaYieldCurvesApp.paperError.sigmaRm">Sigma Rm</span></th><th><span data-translate="moldovaYieldCurvesApp.paperError.sigmaSpr">Sigma Spr</span></th><th><span data-translate="moldovaYieldCurvesApp.paperError.sigmaVol">Sigma Vol</span></th><th><span data-translate="moldovaYieldCurvesApp.paperError.description">Description</span></th><th><span data-translate="moldovaYieldCurvesApp.paperError.transDate">Transaction Date</span></th><th><span data-translate="moldovaYieldCurvesApp.paperError.volume">Volume</span></th><th><span data-translate="moldovaYieldCurvesApp.paperError.yieldCurveResults">Yield Curve Results</span></th><th></th></tr></thead><tbody><tr ng-repeat="paperError in vm.paperErrors track by paperError.id"><td><a ui-sref="paper-error-detail({id:paperError.id})">{{paperError.id}}</a></td><td>{{paperError.paperId}}</td><td>{{paperError.settleDate | date:\'mediumDate\'}}</td><td>{{paperError.ytmDiff}}</td><td>{{paperError.ytmObs}}</td><td>{{paperError.ytmThe}}</td><td>{{paperError.market}}</td><td>{{paperError.residualMaturity}}</td><td>{{paperError.weightYtm}}</td><td>{{paperError.sigmaMarket}}</td><td>{{paperError.sigmaOfftherun}}</td><td>{{paperError.sigmaRm}}</td><td>{{paperError.sigmaSpr}}</td><td>{{paperError.sigmaVol}}</td><td>{{paperError.description}}</td><td>{{paperError.transDate | date:\'mediumDate\'}}</td><td>{{paperError.volume}}</td><td><a ui-sref="yield-curve-results-detail({id:paperError.yieldCurveResultsId})">{{paperError.yieldCurveResultsDate}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="paper-error-detail({id:paperError.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="paper-error.edit({id:paperError.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="paper-error.delete({id:paperError.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/paper-price/paper-price-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.paperPrice.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="moldovaYieldCurvesApp.paperPrice.delete.question" translate-values="{id: \'{{vm.paperPrice.id}}\'}">Are you sure you want to delete this Paper Price?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/paper-price/paper-price-detail.html','<div><h2><span data-translate="moldovaYieldCurvesApp.paperPrice.detail.title">Paper Price</span> {{vm.paperPrice.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="moldovaYieldCurvesApp.paperPrice.dirtyPrice">Dirty Price</span></dt><dd><span>{{vm.paperPrice.dirtyPrice}}</span></dd><dt><span data-translate="moldovaYieldCurvesApp.paperPrice.cleanPrice">Clean Price</span></dt><dd><span>{{vm.paperPrice.cleanPrice}}</span></dd><dt><span data-translate="moldovaYieldCurvesApp.paperPrice.ytm">Ytm</span></dt><dd><span>{{vm.paperPrice.ytm}}</span></dd><dt><span data-translate="moldovaYieldCurvesApp.paperPrice.residualMaturity">Residual Maturity</span></dt><dd><span>{{vm.paperPrice.residualMaturity}}</span></dd><dt><span data-translate="moldovaYieldCurvesApp.paperPrice.code">Code</span></dt><dd><span>{{vm.paperPrice.code}}</span></dd><dt><span data-translate="moldovaYieldCurvesApp.paperPrice.description">Description</span></dt><dd><span>{{vm.paperPrice.description}}</span></dd><dt><span data-translate="moldovaYieldCurvesApp.paperPrice.dayCount">Day Count</span></dt><dd><span>{{vm.paperPrice.dayCount}}</span></dd><dt><span data-translate="moldovaYieldCurvesApp.paperPrice.yieldCurveResults">Yield Curve Results</span></dt><dd><a ui-sref="yield-curve-results-detail({id:vm.paperPrice.yieldCurveResultsId})">{{vm.paperPrice.yieldCurveResultsId}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="paper-price-detail.edit({id:vm.paperPrice.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/paper-price/paper-price-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myPaperPriceLabel" data-translate="moldovaYieldCurvesApp.paperPrice.home.createOrEditLabel">Create or edit a Paper Price</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.paperPrice.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.paperPrice.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="moldovaYieldCurvesApp.paperPrice.dirtyPrice" for="field_dirtyPrice">Dirty Price</label><input type="number" class="form-control" name="dirtyPrice" id="field_dirtyPrice" ng-model="vm.paperPrice.dirtyPrice"></div><div class="form-group"><label class="control-label" data-translate="moldovaYieldCurvesApp.paperPrice.cleanPrice" for="field_cleanPrice">Clean Price</label><input type="number" class="form-control" name="cleanPrice" id="field_cleanPrice" ng-model="vm.paperPrice.cleanPrice"></div><div class="form-group"><label class="control-label" data-translate="moldovaYieldCurvesApp.paperPrice.ytm" for="field_ytm">Ytm</label><input type="number" class="form-control" name="ytm" id="field_ytm" ng-model="vm.paperPrice.ytm"></div><div class="form-group"><label class="control-label" data-translate="moldovaYieldCurvesApp.paperPrice.residualMaturity" for="field_residualMaturity">Residual Maturity</label><input type="number" class="form-control" name="residualMaturity" id="field_residualMaturity" ng-model="vm.paperPrice.residualMaturity"></div><div class="form-group"><label class="control-label" data-translate="moldovaYieldCurvesApp.paperPrice.code" for="field_code">Code</label><input type="text" class="form-control" name="code" id="field_code" ng-model="vm.paperPrice.code" required ng-maxlength="50"><div ng-show="editForm.code.$invalid"><p class="help-block" ng-show="editForm.code.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.code.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="moldovaYieldCurvesApp.paperPrice.description" for="field_description">Description</label><input type="text" class="form-control" name="description" id="field_description" ng-model="vm.paperPrice.description" ng-maxlength="1023"><div ng-show="editForm.description.$invalid"><p class="help-block" ng-show="editForm.description.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="1023">This field cannot be longer than 1023 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="moldovaYieldCurvesApp.paperPrice.dayCount" for="field_dayCount">Day Count</label><input type="text" class="form-control" name="dayCount" id="field_dayCount" ng-model="vm.paperPrice.dayCount" ng-maxlength="64"><div ng-show="editForm.dayCount.$invalid"><p class="help-block" ng-show="editForm.dayCount.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="64">This field cannot be longer than 64 characters.</p></div></div><div class="form-group"><label data-translate="moldovaYieldCurvesApp.paperPrice.yieldCurveResults" for="field_yieldCurveResults">Yield Curve Results</label><select class="form-control" id="field_yieldCurveResults" name="yieldCurveResults" ng-model="vm.paperPrice.yieldCurveResultsId" ng-options="yieldCurveResults.id as yieldCurveResults.id for yieldCurveResults in vm.yieldcurveresults"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/paper-price/paper-prices.html','<div><h2 data-translate="moldovaYieldCurvesApp.paperPrice.home.title">Paper Prices</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="paper-price.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="moldovaYieldCurvesApp.paperPrice.home.createLabel">Create new Paper Price</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="moldovaYieldCurvesApp.paperPrice.dirtyPrice">Dirty Price</span></th><th><span data-translate="moldovaYieldCurvesApp.paperPrice.cleanPrice">Clean Price</span></th><th><span data-translate="moldovaYieldCurvesApp.paperPrice.ytm">Ytm</span></th><th><span data-translate="moldovaYieldCurvesApp.paperPrice.residualMaturity">Residual Maturity</span></th><th><span data-translate="moldovaYieldCurvesApp.paperPrice.code">Code</span></th><th><span data-translate="moldovaYieldCurvesApp.paperPrice.description">Description</span></th><th><span data-translate="moldovaYieldCurvesApp.paperPrice.dayCount">Day Count</span></th><th><span data-translate="moldovaYieldCurvesApp.paperPrice.yieldCurveResults">Yield Curve Results</span></th><th></th></tr></thead><tbody><tr ng-repeat="paperPrice in vm.paperPrices track by paperPrice.id"><td><a ui-sref="paper-price-detail({id:paperPrice.id})">{{paperPrice.id}}</a></td><td>{{paperPrice.dirtyPrice}}</td><td>{{paperPrice.cleanPrice}}</td><td>{{paperPrice.ytm}}</td><td>{{paperPrice.residualMaturity}}</td><td>{{paperPrice.code}}</td><td>{{paperPrice.description}}</td><td>{{paperPrice.dayCount}}</td><td><a ui-sref="yield-curve-results-detail({id:paperPrice.yieldCurveResultsId})">{{paperPrice.yieldCurveResultsId}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="paper-price-detail({id:paperPrice.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="paper-price.edit({id:paperPrice.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="paper-price.delete({id:paperPrice.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/par-curve-point/par-curve-point-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.parCurvePoint.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="moldovaYieldCurvesApp.parCurvePoint.delete.question" translate-values="{id: \'{{vm.parCurvePoint.id}}\'}">Are you sure you want to delete this Par Curve Point?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/par-curve-point/par-curve-point-detail.html','<div><h2><span data-translate="moldovaYieldCurvesApp.parCurvePoint.detail.title">Par Curve Point</span> {{vm.parCurvePoint.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="moldovaYieldCurvesApp.parCurvePoint.date">Date</span></dt><dd><span>{{vm.parCurvePoint.date | date:\'mediumDate\'}}</span></dd><dt><span data-translate="moldovaYieldCurvesApp.parCurvePoint.str">Str</span></dt><dd><span>{{vm.parCurvePoint.str}}</span></dd><dt><span data-translate="moldovaYieldCurvesApp.parCurvePoint.deltaPeriods">Delta Periods</span></dt><dd><span>{{vm.parCurvePoint.deltaPeriods}}</span></dd><dt><span data-translate="moldovaYieldCurvesApp.parCurvePoint.parRate">Par Rate</span></dt><dd><span>{{vm.parCurvePoint.parRate}}</span></dd><dt><span data-translate="moldovaYieldCurvesApp.parCurvePoint.yieldCurveResults">Yield Curve Results</span></dt><dd><a ui-sref="yield-curve-results-detail({id:vm.parCurvePoint.yieldCurveResultsId})">{{vm.parCurvePoint.yieldCurveResultsId}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="par-curve-point-detail.edit({id:vm.parCurvePoint.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/par-curve-point/par-curve-point-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myParCurvePointLabel" data-translate="moldovaYieldCurvesApp.parCurvePoint.home.createOrEditLabel">Create or edit a Par Curve Point</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.parCurvePoint.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.parCurvePoint.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="moldovaYieldCurvesApp.parCurvePoint.date" for="field_date">Date</label><div class="input-group"><input id="field_date" type="text" class="form-control" name="date" uib-datepicker-popup="{{dateformat}}" ng-model="vm.parCurvePoint.date" is-open="vm.datePickerOpenStatus.date"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'date\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="moldovaYieldCurvesApp.parCurvePoint.str" for="field_str">Str</label><input type="text" class="form-control" name="str" id="field_str" ng-model="vm.parCurvePoint.str" ng-maxlength="50"><div ng-show="editForm.str.$invalid"><p class="help-block" ng-show="editForm.str.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="moldovaYieldCurvesApp.parCurvePoint.deltaPeriods" for="field_deltaPeriods">Delta Periods</label><input type="number" class="form-control" name="deltaPeriods" id="field_deltaPeriods" ng-model="vm.parCurvePoint.deltaPeriods"></div><div class="form-group"><label class="control-label" data-translate="moldovaYieldCurvesApp.parCurvePoint.parRate" for="field_parRate">Par Rate</label><input type="number" class="form-control" name="parRate" id="field_parRate" ng-model="vm.parCurvePoint.parRate"></div><div class="form-group"><label data-translate="moldovaYieldCurvesApp.parCurvePoint.yieldCurveResults" for="field_yieldCurveResults">Yield Curve Results</label><select class="form-control" id="field_yieldCurveResults" name="yieldCurveResults" ng-model="vm.parCurvePoint.yieldCurveResultsId" ng-options="yieldCurveResults.id as yieldCurveResults.id for yieldCurveResults in vm.yieldcurveresults"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/par-curve-point/par-curve-points.html','<div><h2 data-translate="moldovaYieldCurvesApp.parCurvePoint.home.title">Par Curve Points</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="par-curve-point.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="moldovaYieldCurvesApp.parCurvePoint.home.createLabel">Create new Par Curve Point</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="moldovaYieldCurvesApp.parCurvePoint.date">Date</span></th><th><span data-translate="moldovaYieldCurvesApp.parCurvePoint.str">Str</span></th><th><span data-translate="moldovaYieldCurvesApp.parCurvePoint.deltaPeriods">Delta Periods</span></th><th><span data-translate="moldovaYieldCurvesApp.parCurvePoint.parRate">Par Rate</span></th><th><span data-translate="moldovaYieldCurvesApp.parCurvePoint.yieldCurveResults">Yield Curve Results</span></th><th></th></tr></thead><tbody><tr ng-repeat="parCurvePoint in vm.parCurvePoints track by parCurvePoint.id"><td><a ui-sref="par-curve-point-detail({id:parCurvePoint.id})">{{parCurvePoint.id}}</a></td><td>{{parCurvePoint.date | date:\'mediumDate\'}}</td><td>{{parCurvePoint.str}}</td><td>{{parCurvePoint.deltaPeriods}}</td><td>{{parCurvePoint.parRate}}</td><td><a ui-sref="yield-curve-results-detail({id:parCurvePoint.yieldCurveResultsId})">{{parCurvePoint.yieldCurveResultsId}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="par-curve-point-detail({id:parCurvePoint.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="par-curve-point.edit({id:parCurvePoint.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="par-curve-point.delete({id:parCurvePoint.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/quoting/quoting-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.quoting.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="moldovaYieldCurvesApp.quoting.delete.question" translate-values="{id: \'{{vm.quoting.id}}\'}">Are you sure you want to delete this Quoting?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/quoting/quoting-detail.html','<div><h2><span data-translate="moldovaYieldCurvesApp.quoting.detail.title">Quoting</span> {{vm.quoting.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="moldovaYieldCurvesApp.quoting.compound">Compound</span></dt><dd><span>{{vm.quoting.compound}}</span></dd><dt><span data-translate="moldovaYieldCurvesApp.quoting.parCouponFreq">Par Coupon Freq</span></dt><dd><span>{{vm.quoting.parCouponFreq}}</span></dd><dt><span data-translate="moldovaYieldCurvesApp.quoting.deltaPeriods">Delta Periods</span></dt><dd><span>{{vm.quoting.deltaPeriods}}</span></dd><dt><span data-translate="moldovaYieldCurvesApp.quoting.zeroRate">Zero Rate</span></dt><dd><span>{{vm.quoting.zeroRate}}</span></dd><dt><span data-translate="moldovaYieldCurvesApp.quoting.forwardRate">Forward Rate</span></dt><dd><span>{{vm.quoting.forwardRate}}</span></dd><dt><span data-translate="moldovaYieldCurvesApp.quoting.parRate">Par Rate</span></dt><dd><span>{{vm.quoting.parRate}}</span></dd><dt><span data-translate="moldovaYieldCurvesApp.quoting.dirtyPrice">Dirty Price</span></dt><dd><span>{{vm.quoting.dirtyPrice}}</span></dd><dt><span data-translate="moldovaYieldCurvesApp.quoting.cleanPrice">Clean Price</span></dt><dd><span>{{vm.quoting.cleanPrice}}</span></dd><dt><span data-translate="moldovaYieldCurvesApp.quoting.ytm">Ytm</span></dt><dd><span>{{vm.quoting.ytm}}</span></dd><dt><span data-translate="moldovaYieldCurvesApp.quoting.residualMaturity">Residual Maturity</span></dt><dd><span>{{vm.quoting.residualMaturity}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="quoting-detail.edit({id:vm.quoting.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/quoting/quoting-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myQuotingLabel" data-translate="moldovaYieldCurvesApp.quoting.home.createOrEditLabel">Create or edit a Quoting</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.quoting.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.quoting.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="moldovaYieldCurvesApp.quoting.compound" for="field_compound">Compound</label><input type="number" class="form-control" name="compound" id="field_compound" ng-model="vm.quoting.compound"></div><div class="form-group"><label class="control-label" data-translate="moldovaYieldCurvesApp.quoting.parCouponFreq" for="field_parCouponFreq">Par Coupon Freq</label><input type="number" class="form-control" name="parCouponFreq" id="field_parCouponFreq" ng-model="vm.quoting.parCouponFreq"></div><div class="form-group"><label class="control-label" data-translate="moldovaYieldCurvesApp.quoting.deltaPeriods" for="field_deltaPeriods">Delta Periods</label><input type="text" class="form-control" name="deltaPeriods" id="field_deltaPeriods" ng-model="vm.quoting.deltaPeriods"></div><div class="form-group"><label class="control-label" data-translate="moldovaYieldCurvesApp.quoting.zeroRate" for="field_zeroRate">Zero Rate</label><input type="text" class="form-control" name="zeroRate" id="field_zeroRate" ng-model="vm.quoting.zeroRate" ng-maxlength="100"><div ng-show="editForm.zeroRate.$invalid"><p class="help-block" ng-show="editForm.zeroRate.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="moldovaYieldCurvesApp.quoting.forwardRate" for="field_forwardRate">Forward Rate</label><input type="text" class="form-control" name="forwardRate" id="field_forwardRate" ng-model="vm.quoting.forwardRate" ng-maxlength="100"><div ng-show="editForm.forwardRate.$invalid"><p class="help-block" ng-show="editForm.forwardRate.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="moldovaYieldCurvesApp.quoting.parRate" for="field_parRate">Par Rate</label><input type="text" class="form-control" name="parRate" id="field_parRate" ng-model="vm.quoting.parRate" ng-maxlength="100"><div ng-show="editForm.parRate.$invalid"><p class="help-block" ng-show="editForm.parRate.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="moldovaYieldCurvesApp.quoting.dirtyPrice" for="field_dirtyPrice">Dirty Price</label><input type="text" class="form-control" name="dirtyPrice" id="field_dirtyPrice" ng-model="vm.quoting.dirtyPrice" ng-maxlength="100"><div ng-show="editForm.dirtyPrice.$invalid"><p class="help-block" ng-show="editForm.dirtyPrice.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="moldovaYieldCurvesApp.quoting.cleanPrice" for="field_cleanPrice">Clean Price</label><input type="text" class="form-control" name="cleanPrice" id="field_cleanPrice" ng-model="vm.quoting.cleanPrice" ng-maxlength="100"><div ng-show="editForm.cleanPrice.$invalid"><p class="help-block" ng-show="editForm.cleanPrice.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="moldovaYieldCurvesApp.quoting.ytm" for="field_ytm">Ytm</label><input type="text" class="form-control" name="ytm" id="field_ytm" ng-model="vm.quoting.ytm" ng-maxlength="100"><div ng-show="editForm.ytm.$invalid"><p class="help-block" ng-show="editForm.ytm.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="moldovaYieldCurvesApp.quoting.residualMaturity" for="field_residualMaturity">Residual Maturity</label><input type="text" class="form-control" name="residualMaturity" id="field_residualMaturity" ng-model="vm.quoting.residualMaturity" ng-maxlength="10"><div ng-show="editForm.residualMaturity.$invalid"><p class="help-block" ng-show="editForm.residualMaturity.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="10">This field cannot be longer than 10 characters.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/quoting/quotings.html','<div><h2 data-translate="moldovaYieldCurvesApp.quoting.home.title">Quotings</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="quoting.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="moldovaYieldCurvesApp.quoting.home.createLabel">Create new Quoting</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="moldovaYieldCurvesApp.quoting.compound">Compound</span></th><th><span data-translate="moldovaYieldCurvesApp.quoting.parCouponFreq">Par Coupon Freq</span></th><th><span data-translate="moldovaYieldCurvesApp.quoting.deltaPeriods">Delta Periods</span></th><th><span data-translate="moldovaYieldCurvesApp.quoting.zeroRate">Zero Rate</span></th><th><span data-translate="moldovaYieldCurvesApp.quoting.forwardRate">Forward Rate</span></th><th><span data-translate="moldovaYieldCurvesApp.quoting.parRate">Par Rate</span></th><th><span data-translate="moldovaYieldCurvesApp.quoting.dirtyPrice">Dirty Price</span></th><th><span data-translate="moldovaYieldCurvesApp.quoting.cleanPrice">Clean Price</span></th><th><span data-translate="moldovaYieldCurvesApp.quoting.ytm">Ytm</span></th><th><span data-translate="moldovaYieldCurvesApp.quoting.residualMaturity">Residual Maturity</span></th><th></th></tr></thead><tbody><tr ng-repeat="quoting in vm.quotings track by quoting.id"><td><a ui-sref="quoting-detail({id:quoting.id})">{{quoting.id}}</a></td><td>{{quoting.compound}}</td><td>{{quoting.parCouponFreq}}</td><td>{{quoting.deltaPeriods}}</td><td>{{quoting.zeroRate}}</td><td>{{quoting.forwardRate}}</td><td>{{quoting.parRate}}</td><td>{{quoting.dirtyPrice}}</td><td>{{quoting.cleanPrice}}</td><td>{{quoting.ytm}}</td><td>{{quoting.residualMaturity}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="quoting-detail({id:quoting.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="quoting.edit({id:quoting.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="quoting.delete({id:quoting.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/translation/translation-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.translation.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="moldovaYieldCurvesApp.translation.delete.question" translate-values="{id: \'{{vm.translation.id}}\'}">Are you sure you want to delete this Translation?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/translation/translation-detail.html','<div><h2><span data-translate="moldovaYieldCurvesApp.translation.detail.title">Translation</span> {{vm.translation.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="moldovaYieldCurvesApp.translation.keyPhrase">Key Phrase</span></dt><dd><span>{{vm.translation.keyPhrase}}</span></dd><dt><span data-translate="moldovaYieldCurvesApp.translation.languageKey">Language Key</span></dt><dd><span>{{vm.translation.languageKey}}</span></dd><dt><span data-translate="moldovaYieldCurvesApp.translation.translation">Translation</span></dt><dd><span>{{vm.translation.translation}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="translation-detail.edit({id:vm.translation.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/translation/translation-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myTranslationLabel" data-translate="moldovaYieldCurvesApp.translation.home.createOrEditLabel">Create or edit a Translation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.translation.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.translation.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="moldovaYieldCurvesApp.translation.keyPhrase" for="field_keyPhrase">Key Phrase</label><input type="text" class="form-control" name="keyPhrase" id="field_keyPhrase" ng-model="vm.translation.keyPhrase" required ng-maxlength="65535"><div ng-show="editForm.keyPhrase.$invalid"><p class="help-block" ng-show="editForm.keyPhrase.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.keyPhrase.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="65535">This field cannot be longer than 65535 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="moldovaYieldCurvesApp.translation.languageKey" for="field_languageKey">Language Key</label><input type="text" class="form-control" name="languageKey" id="field_languageKey" ng-model="vm.translation.languageKey" required ng-maxlength="5"><div ng-show="editForm.languageKey.$invalid"><p class="help-block" ng-show="editForm.languageKey.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.languageKey.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="5">This field cannot be longer than 5 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="moldovaYieldCurvesApp.translation.translation" for="field_translation">Translation</label><input type="text" class="form-control" name="translation" id="field_translation" ng-model="vm.translation.translation" required ng-maxlength="65535"><div ng-show="editForm.translation.$invalid"><p class="help-block" ng-show="editForm.translation.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.translation.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="65535">This field cannot be longer than 65535 characters.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/translation/translations.html','<div><h2 data-translate="moldovaYieldCurvesApp.translation.home.title">Translations</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="translation.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="moldovaYieldCurvesApp.translation.home.createLabel">Create new Translation</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="moldovaYieldCurvesApp.translation.keyPhrase">Key Phrase</span></th><th><span data-translate="moldovaYieldCurvesApp.translation.languageKey">Language Key</span></th><th><span data-translate="moldovaYieldCurvesApp.translation.translation">Translation</span></th><th></th></tr></thead><tbody><tr ng-repeat="translation in vm.translations track by translation.id"><td><a ui-sref="translation-detail({id:translation.id})">{{translation.id}}</a></td><td>{{translation.keyPhrase}}</td><td>{{translation.languageKey}}</td><td>{{translation.translation}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="translation-detail({id:translation.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="translation.edit({id:translation.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="translation.delete({id:translation.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/yield-curve-point/yield-curve-point-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.yieldCurvePoint.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="moldovaYieldCurvesApp.yieldCurvePoint.delete.question" translate-values="{id: \'{{vm.yieldCurvePoint.id}}\'}">Are you sure you want to delete this Yield Curve Point?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/yield-curve-point/yield-curve-point-detail.html','<div><h2><span data-translate="moldovaYieldCurvesApp.yieldCurvePoint.detail.title">Yield Curve Point</span> {{vm.yieldCurvePoint.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="moldovaYieldCurvesApp.yieldCurvePoint.date">Date</span></dt><dd><span>{{vm.yieldCurvePoint.date | date:\'mediumDate\'}}</span></dd><dt><span data-translate="moldovaYieldCurvesApp.yieldCurvePoint.str">Str</span></dt><dd><span>{{vm.yieldCurvePoint.str}}</span></dd><dt><span data-translate="moldovaYieldCurvesApp.yieldCurvePoint.deltaPeriods">Delta Periods</span></dt><dd><span>{{vm.yieldCurvePoint.deltaPeriods}}</span></dd><dt><span data-translate="moldovaYieldCurvesApp.yieldCurvePoint.discount">Discount</span></dt><dd><span>{{vm.yieldCurvePoint.discount}}</span></dd><dt><span data-translate="moldovaYieldCurvesApp.yieldCurvePoint.zeroRate">Zero Rate</span></dt><dd><span>{{vm.yieldCurvePoint.zeroRate}}</span></dd><dt><span data-translate="moldovaYieldCurvesApp.yieldCurvePoint.forwardRate">Forward Rate</span></dt><dd><span>{{vm.yieldCurvePoint.forwardRate}}</span></dd><dt><span data-translate="moldovaYieldCurvesApp.yieldCurvePoint.yieldCurveResults">Yield Curve Results</span></dt><dd><a ui-sref="yield-curve-results-detail({id:vm.yieldCurvePoint.yieldCurveResultsId})">{{vm.yieldCurvePoint.yieldCurveResultsId}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="yield-curve-point-detail.edit({id:vm.yieldCurvePoint.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/yield-curve-point/yield-curve-point-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myYieldCurvePointLabel" data-translate="moldovaYieldCurvesApp.yieldCurvePoint.home.createOrEditLabel">Create or edit a Yield Curve Point</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.yieldCurvePoint.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.yieldCurvePoint.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="moldovaYieldCurvesApp.yieldCurvePoint.date" for="field_date">Date</label><div class="input-group"><input id="field_date" type="text" class="form-control" name="date" uib-datepicker-popup="{{dateformat}}" ng-model="vm.yieldCurvePoint.date" is-open="vm.datePickerOpenStatus.date"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'date\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="moldovaYieldCurvesApp.yieldCurvePoint.str" for="field_str">Str</label><input type="text" class="form-control" name="str" id="field_str" ng-model="vm.yieldCurvePoint.str" ng-maxlength="50"><div ng-show="editForm.str.$invalid"><p class="help-block" ng-show="editForm.str.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="moldovaYieldCurvesApp.yieldCurvePoint.deltaPeriods" for="field_deltaPeriods">Delta Periods</label><input type="number" class="form-control" name="deltaPeriods" id="field_deltaPeriods" ng-model="vm.yieldCurvePoint.deltaPeriods"></div><div class="form-group"><label class="control-label" data-translate="moldovaYieldCurvesApp.yieldCurvePoint.discount" for="field_discount">Discount</label><input type="number" class="form-control" name="discount" id="field_discount" ng-model="vm.yieldCurvePoint.discount"></div><div class="form-group"><label class="control-label" data-translate="moldovaYieldCurvesApp.yieldCurvePoint.zeroRate" for="field_zeroRate">Zero Rate</label><input type="number" class="form-control" name="zeroRate" id="field_zeroRate" ng-model="vm.yieldCurvePoint.zeroRate"></div><div class="form-group"><label class="control-label" data-translate="moldovaYieldCurvesApp.yieldCurvePoint.forwardRate" for="field_forwardRate">Forward Rate</label><input type="number" class="form-control" name="forwardRate" id="field_forwardRate" ng-model="vm.yieldCurvePoint.forwardRate"></div><div class="form-group"><label data-translate="moldovaYieldCurvesApp.yieldCurvePoint.yieldCurveResults" for="field_yieldCurveResults">Yield Curve Results</label><select class="form-control" id="field_yieldCurveResults" name="yieldCurveResults" ng-model="vm.yieldCurvePoint.yieldCurveResultsId" ng-options="yieldCurveResults.id as yieldCurveResults.id for yieldCurveResults in vm.yieldcurveresults"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/yield-curve-point/yield-curve-points.html','<div><h2 data-translate="moldovaYieldCurvesApp.yieldCurvePoint.home.title">Yield Curve Points</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="yield-curve-point.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="moldovaYieldCurvesApp.yieldCurvePoint.home.createLabel">Create new Yield Curve Point</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="moldovaYieldCurvesApp.yieldCurvePoint.date">Date</span></th><th><span data-translate="moldovaYieldCurvesApp.yieldCurvePoint.str">Str</span></th><th><span data-translate="moldovaYieldCurvesApp.yieldCurvePoint.deltaPeriods">Delta Periods</span></th><th><span data-translate="moldovaYieldCurvesApp.yieldCurvePoint.discount">Discount</span></th><th><span data-translate="moldovaYieldCurvesApp.yieldCurvePoint.zeroRate">Zero Rate</span></th><th><span data-translate="moldovaYieldCurvesApp.yieldCurvePoint.forwardRate">Forward Rate</span></th><th><span data-translate="moldovaYieldCurvesApp.yieldCurvePoint.yieldCurveResults">Yield Curve Results</span></th><th></th></tr></thead><tbody><tr ng-repeat="yieldCurvePoint in vm.yieldCurvePoints track by yieldCurvePoint.id"><td><a ui-sref="yield-curve-point-detail({id:yieldCurvePoint.id})">{{yieldCurvePoint.id}}</a></td><td>{{yieldCurvePoint.date | date:\'mediumDate\'}}</td><td>{{yieldCurvePoint.str}}</td><td>{{yieldCurvePoint.deltaPeriods}}</td><td>{{yieldCurvePoint.discount}}</td><td>{{yieldCurvePoint.zeroRate}}</td><td>{{yieldCurvePoint.forwardRate}}</td><td><a ui-sref="yield-curve-results-detail({id:yieldCurvePoint.yieldCurveResultsId})">{{yieldCurvePoint.yieldCurveResultsId}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="yield-curve-point-detail({id:yieldCurvePoint.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="yield-curve-point.edit({id:yieldCurvePoint.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="yield-curve-point.delete({id:yieldCurvePoint.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/yield-curve-results/yield-curve-results-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.yieldCurveResults.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="moldovaYieldCurvesApp.yieldCurveResults.delete.question" translate-values="{id: \'{{vm.yieldCurveResults.id}}\'}">Are you sure you want to delete this Yield Curve Results?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/yield-curve-results/yield-curve-results-detail.html','<div><h2><span data-translate="moldovaYieldCurvesApp.yieldCurveResults.detail.title">Yield Curve Results</span> {{vm.yieldCurveResults.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="moldovaYieldCurvesApp.yieldCurveResults.m">M</span></dt><dd><span>{{vm.yieldCurveResults.m}}</span></dd><dt><span data-translate="moldovaYieldCurvesApp.yieldCurveResults.codeRevisionDate">Code Revision Date</span></dt><dd><span>{{vm.yieldCurveResults.codeRevisionDate}}</span></dd><dt><span data-translate="moldovaYieldCurvesApp.yieldCurveResults.codeRevisionNumber">Code Revision Number</span></dt><dd><span>{{vm.yieldCurveResults.codeRevisionNumber}}</span></dd><dt><span data-translate="moldovaYieldCurvesApp.yieldCurveResults.date">Date</span></dt><dd><span>{{vm.yieldCurveResults.date | date:\'mediumDate\'}}</span></dd><dt><span data-translate="moldovaYieldCurvesApp.yieldCurveResults.quoting">Quoting</span></dt><dd><a ui-sref="quoting-detail({id:vm.yieldCurveResults.quotingId})">{{vm.yieldCurveResults.quotingId}}</a></dd><dt><span data-translate="moldovaYieldCurvesApp.yieldCurveResults.epmParams">EPM Params</span></dt><dd><a ui-sref="epm-params-detail({id:vm.yieldCurveResults.epmParamsId})">{{vm.yieldCurveResults.epmParamsId}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="yield-curve-results-detail.edit({id:vm.yieldCurveResults.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/yield-curve-results/yield-curve-results-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myYieldCurveResultsLabel" data-translate="moldovaYieldCurvesApp.yieldCurveResults.home.createOrEditLabel">Create or edit a Yield Curve Results</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.yieldCurveResults.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.yieldCurveResults.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="moldovaYieldCurvesApp.yieldCurveResults.m" for="field_m">M</label><input type="number" class="form-control" name="m" id="field_m" ng-model="vm.yieldCurveResults.m"></div><div class="form-group"><label class="control-label" data-translate="moldovaYieldCurvesApp.yieldCurveResults.codeRevisionDate" for="field_codeRevisionDate">Code Revision Date</label><input type="text" class="form-control" name="codeRevisionDate" id="field_codeRevisionDate" ng-model="vm.yieldCurveResults.codeRevisionDate" ng-maxlength="50"><div ng-show="editForm.codeRevisionDate.$invalid"><p class="help-block" ng-show="editForm.codeRevisionDate.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="moldovaYieldCurvesApp.yieldCurveResults.codeRevisionNumber" for="field_codeRevisionNumber">Code Revision Number</label><input type="text" class="form-control" name="codeRevisionNumber" id="field_codeRevisionNumber" ng-model="vm.yieldCurveResults.codeRevisionNumber" ng-maxlength="50"><div ng-show="editForm.codeRevisionNumber.$invalid"><p class="help-block" ng-show="editForm.codeRevisionNumber.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="moldovaYieldCurvesApp.yieldCurveResults.date" for="field_date">Date</label><div class="input-group"><input id="field_date" type="text" class="form-control" name="date" uib-datepicker-popup="{{dateformat}}" ng-model="vm.yieldCurveResults.date" is-open="vm.datePickerOpenStatus.date" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'date\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.date.$invalid"><p class="help-block" ng-show="editForm.date.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label data-translate="moldovaYieldCurvesApp.yieldCurveResults.quoting" for="field_quoting">Quoting</label><select class="form-control" id="field_quoting" name="quoting" ng-model="vm.yieldCurveResults.quotingId" ng-options="quoting.id as quoting.id for quoting in vm.quotings | orderBy:\'id\'"><option value=""></option></select></div><div class="form-group"><label data-translate="moldovaYieldCurvesApp.yieldCurveResults.epmParams" for="field_epmParams">EPM Params</label><select class="form-control" id="field_epmParams" name="epmParams" ng-model="vm.yieldCurveResults.epmParamsId" ng-options="epmParams.id as epmParams.id for epmParams in vm.epmparams | orderBy:\'id\'"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/yield-curve-results/yield-curve-results.html','<div><h2 data-translate="moldovaYieldCurvesApp.yieldCurveResults.home.title">Yield Curve Results</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="yield-curve-results.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="moldovaYieldCurvesApp.yieldCurveResults.home.createLabel">Create new Yield Curve Results</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="moldovaYieldCurvesApp.yieldCurveResults.m">M</span></th><th><span data-translate="moldovaYieldCurvesApp.yieldCurveResults.codeRevisionDate">Code Revision Date</span></th><th><span data-translate="moldovaYieldCurvesApp.yieldCurveResults.codeRevisionNumber">Code Revision Number</span></th><th><span data-translate="moldovaYieldCurvesApp.yieldCurveResults.date">Date</span></th><th><span data-translate="moldovaYieldCurvesApp.yieldCurveResults.quoting">Quoting</span></th><th><span data-translate="moldovaYieldCurvesApp.yieldCurveResults.epmParams">EPM Params</span></th><th></th></tr></thead><tbody><tr ng-repeat="yieldCurveResults in vm.yieldCurveResults track by yieldCurveResults.id"><td><a ui-sref="yield-curve-results-detail({id:yieldCurveResults.id})">{{yieldCurveResults.id}}</a></td><td>{{yieldCurveResults.m}}</td><td>{{yieldCurveResults.codeRevisionDate}}</td><td>{{yieldCurveResults.codeRevisionNumber}}</td><td>{{yieldCurveResults.date | date:\'mediumDate\'}}</td><td><a ui-sref="quoting-detail({id:yieldCurveResults.quotingId})">{{yieldCurveResults.quotingId}}</a></td><td><a ui-sref="epm-params-detail({id:yieldCurveResults.epmParamsId})">{{yieldCurveResults.epmParamsId}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="yield-curve-results-detail({id:yieldCurveResults.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="yield-curve-results.edit({id:yieldCurveResults.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="yield-curve-results.delete({id:yieldCurveResults.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/layouts/error/accessdenied.html','<div ng-cloak><div class="row"><div class="col-md-4"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-8"><h1 data-translate="error.title">Error Page!</h1><div class="alert alert-danger" data-translate="error.403">You are not authorized to access the page.</div></div></div></div>');
$templateCache.put('app/layouts/error/error.html','<div ng-cloak><div class="row"><div class="col-md-4"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-8"><h1 data-translate="error.title">Error Page!</h1><div ng-show="errorMessage"><div class="alert alert-danger">{{errorMessage}}</div></div></div></div></div>');
$templateCache.put('app/layouts/footer/footer.html','<div class="footer" ng-cloak><hr><p data-translate="footer">Copyright \xA9 2023 OGResearch, s.r.o. All rights reserved.</p></div>');
$templateCache.put('app/layouts/navbar/navbar.html','<nav class="navbar navbar-default" role="navigation"><div class="container"><div class="navbar-header"><button type="button" class="navbar-toggle" ng-click="vm.toggleNavbar()"><span class="sr-only">Toggle navigation</span> <span class="icon-bar"></span> <span class="icon-bar"></span> <span class="icon-bar"></span></button> <a class="navbar-brand logo" href="#/" ng-click="vm.collapseNavbar()"><img class="logo-img" src="content/images/logo.png" alt="logo"> <span data-translate="global.title">Moldova_yield_curves</span><!--<span class="navbar-version">v{{VERSION}}</span>--></a></div><div class="navbar-collapse" uib-collapse="vm.isNavbarCollapsed" ng-switch="vm.isAuthenticated()"><ul class="nav navbar-nav navbar-right"><li ui-sref-active="active" has-authority="ROLE_ADMIN"><a ui-sref="home" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-home"></span> <span class="hidden-sm" data-translate="global.menu.home">Home</span></a></li><!-- jhipster-needle-add-element-to-menu - JHipster will add new menu items here --><li ng-class="{active: vm.$state.includes(\'entity\')}" ng-switch-when="true" has-authority="ROLE_ADMIN" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="entity-menu"><span><span class="glyphicon glyphicon-th-list"></span> <span class="hidden-sm" data-translate="global.menu.entities.main">Entities </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="translation" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.translation">Translation</span></a></li><li ui-sref-active="active"><a ui-sref="file-store" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.fileStore">File Store</span></a></li><li ui-sref-active="active"><a ui-sref="quoting" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.quoting">Quoting</span></a></li><li ui-sref-active="active"><a ui-sref="yield-curve-point" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.yieldCurvePoint">Yield Curve Point</span></a></li><li ui-sref-active="active"><a ui-sref="par-curve-point" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.parCurvePoint">Par Curve Point</span></a></li><li ui-sref-active="active"><a ui-sref="paper-price" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.paperPrice">Paper Price</span></a></li><li ui-sref-active="active"><a ui-sref="epm-params" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.epmParams">Epm Params</span></a></li><li ui-sref-active="active"><a ui-sref="yield-curve-results" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.yieldCurveResults">Yield Curve Results</span></a></li><li ui-sref-active="active"><a ui-sref="observed-data" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.observedData">Observed Data</span></a></li><li ui-sref-active="active"><a ui-sref="paper-error" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.paperError">Paper Error</span></a></li><!-- jhipster-needle-add-entity-to-menu - JHipster will add entities to the menu here --></ul></li><li ui-sref-active="active" ng-switch-when="false"><a href="" ng-click="vm.login()" id="login"><span class="glyphicon glyphicon-user"></span> <span class="hidden-sm" data-translate="global.menu.account.login">Sign in</span></a></li><li ng-class="{active: vm.$state.includes(\'account\')}" ng-switch-when="true" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="account-menu"><span><span class="glyphicon glyphicon-user"></span> <span class="hidden-sm" data-translate="global.menu.account.main">Account </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="settings" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-wrench"></span>&nbsp; <span data-translate="global.menu.account.settings">Settings</span></a></li><li ui-sref-active="active"><a ui-sref="password" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-lock"></span>&nbsp; <span data-translate="global.menu.account.password">Password</span></a></li><li ui-sref-active="active"><a href="" ng-click="vm.logout()" id="logout"><span class="glyphicon glyphicon-log-out"></span>&nbsp; <span data-translate="global.menu.account.logout">Sign out</span></a></li><!--<li ui-sref-active="active" ng-switch-when="false">--><!--<a href="" ng-click="vm.login()" id="login">--><!--<span class="glyphicon glyphicon-log-in"></span>&nbsp;--><!--<span data-translate="global.menu.account.login">Sign in</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active" ng-switch-when="false">\n                            <a ui-sref="register" ng-click="vm.collapseNavbar()">\n                                <span class="glyphicon glyphicon-plus-sign"></span>&nbsp;\n                                <span data-translate="global.menu.account.register">Register</span>\n                            </a>\n                        </li>--></ul></li><li ng-class="{active: vm.$state.includes(\'admin\')}" ng-switch-when="true" has-any-authority="ROLE_ADMIN,ROLE_SUPERUSER" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="admin-menu"><span><span class="glyphicon glyphicon-tower"></span> <span class="hidden-sm" data-translate="global.menu.admin.main">Administration</span> <b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="user-management" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-user"></span>&nbsp; <span data-translate="global.menu.admin.userManagement">User management</span></a></li><li ui-sref-active="active"><a ui-sref="translation" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.translation">Excel Translations</span></a></li><!--                        <li ui-sref-active="active">--><!--                            <a ui-sref="curve-limits" ng-click="vm.collapseNavbar()">--><!--                                <span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--                                <span data-translate="global.menu.entities.curveLimits">Yield Curve Limits</span>--><!--                            </a>--><!--                        </li>--><li ui-sref-active="active" has-authority="ROLE_ADMIN"><a ui-sref="jhi-metrics" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-dashboard"></span>&nbsp; <span data-translate="global.menu.admin.metrics">Metrics</span></a></li><li ui-sref-active="active" has-authority="ROLE_ADMIN"><a ui-sref="jhi-health" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-heart"></span>&nbsp; <span data-translate="global.menu.admin.health">Health</span></a></li><li ui-sref-active="active" has-authority="ROLE_ADMIN"><a ui-sref="jhi-configuration" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-list-alt"></span>&nbsp; <span data-translate="global.menu.admin.configuration">Configuration</span></a></li><li ui-sref-active="active" has-authority="ROLE_ADMIN"><a ui-sref="audits" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-bell"></span>&nbsp; <span data-translate="global.menu.admin.audits">Audits</span></a></li><li ui-sref-active="active" has-authority="ROLE_ADMIN"><a ui-sref="logs" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-tasks"></span>&nbsp; <span data-translate="global.menu.admin.logs">Logs</span></a></li><li ng-show="vm.swaggerEnabled" ui-sref-active="active" has-authority="ROLE_ADMIN"><a ui-sref="docs" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-book"></span>&nbsp; <span data-translate="global.menu.admin.apidocs">API</span></a></li><!-- jhipster-needle-add-element-to-admin-menu - JHipster will add entities to the admin menu here --><li ng-hide="vm.inProduction" has-authority="ROLE_ADMIN"><a href="/h2-console" target="_tab" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-hdd"></span>&nbsp; <span data-translate="global.menu.admin.database">Database</span></a></li></ul></li><li ui-sref-active="active" uib-dropdown class="dropdown pointer" ng-controller="JhiLanguageController as languageVm"><a class="dropdown-toggle" uib-dropdown-toggle href="" ng-if="languageVm.languages.length > 1"><span><span class="glyphicon glyphicon-flag"></span> <span class="hidden-sm" data-translate="global.menu.language">Language</span> <b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu ng-if="languageVm.languages.length > 1"><li active-menu="{{language}}" ng-repeat="language in languageVm.languages"><a href="" ng-click="languageVm.changeLanguage(language);vm.collapseNavbar();">{{language | findLanguageFromKey}}</a></li></ul></li></ul></div></div></nav>');
$templateCache.put('app/account/reset/finish/reset.finish.html','<div><div class="row"><div class="col-md-4 col-md-offset-4"><h1 data-translate="reset.finish.title">Reset password</h1><div class="alert alert-danger" data-translate="reset.finish.messages.keymissing" ng-show="vm.keyMissing"><strong>The password reset key is missing.</strong></div><div class="alert alert-warning" ng-hide="vm.success || vm.keyMissing"><p data-translate="reset.finish.messages.info">Choose a new password</p></div><div class="alert alert-danger" ng-show="vm.error"><p data-translate="reset.finish.messages.error">Your password couldn\'t be reset. Remember a password request is only valid for 24 hours.</p></div><div class="alert alert-success" ng-show="vm.success"><p data-translate="reset.finish.messages.success" translate-compile><strong>Your password has been reset.</strong> Please <a class="alert-link" href="" ng-click="vm.login()">sign in</a>.</p></div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div><div ng-hide="vm.keyMissing"><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.finishReset()" show-validation><div class="form-group"><label class="control-label" for="password" data-translate="global.form.newpassword">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.resetAccount.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.resetAccount.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" data-translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your password confirmation is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your password confirmation is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your password confirmation cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="reset.finish.form.button">Reset Password</button></form></div></div></div></div>');
$templateCache.put('app/account/reset/request/reset.request.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1 data-translate="reset.request.title">Reset your password</h1><div class="alert alert-danger" data-translate="reset.request.messages.notfound" ng-show="vm.errorEmailNotExists"><strong>E-Mail address isn\'t registered!</strong> Please check and try again.</div><div class="alert alert-warning" ng-hide="vm.success"><p data-translate="reset.request.messages.info">Enter the e-mail address you used to register.</p></div><div class="alert alert-success" ng-show="vm.success == \'OK\'"><p data-translate="reset.request.messages.success">Check your e-mails for details on how to reset your password.</p></div><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.requestReset()" show-validation><div class="form-group"><label class="control-label" for="email" data-translate="global.form.email">E-mail</label><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.resetAccount.email" ng-minlength="5" ng-maxlength="100" required><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" data-translate="global.messages.validate.email.required">Your e-mail is required.</p><p class="help-block" ng-show="form.email.$error.email" data-translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" data-translate="global.messages.validate.email.minlength">Your e-mail is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" data-translate="global.messages.validate.email.maxlength">Your e-mail cannot be longer than 100 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="reset.request.form.button">Reset</button></form></div></div></div>');}]);})();